import type { TranslationDictionary } from '@eliadmin/core/src/i18n/translation-snapshot-types';

export const GENERATED_TRANSLATIONS = Object.freeze({
  "text1": "Ricerca",
  "text2": "Il vostro ordine",
  "text3": "In attesa del pagamento tramite bonifico bancario",
  "text4": "Ciao",
  "text5": "Per effettuare un ordine",
  "text6": "ci aspettiamo che il pagamento avvenga tramite bonifico bancario.",
  "text7": "Ordine consegnato",
  "text8": "Il vostro ordine è stato consegnato con successo.",
  "text9": "Parametri",
  "text10": "Facebook",
  "text11": "Ordine spedito",
  "text12": "è in arrivo per voi.",
  "text13": "Potete seguire il movimento dettagliato del vostro pacco cliccando sul numero del pacco.",
  "text14": "Numero di tracciamento della spedizione:",
  "text15": "Grazie per l'acquisto",
  "text16": "Registriamo l'ordine con il numero di tracking",
  "text17": "Dettaglio dell'ordine",
  "text18": "Creato:",
  "text19": "Codice",
  "text20": "Prodotto",
  "text21": "Prezzo unitario",
  "text22": "Quantità",
  "text23": "Prezzo totale",
  "text24": "Sconto",
  "text25": "Sconti",
  "text26": "Importo totale",
  "text27": "Dettagli del pagamento",
  "text28": "IBAN",
  "text29": "Istituto finanziario",
  "text30": "Importo",
  "text31": "Simbolo variabile",
  "text32": "Indirizzo di consegna",
  "text33": "Nome",
  "text34": "Cognome",
  "text35": "E-mail",
  "text36": "Telefono",
  "text37": "Nome dell'azienda",
  "text38": "Via",
  "text39": "Città",
  "text40": "CAP",
  "text41": "Stato",
  "text42": "ID",
  "text43": "ID Fiscale",
  "text44": "ID Fiscale",
  "text45": "Indirizzo di fatturazione",
  "text46": "Ordine annullato",
  "text47": "è stato annullato.",
  "text48": "Pagamento ricevuto",
  "text49": "è stato pagato.",
  "text50": "Lo stato degli ordini può essere monitorato anche accedendo all'account utente.",
  "text51": "Accesso al mio account",
  "text52": "Ordine restituito",
  "text53": "è stato restituito",
  "text54": "Rimborso",
  "text55": "Per un ordine",
  "text56": "Il denaro è stato rimborsato.",
  "text57": "Nota",
  "text58": "Costo di spedizione",
  "text59": "Prezzo di pagamento",
  "text60": "Prodotti simili",
  "text61": "Prodotti più richiesti",
  "text62": "Ordine ricevuto",
  "text63": "Ordine",
  "text64": "IVA",
  "text65": "numero",
  "text66": "è in arrivo per voi.",
  "text67": "Registrazione riuscita",
  "text68": "La registrazione è andata a buon fine.",
  "text69": "Password generata:",
  "text70": "Si consiglia di modificare la password dopo l'accesso.",
  "text71": "È possibile accedere al proprio account nella sezione",
  "text72": "Account utente",
  "text73": "o facendo clic sul pulsante di accesso.",
  "text74": "Accesso al mio account",
  "text75": "LA MIA EMAIL:",
  "text76": "LINK AL PRODOTTO PIÙ ECONOMICO:",
  "text77": "LINK AL VOSTRO PRODOTTO:",
  "text78": "Buon compleanno.",
  "text79": "LINK AL PRODOTTO:",
  "text80": "Messaggio:",
  "text81": "Oggetto",
  "text82": "Modulo di contatto",
  "text83": "in segno di fiducia, ti inviamo un buono sconto",
  "text84": "per un importo di",
  "text85": "La validità del coupon è da",
  "text86": "a",
  "text87": "Newsletter",
  "text88": "Cliccare sul pulsante sottostante per confermare l'iscrizione alla newsletter.",
  "text89": "Confermare l'iscrizione alla newsletter",
  "text90": "Confermare le voci",
  "text91": "Abbiamo accettato il vostro reso. Grazie mille. Il denaro sta per arrivare a voi. Il metodo di rimborso dipenderà dal metodo di pagamento scelto nell'ordine.",
  "text92": "Se le informazioni sui prodotti che avete riportato dai vostri account utente sono diverse da quelle dei prodotti restituiti, ci riserviamo il diritto di riaddebitare alla vostra carta di credito l'importo già pagato.",
  "text93": "Si prega di notare che ogni pacco restituito viene elaborato separatamente. Se avete inviato prodotti aggiuntivi in un pacchetto diverso, riceverete una ricevuta separata.",
  "text94": "Prodotti restituiti:",
  "text95": "Fare clic sul pulsante sottostante per reimpostare la password.",
  "text96": "Reimpostare la password",
  "text97": "Il pagamento dell'ordine non era corretto",
  "text98": "È possibile ripetere il pagamento",
  "text99": "Cliccate su questo link per essere reindirizzati al gateway di pagamento.",
  "text100": "Grazie per il vostro ordine",
  "text101": "Domanda",
  "text102": "Richiesta di prodotto:",
  "text103": "Richiesta di restituzione",
  "text104": "Abbiamo ricevuto la sua richiesta di rimborso. Potete iniziare a preparare il vostro pacchetto.",
  "text105": "Vi rimborseremo il denaro non appena avremo ricevuto la merce restituita, ma non oltre 14 giorni.",
  "text106": "Avete ordinato la merce con pagamento anticipato? Se non avete ancora pagato la merce, modificheremo l'importo da pagare per escludere il vostro reso.",
  "text107": "Restituzione:",
  "text108": "Numero d'ordine",
  "text109": "La richiesta di risarcimento è stata annullata",
  "text110": "La richiesta di risarcimento non è stata approvata",
  "text111": "Motivo",
  "text112": "Stiamo elaborando la vostra richiesta di risarcimento",
  "text113": "Rilasciato da",
  "text114": "Pagina 1/1",
  "text115": "Modifica della password",
  "text116": "Fattura",
  "text117": "Fornitore",
  "text118": "Funzionamento",
  "text119": "Acquirente",
  "text120": "Tel.",
  "text121": "Data di emissione",
  "text122": "Data di consegna",
  "text123": "Data di scadenza",
  "text124": "Metodo di pagamento",
  "text125": "Metodo di trasporto",
  "text126": "SWIFT",
  "text127": "Spese di pagamento",
  "text128": "Articolo/Codice",
  "text129": "Prezzo base / sconto",
  "text130": "Aliquota IVA",
  "text131": "Numero",
  "text132": "Totale con IVA",
  "text133": "Prezzo IVA inclusa",
  "text134": "Spese di trasporto",
  "text135": "Ricevuta fiscale per il pagamento ricevuto.",
  "text136": "Totale IVA esclusa",
  "text137": "Totale IVA",
  "text138": "Totale",
  "text139": "Simbolo costante",
  "text140": "Importo da rimborsare",
  "text141": "Nota di credito",
  "text142": "alla fattura",
  "text143": "Bolla di consegna",
  "text144": "Bolla di consegna n.",
  "text145": "Venduto da",
  "text146": "Ricevuto da",
  "text147": "Data",
  "text148": "Dettagli IVA (EUR)",
  "text149": "Aliquota IVA",
  "text150": "Prodotti",
  "text151": "Fattura n.",
  "text152": "Dettagli (EUR)",
  "text153": "Spedizione",
  "text154": "Ordini",
  "text155": "Numero d'ordine",
  "text156": "Cliente",
  "text157": "Indirizzo",
  "text158": "Pagamento",
  "text159": "Fattura anticipata n.",
  "text160": "Casa",
  "text161": "Blog",
  "text162": "Termine di ricerca...",
  "text163": "Carrello della spesa",
  "text164": "Prezzo",
  "text165": "Totale",
  "text166": "Aggiornamento del carrello della spesa",
  "text167": "Buoni sconto",
  "text168": "Inviare l'ordine",
  "text169": "Riepilogo dell'ordine",
  "text170": "Prezzo del prodotto",
  "text171": "Il carrello è vuoto",
  "text172": "Negozio",
  "text173": "Prodotti",
  "text174": "Filtro",
  "text175": "Produttore",
  "text176": "Categoria",
  "text177": "Più economico",
  "text178": "Il più costoso",
  "text179": "Ultime novità",
  "text180": "Il più vecchio",
  "text181": "I più venduti",
  "text182": "Abbonarsi",
  "text183": "Il vostro indirizzo e-mail",
  "text184": "Ricevi le migliori offerte direttamente nella tua casella di posta!",
  "text185": "Inviare a",
  "text186": "Contatto",
  "text187": "Modifica della password",
  "text188": "Avete dimenticato la password?",
  "text189": "Accedi",
  "text190": "Accesso",
  "text191": "Password",
  "text192": "Registro",
  "text193": "Non avete ancora un account?",
  "text194": "Oops... la pagina che state cercando non esiste.",
  "text195": "Produttori",
  "text196": "Vedi altri prodotti",
  "text197": "Il mio account",
  "text198": "Dati personali",
  "text199": "Dettagli dell'azienda",
  "text200": "Azienda",
  "text201": "Risparmiare",
  "text202": "Vecchia password",
  "text203": "Nuova password",
  "text204": "Modifica della password",
  "text205": "Articolo completo",
  "text206": "Il suo ordine è stato accettato, ma purtroppo il pagamento non è andato a buon fine. Per ulteriori informazioni sullo stato del vostro ordine, controllate la vostra e-mail.",
  "text207": "Ordine di pagamento",
  "text208": "Continua gli acquisti",
  "text209": "Potresti essere interessato a",
  "text210": "Acquista",
  "text211": "Ricerca",
  "text212": "Articolo/i",
  "text213": "Ricerca",
  "text214": "Consegna il giorno successivo",
  "text215": "Nella Repubblica Ceca",
  "text216": "Regalo gratuito",
  "text217": "Con ogni ordine",
  "text218": "Garanzia di consegna",
  "text219": "merci non danneggiate",
  "text220": "300 punti di consegna",
  "text221": "in Slovacchia e nella Repubblica Ceca",
  "text222": "Ultimi prodotti",
  "text223": "Prodotti top",
  "text224": "Articoli più importanti",
  "text225": "Prezzo con IVA",
  "text226": "Prezzo senza IVA",
  "text227": "Aggiungi al carrello",
  "text228": "Codice prodotto:",
  "text229": "Condividi",
  "text230": "Categoria:",
  "text231": "Descrizione del prodotto",
  "text232": "Accessori",
  "text233": "Informazioni aggiuntive",
  "text234": "Newsletter a cui siete già iscritti",
  "text235": "Continua gli acquisti",
  "text236": "Vi siete iscritti con successo alla nostra newsletter",
  "text237": "Disponibilità:",
  "text238": "In stock",
  "text239": "Per ordinare",
  "text240": "Chi siamo",
  "text241": "Filtro",
  "text242": "Prodotti",
  "text243": "Ordina per:",
  "text244": "Azzeramento del filtro",
  "text245": "Stato dell'ordine",
  "text246": "Indietro",
  "text247": "Dimensioni:",
  "text248": "Pz",
  "text249": "EUR",
  "text250": "Cambia avatar",
  "text251": "L'accesso è stato effettuato con successo",
  "text252": "Uomo",
  "text253": "Donna",
  "text254": "Altro",
  "text255": "Genere",
  "text256": "Ciao",
  "text257": "I miei ordini",
  "text258": "Esci",
  "text259": "Inserisci il tuo indirizzo e-mail",
  "text260": "Accesso permanente",
  "text261": "Registro",
  "text262": "Registrazione di un nuovo account",
  "text263": "Ripetere la password",
  "text264": "Sono d'accordo con",
  "text265": "termini e condizioni",
  "text266": "Ho già un account e voglio effettuare il login",
  "text267": "Informazioni sui cookies",
  "text268": "Facendo clic sul pulsante Accetto tutto, vengono memorizzati cookie tecnici, analitici e di marketing per consentirci di offrirvi un uso confortevole del sito, di misurare la funzionalità del nostro sito e di indirizzarvi la pubblicità. È possibile regolare facilmente le proprie preferenze facendo clic su Impostazioni dei cookie.",
  "text269": "Sono d'accordo su tutto",
  "text270": "Impostazioni dei cookie",
  "text271": "Salva le impostazioni",
  "text272": "Chiudere",
  "text273": "Cookies",
  "text274": "Descrizione",
  "text275": "Utilizziamo i cookie",
  "text276": "Utilizziamo i cookie per analizzare i dati relativi ai nostri visitatori, per migliorare il nostro sito web, per visualizzare contenuti personalizzati e per offrirvi un'esperienza web eccellente. Utilizzando questo sito web, l'utente acconsente a tale utilizzo.",
  "text277": "Cookie tecnici",
  "text278": "Questi cookie sono necessari per il funzionamento del sito web e non possono essere disattivati. Di solito vengono impostati in risposta a un'azione dell'utente sul sito web, come l'impostazione della sicurezza, il login e la compilazione di moduli. È possibile impostare il browser in modo da bloccare i cookie o inviare notifiche in merito. Tenete presente che alcuni siti non funzionano senza questi file. Questi cookie non memorizzano alcuna informazione che possa essere attribuita a una persona specifica. Questi cookie possono essere impostati da noi o da fornitori terzi di cui utilizziamo i servizi sul sito. Questi cookie non memorizzano alcuna informazione che possa essere attribuita a una persona specifica.",
  "text279": "Le impostazioni dei cookie da questa finestra di dialogo",
  "text280": "Cookie analitici",
  "text281": "Questi cookie sono utilizzati per migliorare il funzionamento del sito web. Ci permettono di riconoscere e tracciare il numero di visitatori e di monitorare il modo in cui i visitatori utilizzano il sito. Ci aiutano a migliorare il funzionamento del sito, ad esempio consentendo agli utenti di trovare facilmente ciò che cercano. Questi cookie non raccolgono informazioni che possano identificare l'utente. Utilizziamo questi strumenti per analizzare e migliorare regolarmente la funzionalità del nostro sito web. Possiamo utilizzare le statistiche raccolte per migliorare l'esperienza dell'utente e rendere la sua visita al Sito più interessante per l'utente stesso.",
  "text282": "Google Analytics - memorizza e conta il numero di pagine viste e il comportamento del sito.",
  "text283": "Google Tag Manager - collegamento delle conversioni",
  "text284": "Incomaker - memorizza e conta le visualizzazioni di pagina e le conversioni",
  "text285": "Cookie di marketing",
  "text286": "Questi vengono utilizzati per tracciare le preferenze di un utente sul sito web allo scopo di indirizzare la pubblicità, ossia di visualizzare messaggi di marketing e pubblicitari (anche su siti di terze parti) che potrebbero essere di interesse per il visitatore del sito web, in linea con tali preferenze. I cookie di marketing utilizzano strumenti di aziende esterne. Questi cookie di marketing saranno utilizzati solo con il vostro consenso.",
  "text287": "Pixel di Facebook - visualizzazione di annunci e trasmissione di informazioni a Facebook",
  "text288": "Caricare",
  "text289": "Scambio di beni",
  "text290": "Rimborsi",
  "text291": "Dettagli del cliente",
  "text292": "Numero di fattura",
  "text293": "Coordinate bancarie",
  "text294": "IBAN",
  "text295": "SWIFT",
  "text296": "Motivo del rimborso",
  "text297": "Selezionare l'elemento dell'elenco che si desidera restituire",
  "text298": "E-shop",
  "text299": "Negozio",
  "text300": "E-shop + Negozio",
  "text301": "Abbiamo ricevuto la sua richiesta di rimborso. Potete iniziare a preparare il vostro pacchetto.",
  "text302": "Vi rimborseremo il denaro immediatamente dopo aver ricevuto la merce restituita, al massimo entro 14 giorni.",
  "text303": "Avete ordinato la merce con pagamento anticipato? Se non avete ancora pagato la merce, modificheremo l'importo da pagare per escludere il vostro reso.",
  "text304": "Restituzione:",
  "text305": "Numero d'ordine:",
  "text306": "Abbiamo accettato il suo reso. Grazie mille. Il denaro sta per arrivare a voi. Il metodo di rimborso dipenderà dal metodo di pagamento scelto nell'ordine.",
  "text307": "Se i dettagli dei prodotti riportati dal vostro account utente differiscono dai prodotti restituiti, ci riserviamo il diritto di ricaricare la vostra carta di credito per l'importo già pagato.",
  "text308": "Si prega di notare che ogni pacco restituito viene elaborato separatamente. Se avete inviato prodotti aggiuntivi in un pacchetto diverso, riceverete una ricevuta separata.",
  "text309": "Prodotti restituiti:",
  "text310": "Nuovo",
  "text311": "Approvato",
  "text312": "Rifiutato",
  "text313": "Annullato",
  "text314": "In corso",
  "text315": "Richiesta di rimborso",
  "text316": "Conferma degli articoli",
  "text317": "La richiesta di risarcimento è stata annullata",
  "text318": "Stiamo elaborando la vostra richiesta di risarcimento",
  "text319": "La richiesta di risarcimento non è stata approvata",
  "text320": "La richiesta non è stata elaborata",
  "text321": "Newsletter",
  "text322": "/scambio-e-restituzione-di-merci",
  "text323": "Cambio e restituzione della merce",
  "text324": "Dettagli dell'azienda",
  "text325": "Dominio del vostro negozio",
  "text326": "Aggiungere un altro dominio",
  "text327": "Altri domini",
  "text328": "Nome della società",
  "text329": "Aggiungere un indirizzo aziendale",
  "text330": "Indirizzo commerciale",
  "text331": "Nome del negozio",
  "text332": "Nome di accesso",
  "text333": "Allegati",
  "text334": "Estratto dal registro delle imprese",
  "text335": "Selezionare l'allegato",
  "text336": "Accetto i termini e le condizioni",
  "text337": "Sottocategorie",
  "text338": "Mostra di più",
  "text339": "Disponibilità",
  "text340": "Prezzo",
  "text341": "Filtrare per",
  "text342": "Il prodotto selezionato è stato aggiunto al carrello.",
  "text343": "Carrello",
  "text344": "Prezzo di pagamento",
  "text345": "Prezzo di spedizione",
  "text346": "Selezionare il metodo di spedizione",
  "text347": "Numero di coupon",
  "text348": "Selezionare il metodo di pagamento",
  "text349": "Gratuito",
  "text350": "Riepilogo dell'ordine",
  "text351": "Prezzo dei beni",
  "text352": "L'ordine è stato spedito",
  "text353": "Il vostro numero d'ordine.",
  "text354": "è stato registrato ed è attualmente in fase di elaborazione. Controllare la posta elettronica",
  "text355": "per ulteriori informazioni sul vostro ordine",
  "text356": "Confermare la password",
  "text357": "Accedi",
  "text358": "Avete un account?",
  "text359": "Dettagli sulla consegna",
  "text360": "Dettagli di contatto",
  "text361": "Acquisto in azienda",
  "text362": "Create un account e godete dei vantaggi di un cliente registrato.",
  "text363": "Accetto i termini e le condizioni.",
  "text364": "Accetto l'informativa sulla privacy.",
  "text365": "L'indirizzo di consegna è diverso da quello di fatturazione",
  "text366": "Dropshipping",
  "text367": "Indirizzo operativo",
  "text368": "Impostazioni dei dati personali",
  "text369": "Modifica dell'indirizzo di consegna",
  "text370": "Proseguire alla cassa",
  "text371": "Iscriviti alla nostra newsletter e ricevi aggiornamenti sulle promozioni",
  "text372": "Articoli da restituire",
  "text373": "Articoli restituiti",
  "text374": "Cosa vorresti restituire?",
  "text375": "Non avete ordinato nulla negli ultimi 30 giorni.",
  "text376": "Confermare i resi dei prodotti",
  "text377": "Annullamento",
  "text378": "il-mio-conto-merce-restituita",
  "text379": "il-mio-conto-ritorna-1",
  "text380": "il-mio-conto-ritorna-2",
  "text381": "il-mio-conto-ritorna-3",
  "text382": "Slovacchia",
  "text383": "Repubblica Ceca",
  "text384": "Ungheria",
  "text385": "Dettagli di accesso",
  "text386": "Per saperne di più",
  "text387": "Nel carrello",
  "text388": "Per recuperare una password dimenticata, inserire il proprio indirizzo e-mail",
  "text389": "Data di nascita",
  "text390": "Utilizzo",
  "text391": "/condizioni generali di business",
  "text392": "/protezione-delle-agenzie-personali",
  "text393": "Data dell'ordine",
  "text394": "Numero d'ordine",
  "text395": "Selezionare il motivo",
  "text396": "La merce non corrisponde alla descrizione",
  "text397": "Ho ricevuto il prodotto sbagliato",
  "text398": "Non mi piace questo articolo",
  "text399": "L'articolo è troppo grande",
  "text400": "L'articolo è danneggiato",
  "text401": "Prodotto arrivato in ritardo",
  "text402": "Il prodotto è troppo piccolo",
  "text403": "Il prodotto è troppo costoso",
  "text404": "Nessun dettaglio",
  "text405": "Ritorno a",
  "text406": "Articoli dell'azienda",
  "text407": "Articoli da restituire all'azienda",
  "text408": "Vi abbiamo inviato un elenco dei prodotti che avete restituito a",
  "text409": "I vostri prodotti sono pronti per essere restituiti",
  "text410": "E poi?",
  "text411": "Preparare il pacchetto",
  "text412": "Ora non resta che inviare il pacchetto",
  "text413": "Recuperate il vostro denaro",
  "text414": "Imballate i prodotti desiderati, includete un'etichetta di restituzione e sul pacco arriverà un indirizzo di restituzione. E sapevate che potete restituire gli articoli contenuti in più pacchi insieme in un unico pacco? È sufficiente imballare le etichette di reso di ogni ordine",
  "text415": "Portate il pacco al centro logistico più vicino che avete selezionato sul modulo",
  "text416": "Vi rimborseremo il denaro immediatamente dopo aver ricevuto la merce restituita, entro e non oltre i 14 giorni successivi. Avete ordinato la merce con pagamento anticipato? Se non avete ancora pagato la merce, modificheremo l'importo da pagare in modo che non includa la vostra restituzione.",
  "text417": "Numero di prodotti",
  "text418": "Ritorno all'azienda",
  "text419": "Stato",
  "text420": "Creato il",
  "text421": "Non ci sono articoli restituiti.",
  "text422": "Si prega di impostare l'IBAN e lo SWIFT nelle impostazioni del conto.",
  "text423": "Non sono state impostate coordinate bancarie",
  "text424": "Acquista di più per",
  "text425": "e avete la spedizione",
  "text426": "LIBERO",
  "text427": "Congratulazioni, avete spedito",
  "text428": "Il vostro messaggio è stato inviato con successo!",
  "text429": "Errore, il messaggio non è stato inviato!",
  "text430": "",
  "text431": "L'e-mail esiste; si prega di utilizzarne una diversa.",
  "text432": "La registrazione è andata a buon fine.",
  "text433": "Codice variante",
  "text434": "il-mio-conto-ritorna-1",
  "text435": "Unità di vendita",
  "text436": "Informativa sulla privacy",
  "text437": "Tag",
  "text438": "Numero civico",
  "text439": "Caricamento",
  "text440": "Selezionare un punto di sottoscrizione",
  "text441": "Selezionare la variante",
  "text442": "Aggiungi ai preferiti",
  "text443": "senza IVA",
  "text444": "Il prezzo è approssimativo",
  "text445": "Nessun risultato",
  "text446": "AGENTI ANTICORROSIVI",
  "text447": "Recensioni",
  "text448": "Servizi aggiuntivi",
  "text449": "Pacchi",
  "text450": "Spedire",
  "text451": "Video",
  "text452": "Descrizione completa",
  "text453": "Siamo spiacenti, abbiamo solo una quantità limitata di questo prodotto in magazzino",
  "text454": "non puoi più aggiungere articoli al carrello.",
  "text455": "OK",
  "text456": "vai al carrello",
  "text457": "",
  "text458": "Il tuo carrello ti sta aspettando",
  "text459": "Non hai completato il tuo ordine durante la tua ultima visita. La merce che hai scelto ti aspetta nel tuo carrello. Non perderlo e completa subito il tuo acquisto.",
  "text460": "Il tuo ordine è stato ricevuto con successo. Controlla la tua casella di posta elettronica.",
  "text461": "Il tuo messaggio è stato inviato con successo!",
  "text462": "L'e-mail è obbligatoria.",
  "text463": "L'indirizzo e-mail inserito non è valido.",
  "text464": "L'e-mail può contenere un massimo di 255 caratteri.",
  "text465": "L'e-mail inserita è già registrata.",
  "text466": "La password è obbligatoria.",
  "text467": "La password deve contenere almeno 6 caratteri.",
  "text468": "Le passwords non corrispondono.",
  "text469": "Il consenso ai termini e condizioni è obbligatorio.",
  "text470": "Controlla il modulo captcha.",
  "text471": "Andare alla guida in linea",
  "text472": "Visualizza gli argomenti delle domande e delle risposte",
  "text473": "Nascondere gli argomenti delle domande e delle risposte",
  "text474": "Vai al blog",
  "text475": "Sala di consulenza",
  "text476": "Chiedete direttamente al nostro farmacista",
  "text477": "Nessuna opzione",
  "text478": "Selezionare le categorie",
  "text479": "per ordini superiori a",
  "text480": "Torna al negozio",
  "text481": "Prezzo / pz. incl. IVA",
  "text482": "Prezzo totale",
  "text483": "Prezzo / pz. senza IVA",
  "text484": "",
  "text485": "Numero di casa",
  "text486": "Profilo",
  "text487": "Cambia dati",
  "text488": "Sicurezza",
  "text489": "Cambia posizione",
  "text490": "Carica di più",
  "text491": "I miei dati",
  "text492": "Segui noi",
  "text493": "Best seller",
  "text494": "Tutti i prodotti",
  "text495": "Non disponibile",
  "text496": "Scegliere una variante",
  "text497": "",
  "text498": "",
  "text499": "",
  "text500": "",
  "text501": "",
  "text502": "Nome completo",
  "text503": "Conferma la nuova password",
  "text504": "Si prega di confermare il proprio accordo con i termini di protezione dei dati personali.",
  "text505": "L'indirizzo e-mail inserito è già iscritto per ricevere notizie.",
  "text506": "Controlla la tua casella di posta elettronica.",
  "text507": "Punto di erogazione",
  "text508": "Chiedi informazioni su un prodotto",
  "text509": "Domanda sulla disponibilità della merce",
  "text510": "Offerta speciale",
  "text511": "Larghezza",
  "text512": "Lunghezza",
  "text513": "Altezza",
  "text514": "Il peso",
  "text515": "Valutato in data",
  "text516": "Preferito",
  "text517": "Ritorna alla pagina principale",
  "text518": "Stato del prodotto",
  "text519": "Nazione",
  "text520": "Dati di consegna e fatturazione",
  "text521": "Hai già fatto acquisti con noi?",
  "text522": "Torna al carrello",
  "text523": "Buoni di sconto",
  "text524": "Aggiungi all'ordine",
  "text525": "Il contenuto del carrello",
  "text526": "Continua a ordinare",
  "text527": "Condividi il prodotto",
  "text528": "Nascondi descrizione",
  "text529": "Descrizione completa",
  "text530": "Si è verificato un errore, riprova tra un attimo.",
  "text531": "Aggiungi ai preferiti",
  "text532": "Rimuovi dai preferiti",
  "text533": "Dettaglio",
  "text534": "Nuova prenotazione",
  "text535": "Prenotazione creata con successo",
  "text536": "Sconto per il pagamento",
  "text537": "Annullamento dell'iscrizione",
  "text538": "Scegliere un termine",
  "text539": "Punto di sottoscrizione",
  "text540": "Scadenza",
  "text541": "Sconto per il cliente",
  "text542": "Riepilogo ordine spedito n.",
  "text543": "Numero d'ordine",
  "text544": "Utente non connesso",
  "text545": "Il coupon è valido",
  "text546": "Il coupon non esiste, è scaduto o le condizioni per l'applicazione del coupon non sono soddisfatte.",
  "text547": "Il coupon non è valido",
  "text548": "Il coupon è stato aggiunto",
  "text549": "Risposta",
  "text550": "Ha risposto alla domanda",
  "text551": "Fai una domanda",
  "text552": "Nome",
  "text553": "Per postare una domanda nella sezione consigli è necessario aver effettuato il login.",
  "text554": "Non abbiamo trovato nessun record corrispondente",
  "text555": "Oggi è il suo giorno del nome",
  "text556": "Avviso",
  "text557": "Dati di accesso errati",
  "text558": "La password originale non corrisponde",
  "text559": "Interesse per il lavoro",
  "text560": "Nuovo richiedente",
  "text561": "Grazie per il vostro ordine, che inizieremo a elaborare non appena sarà stato pagato.",
  "text562": "Pagamento andato a buon fine.",
  "text563": "Il pagamento non è andato a buon fine.",
  "text564": "Autenticazione Captcha fallita.",
  "text565": "Nessun parametro",
  "text566": "Filtro prodotto",
  "text567": "Ho bisogno di un consiglio",
  "text568": "Contatti e assistenza",
  "text569": "Scrivici",
  "text570": "Seguiteci sui social media",
  "text571": "Spedizione e pagamento",
  "text572": "Programma fedeltà",
  "text573": "Si è verificato un errore durante l'iscrizione alla newsletter",
  "text574": "Abbonarsi alle newsletter via e-mail",
  "text575": "Volete essere tra i primi ad essere informati su promozioni e sconti? Inserite il vostro indirizzo e-mail.",
  "text576": "Grazie per esservi iscritti alla nostra newsletter. La conferma dell'iscrizione è stata inviata al vostro indirizzo e-mail.",
  "text577": "Articoli",
  "text578": "Chat online",
  "text579": "Consulenza online",
  "text580": "Consulenza sui prodotti",
  "text581": "Domande frequenti",
  "text582": "Collezione personale",
  "text583": "Notizie",
  "text584": "Promozioni",
  "text585": "Scrivi una recensione",
  "text586": "Recensioni",
  "text587": "Valutazione",
  "text588": "Visualizza altri articoli",
  "text589": "Argomenti",
  "text590": "Cerca articolo",
  "text591": "Leggi l'articolo completo",
  "text592": "Pubblicato da",
  "text593": "Per scrivere una recensione è necessario aver effettuato il login.",
  "text594": "Qualcosa è andato storto",
  "text595": "Riprova",
  "text596": "Nascondi risposta",
  "text597": "Mostra la risposta",
  "text598": "Articoli popolari",
  "text599": "Filtrare le categorie",
  "text600": "Torna alla pagina dei blog",
  "text601": "Trova il lavoro dei tuoi sogni!",
  "text602": "Paese di consegna",
  "text603": "È possibile modificare il paese di consegna nel passaggio precedente.",
  "text604": "Mostra meno",
  "text605": "",
  "text606": "massimo",
  "text607": "Abbiamo selezionato per voi",
  "text608": "Nessuna recensione",
  "text609": "Desidero ricevere e-mail con notizie sulle tendenze attuali, promozioni e coupon di sconto. È possibile annullare l'iscrizione gratuitamente in qualsiasi momento.",
  "text610": "Iscrizione alla newsletter",
  "text611": "Avete bisogno di un consiglio?",
  "text612": "Contattateci:",
  "text613": "Sono d'accordo con",
  "text614": "trattamento dei dati personali",
  "text615": "Rapporto",
  "text616": "Dati aziendali",
  "text617": "Dati sul funzionamento",
  "text618": "Registro commerciale",
  "text619": "Nome della banca",
  "text620": "Se non avete ancora fatto acquisti da noi e non avete un account,",
  "text621": "crearne uno qui",
  "text622": "Ho dimenticato la password",
  "text623": "Avete già un account?",
  "text624": "Effettuare il login.",
  "text625": "Registrando un account, l'utente accetta la nostra",
  "text626": "condizioni di utilizzo.",
  "text627": "Leggi il nostro",
  "text628": "Informativa sulla privacy.",
  "text629": "Sì, desidero ricevere occasionalmente e-mail con offerte speciali. Posso cancellare il mio abbonamento in qualsiasi momento. (Opzionale)",
  "text630": "La password deve contenere almeno 8 caratteri.",
  "text631": "Aggiunto al carrello",
  "text632": "Libero",
  "text633": "Tutti i blog",
  "text634": "Mostra i risultati",
  "text635": "Scrivere una domanda",
  "text636": "Visualizza la risposta di uno specialista",
  "text637": "Non ci sono ancora domande in questa categoria",
  "text638": "Torna alla pagina principale",
  "text639": "ha creato il progetto",
  "text640": "Tutti i diritti riservati",
  "text641": "Modalità di spedizione e di pagamento",
  "text642": "La domanda verrà visualizzata dopo l'approvazione da parte di un amministratore.",
  "text643": "Grazie",
  "text644": "o scrivere a",
  "text645": "Attivare il codice sconto",
  "text646": "Codice coupon",
  "text647": "Riscattare il codice sconto",
  "text648": "La recensione è stata aggiunta",
  "text649": "La password è stata modificata con successo",
  "text650": "Impossibile modificare la password",
  "text651": "Si è verificato un errore di reimpostazione della password",
  "text652": "Avete ricevuto un'e-mail di reimpostazione della password",
  "text653": "Si è verificato un errore durante la registrazione",
  "text654": "La registrazione è avvenuta con successo",
  "text655": "Si è verificato un errore durante l'accesso",
  "text656": "Sei stato registrato",
  "text657": "Si è verificato un errore durante l'invio del modulo di contatto",
  "text658": "Il modulo di contatto è stato inviato con successo",
  "text659": "La domanda è stata inviata con successo",
  "text660": "Si è verificato un errore durante l'invio della domanda",
  "text661": "Si è verificato un errore durante la creazione della recensione",
  "text662": "Prezzo / pz.",
  "text663": "Totale",
  "text664": "Regalo",
  "text665": "Seguici su instagram",
  "text666": "Visualizza instagram",
  "text667": "Il colore è nel formato sbagliato.",
  "text668": "di più...",
  "text669": "Acquista",
  "text670": "Visualizza tutti i prodotti",
  "text671": "Blog",
  "text672": "Nessuna etichetta",
  "text673": "Nessun blog",
  "text674": "Nessuna categoria",
  "text675": "Subtotale",
  "text676": "Avete già fatto acquisti da noi?",
  "text677": "Se avete già fatto acquisti da noi, accedete al vostro account per aggiungere automaticamente i dettagli del vostro ordine e velocizzare il processo di checkout.",
  "text678": "Sono un nuovo cliente",
  "text679": "Dati di fatturazione",
  "text680": "Prodotto danneggiato",
  "text681": "Regalo inappropriato",
  "text682": "Non voglio dichiarare",
  "text683": "Selezionare un motivo",
  "text684": "Corriere",
  "text685": "Prodotti restituiti:",
  "text686": "Annullamento del rimborso",
  "text687": "Confermare la restituzione del prodotto",
  "text688": "Indirizzo dell'azienda",
  "text689": "Dati aziendali",
  "text690": "Orari di apertura",
  "text691": "Verifica la disponibilità",
  "text692": "Prescrizione elettronica",
  "text693": "Prenotazione di prescrizioni elettroniche",
  "text694": "Carta fedeltà",
  "text695": "Voglio un biglietto",
  "text696": "Ho un biglietto",
  "text697": "Numero di nascita",
  "text698": "Il telefono è essenziale per informare sullo stato della prenotazione.",
  "text699": "Abbiamo bisogno del vostro numero di identificazione personale per verificare la vostra prescrizione.",
  "text700": "Invia la prenotazione della ricetta",
  "text701": "Selezionare una città",
  "text702": "Numero della carta fedeltà",
  "text703": "Nome del prodotto",
  "text704": "Inserire il nome del prodotto/numero di codice a barre",
  "text705": "Ricerca per nome o codice a barre - cifre sotto il codice a barre del prodotto",
  "text706": "Prodotto personalizzato",
  "text707": "Scrivere una dedica...",
  "text708": "Selezionare una data di consegna",
  "text709": "Vedi altre sottocategorie",
  "text710": "Nascondere le sottocategorie",
  "text711": "Ho una ricetta cartacea",
  "text712": "Impostate sia l'IBAN che lo SWIFT nelle impostazioni del vostro conto.",
  "text713": "Abbiamo registrato con successo il ritorno",
  "text714": "Ordini restituiti",
  "text715": "Restituzione della merce",
  "text716": "Data di ritorno",
  "text717": "Scaricare",
  "text718": "Fornitori",
  "text719": "Informazioni sul prodotto",
  "text720": "Prezzo del prodotto",
  "text721": "Vai al negozio",
  "text722": "Modifica dello stato di un sinistro",
  "text723": "Può contenere solo un formato con un massimo di 4 numeri prima della virgola e 8 dopo la virgola.",
  "text724": "Dove siamo stati ovunque",
  "text725": "Continua alla pagina principale",
  "text726": "Inserire il numero d'ordine e l'e-mail",
  "text727": "Collegamento",
  "text728": "Posizione del fornitore",
  "text729": "Il numero minimo di caratteri è",
  "text730": "Il numero massimo di caratteri è",
  "text731": "Questo campo non può essere vuoto",
  "text732": "L'indirizzo e-mail deve essere valido",
  "text733": "Il numero di telefono deve essere valido",
  "text734": "Questo campo è obbligatorio",
  "text735": "La data deve essere valida",
  "text736": "L'input deve essere un numero",
  "text737": "L'ingresso deve essere un numero intero",
  "text738": "L'input deve essere un numero decimale",
  "text739": "Le password non corrispondono",
  "text740": "Dovete accettare il GDPR",
  "text741": "È necessario accettare le condizioni di utilizzo",
  "text742": "È necessario selezionare almeno un prodotto",
  "text743": "Inserite i dati della vostra carta di previdenza o il vostro nome",
  "text744": "Prodotti correlati",
  "text745": "Collegato come",
  "text746": "Ricerca",
  "text747": "Parola chiave",
  "text748": "Distanza",
  "text749": "Categoria",
  "text750": "Campi obbligatori",
  "text751": "Contattateci in qualsiasi momento se avete una richiesta speciale o se avete domande.",
  "text752": "Nessun risultato",
  "text753": "I giorni selezionati non sono disponibili",
  "text754": "Modifica da parte di",
  "text755": "Cancellare l'account",
  "text756": "Imprenditorialità",
  "text757": "Nel caso in cui dovessimo contattarvi in merito al vostro ordine.",
  "text758": "Creare un account",
  "text759": "Non ci sono fornitori entro la distanza selezionata",
  "text760": "Selezionare un fornitore",
  "text761": "Selezionare una città",
  "text762": "Inserite l'indirizzo di fatturazione per non doverlo fare ad ogni ordine.",
  "text763": "Per completare il modulo di vendita all'ingrosso è necessario aver effettuato il login.",
  "text764": "All'ingrosso",
  "text765": "Congratulazioni! Siete già registrati come grossisti.",
  "text766": "Tipo di azienda e domini",
  "text767": "Informazioni di contatto",
  "text768": "Dimensione massima del file 2MB",
  "text769": "Dropshipping",
  "text770": "Ordine per lo stock",
  "text771": "Indirizzo di consegna del Dropship",
  "text772": "Dati personali e di contatto",
  "text773": "Indirizzo di consegna",
  "text774": "Il vostro modulo è stato inviato con successo. Vi contatteremo al più presto per le condizioni di vendita all'ingrosso.",
  "text775": "Abilita il recupero della posizione",
  "text776": "È necessario selezionare una data di consegna",
  "text777": "È necessario selezionare un punto di erogazione specifico",
  "text778": "Il prezzo del pacchetto è superiore al valore consentito.",
  "text779": "Il pacchetto comprende",
  "text780": "Il pacchetto non ha un prezzo massimo",
  "text781": "Inserire il codice postale",
  "text782": "Inserisci la città",
  "text783": "Calcolare il prezzo",
  "text784": "Inviare al rifugio",
  "text785": "Marchio",
  "text786": "Domanda per il farmacista",
  "text787": "Ha risposto alla domanda",
  "text788": "Offerte di lavoro",
  "text789": "Consulenza online",
  "text790": "Nascondere gli argomenti delle domande e delle risposte",
  "text791": "Visualizza gli argomenti delle domande e delle risposte",
  "text792": "Per saperne di più",
  "text793": "Visualizza tutte le offerte",
  "text794": "Dettaglio offerta",
  "text795": "Luogo di lavoro",
  "text796": "Salario lordo",
  "text797": "Occupazione",
  "text798": "Recuperato da",
  "text799": "Ulteriori riferimenti",
  "text800": "Chiamateci",
  "text801": "Siamo disponibili",
  "text802": "Informazioni sull'azienda",
  "text803": "Dettagli di contatto",
  "text804": "Documenti d'ordine",
  "text805": "Nessun documento disponibile per questo ordine",
  "text806": "Scegliere un rifugio",
  "text807": "Visualizza i dettagli",
  "text808": "Sono interessato all'implementazione",
  "text809": "z",
  "text810": "offerte",
  "text811": "Da",
  "text812": "lordo",
  "text813": "Sono interessato alla posizione",
  "text814": "Carica il CV",
  "text815": "Invia interesse",
  "text816": "Calcolatrice rateale",
  "text817": "Vedi offerta",
  "text818": "Configuratore",
  "text819": "Tutte le realizzazioni",
  "text820": "Dove trovarci",
  "text821": "Reparto vendite",
  "text822": "Rappresentanti di vendita",
  "text823": "Nota legale",
  "text824": "Vedere i parametri tecnici",
  "text825": "Selezionare il luogo di consegna",
  "text826": "Varianti",
  "text827": "L'onomastico ha",
  "text828": "Scaricare",
  "text829": "Trovare un lavoro",
  "text830": "Categorie più popolari",
  "text831": "Trovate il tipo di lavoro che fa per voi! Il lavoro inizia subito dopo l'acquisto e vengono forniti i requisiti.",
  "text832": "posizioni aperte",
  "text833": "Creare un CV",
  "text834": "Crea il tuo profilo e trova migliaia di posti di lavoro, costruisci la tua carriera e il tuo impiego!\n  occupazione!",
  "text835": "Ultime offerte di lavoro",
  "text836": "Trovate il tipo di lavoro che fa per voi! Il lavoro inizia subito dopo l'acquisto e vengono forniti i requisiti.",
  "text837": "Inviare il CV",
  "text838": "/ mensile",
  "text839": "È necessario scegliere un rifugio",
  "text840": "Rifugi che potete sostenere con noi",
  "text841": "Ho più di 18 anni",
  "text842": "Il contenuto di questo sito non è adatto alle persone",
  "text843": "minori di 18 anni.",
  "text844": "Tutti",
  "text845": "Solo i nuovi",
  "text846": "Utilizzato solo",
  "text847": "Tipo",
  "text848": "Anno",
  "text849": "Modello",
  "text850": "Il mio CV",
  "text851": "Anteprima del CV",
  "text852": "Eliminazione dell'account",
  "text853": "Una volta eliminato l'account, i dati non possono essere recuperati.",
  "text854": "Cancellare l'account",
  "text855": "Impostazioni",
  "text856": "Sono interessato a ricevere offerte di lavoro via e-mail",
  "text857": "Lingua preferita",
  "text858": "Vai a tutte le offerte di lavoro",
  "text859": "Curriculum Vitae",
  "text860": "Passo",
  "text861": "Dati di base",
  "text862": "Fotografia",
  "text863": "Esperienza lavorativa",
  "text864": "Istruzione",
  "text865": "Conoscenza",
  "text866": "Le lingue",
  "text867": "Parti aggiuntive",
  "text868": "Impostazioni finali",
  "text869": "Ricerca per parola chiave, nome dell'azienda",
  "text870": "Comune, distretto, regione",
  "text871": "Recuperato da",
  "text872": "Via e numero civico",
  "text873": "Carica la tua foto",
  "text874": "La foto non è obbligatoria, ma un CV con foto è più personale e attirerà maggiormente l'attenzione del selezionatore.\n  altro.",
  "text875": "Sapevate che un selezionatore impiega in media 7 secondi per scansionare un CV per la prima volta? Quindi, menzionate solo le esperienze rilevanti e descrivetele in punti o brevi paragrafi.",
  "text876": "Titolo della posizione, azienda",
  "text877": "Città o codice postale",
  "text878": "Qual è il suo percorso formativo?",
  "text879": "Fate sapere ai datori di lavoro qual è il vostro percorso formativo",
  "text880": "Aggiungi istruzione",
  "text881": "Offerta di lavoro",
  "text882": "Offerte attive",
  "text883": "Focus",
  "text884": "Collegio",
  "text885": "Scuola secondaria",
  "text886": "Corso o certificato",
  "text887": "Sono interessato a un lavoro",
  "text888": "Le vostre competenze e conoscenze",
  "text889": "Inserite le competenze e le conoscenze di cui disponete e il loro livello.",
  "text890": "Professione",
  "text891": "La lingua parlata",
  "text892": "Indicare il titolo accademico accanto al nome",
  "text893": "Stipendio",
  "text894": "Tipo di impiego",
  "text895": "Rispondere a un'offerta di lavoro",
  "text896": "Informazioni sulla professione",
  "text897": "Sono un lavoratore autonomo",
  "text898": "Accessori opzionali",
  "text899": "CV, lettera di presentazione, dichiarazioni, certificati, altro... (max. 10MB)",
  "text900": "La lingua parlata",
  "text901": "Selezionare la lingua",
  "text902": "Titolo",
  "text903": "Paese",
  "text904": "Selezionare un paese",
  "text905": "Selezionare una regione",
  "text906": "La dimensione massima del file è di 10 MB",
  "text907": "Aggiungi allegato",
  "text908": "Numero di allegati",
  "text909": "Patente di guida",
  "text910": "Quali sono le patenti di guida in vostro possesso?",
  "text911": "Come le piace riempire il suo tempo libero?",
  "text912": "Interessi o hobby",
  "text913": "Descrivete in modo breve e conciso come vi piace trascorrere il vostro tempo libero.",
  "text914": "Il tuo CV è pronto. Aggiungete le seguenti informazioni per aiutarvi nella ricerca di lavoro su pracaslovensko.sk",
  "text915": "Posizione di lavoro",
  "text916": "In quale settore o in quale posizione specifica vorrebbe lavorare?",
  "text917": "Area di lavoro",
  "text918": "Selezionare un'area di lavoro",
  "text919": "Luogo di lavoro",
  "text920": "In quale località sta cercando lavoro?",
  "text921": "Tipo di impiego",
  "text922": "Indicare il tipo di orario di lavoro più adatto alle proprie esigenze",
  "text923": "Data di arrivo",
  "text924": "Indicare la data del possibile arrivo",
  "text925": "Stipendio minimo previsto (lordo)",
  "text926": "Indicate la vostra idea di stipendio minimo (lordo).",
  "text927": "Turni di lavoro preferiti",
  "text928": "Indicare le preferenze per i turni di lavoro",
  "text929": "Svantaggio di salute",
  "text930": "Siete svantaggiati sul lavoro?",
  "text931": "Offerte di lavoro via e-mail?",
  "text932": "Volete che vi inviamo le offerte di lavoro più adatte a voi via e-mail?",
  "text933": "Città/Comune",
  "text934": "Immediatamente",
  "text935": "Per accordo",
  "text936": "Importo da (EUR)",
  "text937": "Sono interessato a un lavoro che preveda anche il fine settimana",
  "text938": "Sono interessato a lavorare anche di notte",
  "text939": "Ho una disabilità legata al lavoro",
  "text940": "41% - 70%",
  "text941": "Oltre il 70%",
  "text942": "Informazioni aggiuntive",
  "text943": "Sono interessato a ricevere offerte di lavoro via e-mail",
  "text944": "Riassunto personale",
  "text945": "Scrivete un breve riassunto di voi stessi in 2-3 frasi.",
  "text946": "Informazioni aggiuntive",
  "text947": "C'è qualcos'altro che volete aggiungere? Scrivetelo qui.",
  "text948": "Inserire i file o spostarsi qui",
  "text949": "PNG, JPG, GIF",
  "text950": "Selezionare il file",
  "text951": "Aggiungere un lavoro",
  "text952": "Lasso di tempo",
  "text953": "Descrizione del lavoro",
  "text954": "Descrivete in modo breve e conciso la vostra mansione.",
  "text955": "Aggiunta di un lavoro",
  "text956": "Titolo del lavoro",
  "text957": "Datore di lavoro",
  "text958": "Città/Comune",
  "text959": "Paesaggio",
  "text960": "Periodo di tempo",
  "text961": "Attualmente lavoro qui",
  "text962": "Dal mese",
  "text963": "Da quando",
  "text964": "Entro un mese",
  "text965": "Entro l'anno",
  "text966": "Descrizione del lavoro",
  "text967": "Descrivete in modo breve e conciso la vostra mansione.",
  "text968": "Collegio",
  "text969": "Facoltà",
  "text970": "Dipartimento",
  "text971": "Scuola secondaria",
  "text972": "Nome del corso",
  "text973": "Descrizione dello studio",
  "text974": "Descrivete in modo breve e conciso i vostri studi",
  "text975": "Principiante completo",
  "text976": "Le basi",
  "text977": "Intermedio",
  "text978": "Avanzato",
  "text979": "Esperto",
  "text980": "Aggiungi lingua",
  "text981": "Aggiungi conoscenza",
  "text982": "Principiante completo (A1)",
  "text983": "Principiante (A2)",
  "text984": "Intermedio (B1)",
  "text985": "Intermedio (B2)",
  "text986": "Avanzato (C1)",
  "text987": "Esperto (C2)",
  "text988": "Aggiunta di una lingua",
  "text989": "Lingua",
  "text990": "Livello linguistico",
  "text991": "Non avete alcuna formazione aggiuntiva",
  "text992": "Oggi",
  "text993": "Corso o certificato",
  "text994": "Questo sito web utilizza i cookie",
  "text995": "Utilizziamo i cookie per personalizzare i contenuti e gli annunci, fornire funzioni di social media e analizzare il traffico. Forniamo inoltre informazioni sull'utilizzo del nostro sito web ai nostri partner di social media, pubblicità e analisi. Questi partner possono combinare le informazioni in questione con altre informazioni che avete fornito loro o che hanno raccolto da voi quando avete utilizzato i loro servizi.",
  "text996": "Abilitare tutto",
  "text997": "Rifiuto",
  "text998": "Personalizzare",
  "text999": "Impostazioni dei cookie",
  "text1000": "Servizi",
  "text1001": "Le opzioni per la privacy",
  "text1002": "In questa sezione è possibile esprimere alcune preferenze relative al trattamento dei propri dati personali. È possibile rivedere e modificare le preferenze espresse in qualsiasi momento, visitando questo pannello tramite il link fornito. Se desiderate negare il vostro consenso alle specifiche attività di trattamento descritte di seguito, selezionate l'interruttore a levetta su off o utilizzate il pulsante \"Rifiuta tutto\" per confermare che desiderate salvare le vostre scelte.",
  "text1003": "Necessario",
  "text1004": "I cookie necessari contribuiscono a creare siti web utilizzabili, consentendo funzioni di base come la navigazione del sito e l'accesso alle aree protette del sito. Il sito web non può funzionare correttamente senza questi cookie.",
  "text1005": "Statistiche e analisi",
  "text1006": "I cookie statistici aiutano i proprietari dei siti web a capire come interagire con i visitatori del sito raccogliendo e riportando informazioni in forma anonima.",
  "text1007": "Tabella biscotti",
  "text1008": "Biscotto",
  "text1009": "Dominio",
  "text1010": "Marketing",
  "text1011": "I cookie di marketing sono utilizzati per tracciare i visitatori del sito web. L'intento è quello di pubblicare annunci pertinenti e coinvolgenti per i singoli utenti e quindi di maggior valore per gli editori e gli inserzionisti terzi.",
  "text1012": "Voglio saperne di più",
  "text1013": "Per informazioni sul trattamento dei dati personali e sui vostri diritti in relazione alla protezione dei dati personali, potete contattarci",
  "text1014": "qui.",
  "text1015": "Funzionale",
  "text1016": "I cookie funzionali aiutano a svolgere determinate funzioni, come la condivisione dei contenuti del sito web sulle piattaforme dei social media, la raccolta di feedback e altre funzioni di terze parti.",
  "text1017": "Salva le impostazioni",
  "text1018": "Non avete un'esperienza lavorativa aggiuntiva",
  "text1019": "Non avete alcuna conoscenza aggiuntiva",
  "text1020": "Tipo di competenze e conoscenze",
  "text1021": "Livello di competenza e conoscenza",
  "text1022": "Aggiunta di conoscenze e competenze",
  "text1023": "Quali lingue parlate?",
  "text1024": "Inserite le lingue che parlate e il loro livello",
  "text1025": "Non sono state aggiunte lingue",
  "text1026": "Torna a",
  "text1027": "Continua",
  "text1028": "Risparmiare",
  "text1029": "Il valore deve essere compreso nell'intervallo",
  "text1030": "Aggiungere l'istruzione",
  "text1031": "Sto ancora studiando",
  "text1032": "Descrizione dello studio",
  "text1033": "Titolo",
  "text1034": "Informazioni tecniche",
  "text1035": "Caratteristiche tecniche",
  "text1036": "Avete una domanda sul prodotto? Inviatecela e saremo lieti di rispondervi.",
  "text1037": "Nome del prodotto",
  "text1038": "Invia la richiesta",
  "text1039": "Acconsento al trattamento dei dati personali",
  "text1040": "La vostra domanda",
  "text1041": "Inviare a",
  "text1042": "La domanda è stata inviata con successo",
  "text1043": "Non è stato possibile inviare la domanda",
  "text1044": "Il tuo nome",
  "text1045": "Reza",
  "text1046": "Questo prodotto è disponibile in diverse varianti",
  "text1047": "Condividi su Facebook",
  "text1048": "Altezza minima",
  "text1049": "Larghezza minima",
  "text1050": "Altezza massima",
  "text1051": "Larghezza massima",
  "text1052": "Design a colori",
  "text1053": "Gennaio",
  "text1054": "Febbraio",
  "text1055": "Marzo",
  "text1056": "Aprile",
  "text1057": "Maggio",
  "text1058": "Giugno",
  "text1059": "Luglio",
  "text1060": "Agosto",
  "text1061": "Settembre",
  "text1062": "Ottobre",
  "text1063": "Novembre",
  "text1064": "Dicembre",
  "text1065": "Durata del corso",
  "text1066": "Numero di capitoli",
  "text1067": "Inserire il nome originale del ricambio",
  "text1068": "Metodo di pagamento",
  "text1069": "Utilizzate il vostro account per tracciare gli ordini e gestire le fatture",
  "text1070": "Solo i nuovi",
  "text1071": "Utilizzato solo",
  "text1072": "Parti usate",
  "text1073": "Articoli del blog, suggerimenti e consigli",
  "text1074": "Rimanere nel giro",
  "text1075": "Per saperne di più sul progetto",
  "text1076": "Dettaglio dell'azione",
  "text1077": "Fino alla fine dell'evento",
  "text1078": "Fino all'inizio dell'evento",
  "text1079": "Lezione precedente",
  "text1080": "Terminato",
  "text1081": "Krokov",
  "text1082": "Tasso di successo del corso",
  "text1083": "Aprire la discussione completa",
  "text1084": "Partecipa alla discussione",
  "text1085": "Durata del corso",
  "text1086": "Elenco dei capitoli",
  "text1087": "Descrizione del corso",
  "text1088": "Domande frequenti",
  "text1089": "Discussione",
  "text1090": "Acquistare un corso",
  "text1091": "Riferimenti",
  "text1092": "Contrassegnare come soddisfatto",
  "text1093": "Iniziare il corso",
  "text1094": "Uscire dal corso",
  "text1095": "Un'altra lezione",
  "text1096": "Congratulazioni",
  "text1097": "Avete completato con successo il corso",
  "text1098": "Senza",
  "text1099": "Il divario",
  "text1100": "Punto",
  "text1101": "Linea",
  "text1102": "Sconosciuto",
  "text1103": "La nuova password deve essere diversa da quella precedente.",
  "text1104": "Conto",
  "text1105": "Creato il",
  "text1106": "Subtotale",
  "text1107": "Il conto cliente non è valido.",
  "text1108": "Conferma della password",
  "text1109": "Formazione acquistata",
  "text1110": "Aperto",
  "text1111": "Allenatore",
  "text1112": "Ti potrebbe interessare",
  "text1113": "Persona privata",
  "text1114": "Aggiungi indirizzo",
  "text1115": "Aggiungi al carrello",
  "text1116": "Torna alle esercitazioni video",
  "text1117": "Offerta di prezzo",
  "text1118": "Invia la richiesta",
  "text1119": "Consegnare completamente",
  "text1120": "Numero d'ordine esterno",
  "text1121": "Esportazione di prodotti completata",
  "text1122": "con IVA",
  "text1123": "Nuovo utente",
  "text1124": "Nuovo ordine",
  "text1125": "Nuovo commento sul compito",
  "text1126": "Modifica dello stato di un'attività",
  "text1127": "Spedizione gratuita",
  "text1128": "Garanzia di prezzo",
  "text1129": "Consultazione gratuita",
  "text1130": "Assistenza clienti",
  "text1131": "Oltre 2000 prodotti in stock",
  "text1132": "Consegna entro 4 giorni",
  "text1133": "Marchio",
  "text1134": "Il mio profilo",
  "text1135": "Inserire il nome della società",
  "text1136": "Inserire il numero di registrazione",
  "text1137": "Inserire l'indirizzo dell'azienda",
  "text1138": "Luogo di realizzazione",
  "text1139": "Sono interessato a",
  "text1140": "Vicino al torrente",
  "text1141": "Quante persone utilizzeranno l'impianto di trattamento?",
  "text1142": "Ho un terreno in pendenza?",
  "text1143": "",
  "text1144": "Progettate il vostro prodotto esattamente secondo i vostri gusti. Con il nostro configuratore è facile e veloce creare il prodotto perfetto.",
  "text1145": "Create la vostra configurazione ideale",
  "text1146": "Vedi tutti nella sottocategoria",
  "text1147": "Guida fotografica",
  "text1148": "Leggi l'articolo",
  "text1149": "Gli articoli più letti",
  "text1150": "Tag",
  "text1151": "State pianificando un progetto?\nVi incontreremo e vi consiglieremo.",
  "text1152": "gratuito",
  "text1153": "Contatto",
  "text1154": "Recuperato da",
  "text1155": "Condividi l'articolo",
  "text1156": "Il link è stato copiato negli appunti",
  "text1157": "Bilancio",
  "text1158": "Non è stato possibile utilizzare i punti fedeltà",
  "text1159": "I vostri punti fedeltà",
  "text1160": "Ogni fedeltà ha un valore",
  "text1161": "per ottenere uno sconto totale",
  "text1162": "sul vostro acquisto.",
  "text1163": "Non avete punti fedeltà",
  "text1164": "Riscattare i punti fedeltà",
  "text1165": "Numero di punti da applicare",
  "text1166": "Numero di punti fedeltà riscattati",
  "text1167": "Sconto applicato",
  "text1168": "Il numero massimo di punti che possono essere riscattati per ogni ordine è di",
  "text1169": "Sede centrale",
  "text1170": "Per saperne di più su questo servizio",
  "text1171": "Contattateci",
  "text1172": "Ufficio",
  "text1173": "Sede centrale dell'azienda",
  "text1174": "Continua",
  "text1175": "Processo e procedura di implementazione",
  "text1176": "Anteprima delle schermate dell'e-shop universale",
  "text1177": "L'orario selezionato non può essere prenotato",
  "text1178": "Opzione selezionata",
  "text1179": "Camere",
  "text1180": "Area",
  "text1181": "Disegno di mobili",
  "text1182": "Elenco degli elementi di arredo",
  "text1183": "Nome e cognome del cliente",
  "text1184": "Nome dello stato del reclamo",
  "text1185": "Nome della persona che gestirà la prenotazione",
  "text1186": "Prenotato per il giorno",
  "text1187": "Se avete già un account con noi, vi invitiamo a",
  "text1188": "Nome della società",
  "text1189": "Indirizzo della sede legale della società",
  "text1190": "Selezionare un paese",
  "text1191": "Le schede assegnate non appartengono a questa sezione",
  "text1192": "Orizzontale",
  "text1193": "In verticale",
  "text1194": "Interno",
  "text1195": "All'aperto",
  "text1196": "Lavoro, occupazione e opportunità di carriera",
  "text1197": "Posizioni popolari",
  "text1198": "Aggiornamento del carrello",
  "text1199": "Modifica articolo",
  "text1200": "Numero di contratto",
  "text1201": "Servizio post garanzia",
  "text1202": "Modulo di accesso",
  "text1203": "Nome di accesso (e-mail)",
  "text1204": "Accedi",
  "text1205": "Password errata",
  "text1206": "Inserite la password del prodotto virtuale che avete ricevuto dopo aver pagato l'ordine.",
  "text1207": "La password si trova sul vostro indirizzo e-mail.",
  "text1208": "L'articolo nel carrello è stato modificato.",
  "text1209": "La chiave API non è corretta",
  "text1210": "Firma del contratto e pagamento della fattura",
  "text1211": "Dettagli di contatto e specifiche di lavoro",
  "text1212": "Controllo dei dati e degli accessi",
  "text1213": "Design grafico",
  "text1214": "Firma del Protocollo di Accettazione - Progettazione",
  "text1215": "Installazione del sistema sul server di dominio",
  "text1216": "Implementazione visiva e collegamento al sistema",
  "text1217": "Protocollo di accettazione - Implementazione del progetto e connessione al sistema",
  "text1218": "Contenuto del progetto",
  "text1219": "Migrazione alla produzione",
  "text1220": "Conferma del progetto finale",
  "text1221": "Il contratto d'opera non è stato firmato.",
  "text1222": "La fattura non è stata pagata.",
  "text1223": "Il contratto è stato firmato con successo.",
  "text1224": "La fattura è stata pagata.",
  "text1225": "Download",
  "text1226": "Al negozio",
  "text1227": "Scarica il documento",
  "text1228": "Le mie fatture",
  "text1229": "Documento",
  "text1230": "Importo fatturato",
  "text1231": "Importo pagato",
  "text1232": "Rimane da pagare",
  "text1233": "Valuta",
  "text1234": "Data di emissione",
  "text1235": "Approvato da",
  "text1236": "Equipaggiato dal cliente",
  "text1237": "Tipo di documento",
  "text1238": "Data della cessione imponibile",
  "text1239": "La mia richiesta",
  "text1240": "Inserite il vostro indirizzo e-mail attraverso il quale comunicheremo",
  "text1241": "Data di adozione",
  "text1242": "Per saperne di più",
  "text1243": "Sono interessato",
  "text1244": "Isolamento",
  "text1245": "Per utilizzo",
  "text1246": "Secondo il materiale",
  "text1247": "Tutti i riferimenti",
  "text1248": "Progetti selezionati",
  "text1249": "Siete interessati a realizzare un progetto o avete domande? Contattateci",
  "text1250": "Nome e cognome",
  "text1251": "Progetto sostenuto dall'Unione Europea",
  "text1252": "Informativa sulla privacy",
  "text1253": "Panoramica del prodotto",
  "text1254": "Visualizza il prodotto",
  "text1255": "Dati tecnici",
  "text1256": "Consultare",
  "text1257": "Numero di conto",
  "text1258": "Numero di telefono",
  "text1259": "Nella nostra comunicazione con il cliente, preferiamo comunicare attraverso il gruppo di progetto sull'applicazione \"Whatsapp\". Inserite il numero attraverso il quale vi aggiungeremo al gruppo di progetto.",
  "text1260": "Numero di telefono Whatsapp (+421 ... ...)",
  "text1261": "Whatsapp",
  "text1262": "Specifiche di lavoro",
  "text1263": "Tipo di lavoro (per accordo e contratto)",
  "text1264": "Eshop",
  "text1265": "Sito web di presentazione",
  "text1266": "Applicazione web",
  "text1267": "Applicazione mobile",
  "text1268": "Sistema CRM",
  "text1269": "Campagne PPC (Google, Facebook)",
  "text1270": "Ottimizzazione SEO",
  "text1271": "Tipo di design",
  "text1272": "Design dell'e-shop - Eliadmin universal",
  "text1273": "Design di e-shop - design su misura",
  "text1274": "Web design / progettazione di applicazioni / progettazione di sistemi",
  "text1275": "Codice colore preferito (in formato HEX)",
  "text1276": "È possibile mescolarlo a questo link.",
  "text1277": "Documenti grafici e di contenuto",
  "text1278": "Documenti grafici",
  "text1279": "Ho (ad es. manuale di design, logo, banner...)",
  "text1280": "Non ho",
  "text1281": "Contenuti di sfondo per il sito web (descrizioni, nomi di categorie, foto, ecc.)",
  "text1282": "Allegare file di supporto (manuale di progettazione, logo, banner, ...)",
  "text1283": "Per il logo vettoriale utilizzare il formato vettoriale svg, ai o pdf.",
  "text1284": "Carica fino a 10 file supportati. Dimensione massima 100 MB/file.",
  "text1285": "TROVA UN FILE",
  "text1286": "Dominio e hosting",
  "text1287": "Ho acquistato",
  "text1288": "Nome di dominio (www.vasadomena.sk)",
  "text1289": "Nome del dominio",
  "text1290": "Nome del fornitore del dominio",
  "text1291": "Nome del fornitore",
  "text1292": "Il nome di accesso",
  "text1293": "La password di accesso",
  "text1294": "Nota necessaria per l'installazione del sistema (velocizzerà il lavoro e l'effettiva consegna del prodotto, se non ne siete in possesso possiamo provvedere noi)",
  "text1295": "Modulo di prenotazione",
  "text1296": "Scelta del servizio",
  "text1297": "Scegliere un barbiere",
  "text1298": "Selezionare il termine",
  "text1299": "Inserite il vostro contatto",
  "text1300": "Date libere attuali",
  "text1301": "Indeciso",
  "text1302": "Lunedì",
  "text1303": "Martedì",
  "text1304": "Mercoledì",
  "text1305": "Giovedì",
  "text1306": "Venerdì",
  "text1307": "Sabato",
  "text1308": "Domenica",
  "text1309": "La settimana",
  "text1310": "Nessuna data disponibile",
  "text1311": "Sintesi",
  "text1312": "Nome del barbiere",
  "text1313": "Servizio",
  "text1314": "Durata",
  "text1315": "minuti",
  "text1316": "Invia la prenotazione",
  "text1317": "La prenotazione è andata a buon fine",
  "text1318": "È necessario scegliere la data",
  "text1319": "Non è stato possibile creare la prenotazione. Si prega di verificare che il modulo sia stato compilato correttamente e di provare a creare nuovamente la prenotazione.",
  "text1320": "C'è stato un errore inaspettato.",
  "text1321": "Più informazioni",
  "text1322": "Vedi altri progetti",
  "text1323": "Dettaglio del progetto",
  "text1324": "Contattateci se siete interessati\nper i professionisti del settore!",
  "text1325": "Progetti",
  "text1326": "Visualizza i progetti",
  "text1327": "Nome del progetto",
  "text1328": "Anno di implementazione",
  "text1329": "Posizione",
  "text1330": "Lettera di riferimento",
  "text1331": "Dati aziendali",
  "text1332": "Banca",
  "text1333": "Chiamata",
  "text1334": "Inserire il token",
  "text1335": "Prenotazione",
  "text1336": "Vai alla categoria",
  "text1337": "Navigare",
  "text1338": "Rimanete aggiornati iscrivendovi alla nostra newsletter!",
  "text1339": "Inserendo il vostro indirizzo e-mail, confermate il vostro consenso al trattamento dei dati personali e vi iscrivete alla newsletter di Spaceplan.",
  "text1340": "Prenota ora",
  "text1341": "Ho una carta fedeltà",
  "text1342": "Errore durante la registrazione di una prenotazione",
  "text1343": "Prenota i prodotti selezionati",
  "text1344": "Per saperne di più sulla nostra azienda",
  "text1345": "I nostri servizi",
  "text1346": "Connettiti con noi",
  "text1347": "L'iscrizione alla newsletter è stata annullata con successo",
  "text1348": "Creare un nuovo",
  "text1349": "Annullare e scartare",
  "text1350": "Volete annullare la creazione del CV? Tutti i dati andranno persi.",
  "text1351": "Lascia il tuo CV",
  "text1352": "Continua a creare",
  "text1353": "Errore nella selezione degli attributi.",
  "text1354": "Contattare entro e non oltre",
  "text1355": "Calcolo del prezzo online",
  "text1356": "Selezionate i prodotti che vi interessano per la determinazione dei prezzi:",
  "text1357": "Visualizza preventivo",
  "text1358": "Prodotti selezionati per il calcolo:",
  "text1359": "Aggiungi prodotto",
  "text1360": "Per saperne di più",
  "text1361": "Sono interessato al prodotto",
  "text1362": "Sei interessato a questo prodotto? Compilate il modulo e vi contatteremo al più presto per un preventivo.",
  "text1363": "È necessario selezionare il prodotto nel passaggio precedente",
  "text1364": "Senza configurazione",
  "text1365": "Compilate il modulo allegato e vi risponderemo al più presto. Anche in questa fase si tratta comunque di un preventivo non vincolante per voi.",
  "text1366": "Progetto",
  "text1367": "Contattare entro e non oltre",
  "text1368": "Inviare una richiesta non vincolante per un'offerta individuale",
  "text1369": "Scarica il preventivo",
  "text1370": "Sfogliare",
  "text1371": "Questo prodotto non ha impostazioni.",
  "text1372": "La richiesta non vincolante per un'offerta individuale è stata inviata con successo",
  "text1373": "Direttore generale",
  "text1374": "Commercio e servizi",
  "text1375": "Avete una domanda? Scriveteci",
  "text1376": "Se avete una domanda e volete mettervi in contatto con noi, provate a chiamarci o a mandarci un'e-mail, oppure compilate il modulo di contatto.",
  "text1377": "Visualizza il progetto",
  "text1378": "Siete interessati a prodotti e servizi?",
  "text1379": "Designer",
  "text1380": "Applica il filtro",
  "text1381": "Non avete prodotti preferiti",
  "text1382": "Cancellare la lista dei desideri",
  "text1383": "Volete davvero cancellare la vostra lista dei desideri?",
  "text1384": "Sì, eliminare",
  "text1385": "No, non eliminare",
  "text1386": "Numero di telefono non valido",
  "text1387": "Prefisso telefonico non valido",
  "text1388": "Tutte le proprietà",
  "text1389": "Vendite",
  "text1390": "Affitto",
  "text1391": "Acquista",
  "text1392": "Visualizza l'offerta",
  "text1393": "Artisti",
  "text1394": "Invia ordine con obbligo di pagamento",
  "text1395": "Voglio vendere",
  "text1396": "Voglio comprare",
  "text1397": "Voglio noleggiare",
  "text1398": "Nessun luogo di consegna disponibile",
  "text1399": "Attrezzatura",
  "text1400": "Torna al settore immobiliare",
  "text1401": "Visualizza tutte le foto",
  "text1402": "Abbiamo notato che hai aggiunto prodotti ai tuoi preferiti quando non eri connesso. Desidera aggiungere prodotti ai suoi preferiti?",
  "text1403": "Aggiungi",
  "text1404": "Non accettare",
  "text1405": "Il cliente non può essere assegnato.",
  "text1406": "Ricerca di un prodotto",
  "text1407": "Posizione",
  "text1408": "Posizione della proprietà",
  "text1409": "Tipo di proprietà",
  "text1410": "Selezionare",
  "text1411": "Inserire la parola chiave",
  "text1412": "Selezionare una fascia di prezzo",
  "text1413": "Immobili",
  "text1414": "Bilanci",
  "text1415": "Sede centrale dell'azienda",
  "text1416": "Sono interessato a",
  "text1417": "Sì",
  "text1418": "Solo edifici nuovi",
  "text1419": "Nessun immobile",
  "text1420": "immobili in offerta",
  "text1421": "Ordina per",
  "text1422": "Voglio vendere",
  "text1423": "Proprietà",
  "text1424": "Immobili",
  "text1425": "proprietà in offerta",
  "text1426": "proprietà in offerta",
  "text1427": "Da",
  "text1428": "Contatto",
  "text1429": "Scegliere il tipo di conto che si desidera creare con noi",
  "text1430": "Utente",
  "text1431": "Studente",
  "text1432": "Azienda",
  "text1433": "Scuola",
  "text1434": "sito web aziendale",
  "text1435": "Indirizzo della sede legale della società",
  "text1436": "Registrazione della società",
  "text1437": "Se avete già un account presso di noi, vi preghiamo di",
  "text1438": "accedere.",
  "text1439": "L'attività dell'azienda è diversa da quella della sede centrale.",
  "text1440": "Dati di contatto della persona responsabile",
  "text1441": "La password deve contenere almeno 8 caratteri.",
  "text1442": "allo scopo di creare un account e di contattare l'utente.",
  "text1443": "Tutti i progetti",
  "text1444": "Nuovo",
  "text1445": "Per saperne di più sul prodotto",
  "text1446": "Acquista il prodotto",
  "text1447": "Allegati da scaricare",
  "text1448": "Prezzo totale senza IVA",
  "text1449": "Prezzo al pezzo senza IVA",
  "text1450": "Prezzo dei beni senza IVA",
  "text1451": "Totale IVA esclusa",
  "text1452": "Anteprima di configurazione",
  "text1453": "Espandi tutto",
  "text1454": "Configurazione del prodotto",
  "text1455": "Finiture di superficie",
  "text1456": "Trattamento superficiale del dorso",
  "text1457": "Design della porta",
  "text1458": "Bordi",
  "text1459": "Maniglie",
  "text1460": "Cerniere",
  "text1461": "Ornamenti",
  "text1462": "Dimensioni",
  "text1463": "Dati aggiuntivi",
  "text1464": "Inserire il numero di pezzi",
  "text1465": "Numero di pezzi",
  "text1466": "Configurazione pulita",
  "text1467": "Chiudere il configuratore",
  "text1468": "Configuratore",
  "text1469": "Anteprima",
  "text1470": "Configurare",
  "text1471": "Configurazione non valida",
  "text1472": "Credo sia giunto il momento",
  "text1473": "Impostare il numero di pezzi",
  "text1474": "Per aggiungere al carrello è necessario impostare il numero dei pezzi",
  "text1475": "I miei indirizzi",
  "text1476": "Registrazione dell'utente",
  "text1477": "Registrazione degli studenti",
  "text1478": "Iscrizione alla scuola",
  "text1479": "Nome della scuola",
  "text1480": "sito web della scuola",
  "text1481": "Indirizzo della scuola",
  "text1482": "Campi di studio della scuola",
  "text1483": "Email di un dipendente scolastico",
  "text1484": "Email ufficiale della scuola",
  "text1485": "Aggiungi reparto",
  "text1486": "Compilare il campo",
  "text1487": "La configurazione API per Google Analytics non è stata compilata.",
  "text1488": "Generazione di esportazioni avviata",
  "text1489": "Generazione dell'esportazione completata",
  "text1490": "Cerchi un lavoro? Compila il modulo di contatto",
  "text1491": "Non avete trovato un'offerta tra quelle attualmente disponibili? Nessun problema, compilate il modulo di contatto, caricate il vostro CV e vi contatteremo in caso di offerte di lavoro.",
  "text1492": "Carriera",
  "text1493": "Descrivi brevemente la posizione a cui saresti interessato...",
  "text1494": "Contatti importanti",
  "text1495": "Offerte popolari",
  "text1496": "Area di attività",
  "text1497": "Dimensione dell'impresa",
  "text1498": "Fatti interessanti sull'azienda",
  "text1499": "Descrizione dell'azienda",
  "text1500": "Panoramica delle offerte",
  "text1501": "Descrizione della scuola",
  "text1502": "Panoramica dei campi di studio",
  "text1503": "Data dell'esame di ammissione",
  "text1504": "Giornata di apertura",
  "text1505": "Cooperazione / Pratica professionale",
  "text1506": "Non c'è alcuna registrazione.",
  "text1507": "Corsi",
  "text1508": "Modifica profilo",
  "text1509": "Esperienza lavorativa precedente",
  "text1510": "Istruzione e qualifiche",
  "text1511": "Competenze personali",
  "text1512": "Altre competenze",
  "text1513": "Nazionalità",
  "text1514": "Luogo di lavoro",
  "text1515": "Che scuola stai frequentando?",
  "text1516": "Che tipo di lavoro sta cercando?",
  "text1517": "Non compilato",
  "text1518": "Profilo aziendale",
  "text1519": "Rimuovi tutto",
  "text1520": "Pubblicità",
  "text1521": "Profilo della scuola",
  "text1522": "Aziende ricercate",
  "text1523": "Visualizza il profilo",
  "text1524": "Offerte di lavoro in",
  "text1525": "Pulire il filtro",
  "text1526": "Informazioni sull'offerta di lavoro",
  "text1527": "Stipendio",
  "text1528": "Dipartimento",
  "text1529": "Posizione",
  "text1530": "Numero di posti vacanti",
  "text1531": "Validità dell'offerta di lavoro",
  "text1532": "Competenze richieste",
  "text1533": "Altre informazioni",
  "text1534": "Creare un profilo",
  "text1535": "Esperienza lavorativa precedente",
  "text1536": "Istruzione e qualifiche",
  "text1537": "Salvare e riprendere in seguito",
  "text1538": "Selezionare il genere",
  "text1539": "Qual è il suo campo?",
  "text1540": "Dati aziendali di base",
  "text1541": "Logo",
  "text1542": "Fatti interessanti sull'azienda",
  "text1543": "Slogan aziendale",
  "text1544": "Descrivete brevemente la vostra azienda e le sue attività...",
  "text1545": "Scrivi qui un fatto interessante sulla tua azienda...",
  "text1546": "Scrivete il vostro slogan aziendale...",
  "text1547": "Dati di contatto dell'azienda",
  "text1548": "Offrite stage agli studenti?",
  "text1549": "Siete favorevoli alla collaborazione con le scuole?",
  "text1550": "Sì",
  "text1551": "No",
  "text1552": "Collegamento a Facebook",
  "text1553": "Link Instagram",
  "text1554": "Collegamento a Linkedin",
  "text1555": "Area di attività",
  "text1556": "Dimensione dell'azienda",
  "text1557": "Selezionare le dimensioni dell'azienda",
  "text1558": "Elenco dei riferimenti",
  "text1559": "Profilo della scuola",
  "text1560": "Dati scolastici di base",
  "text1561": "Progetti scolastici",
  "text1562": "L'indirizzo è nel formato sbagliato",
  "text1563": "La creazione di un profilo aziendale sarà il vostro biglietto da visita.",
  "text1564": "Campi di studio della scuola",
  "text1565": "Scuole",
  "text1566": "Aziende",
  "text1567": "Provate a effettuare una ricerca efficace dei candidati",
  "text1568": "Jobiis Matching vi consiglierà un candidato adatto.",
  "text1569": "Aggiungi offerta",
  "text1570": "Dati di contatto della scuola",
  "text1571": "Campi di studio della scuola",
  "text1572": "Breve descrizione della scuola",
  "text1573": "Fatti interessanti sulla scuola",
  "text1574": "Descrivi brevemente la tua scuola...",
  "text1575": "Pubblica la tua offerta di lavoro e trova il candidato giusto",
  "text1576": "Utilizzate il nostro portale per pubblicare un'offerta di lavoro e trovare in breve tempo il candidato che soddisfa i vostri criteri di lavoro.",
  "text1577": "Mettetevi in contatto con le aziende e trovate un partner per un apprendistato o uno stage per i vostri studenti.",
  "text1578": "Jobiis vi consentirà di accedere facilmente alle opportunità di esperienza lavorativa o di stage per i vostri studenti.",
  "text1579": "Sareste interessati a organizzare una conferenza con un esperto nella vostra scuola?",
  "text1580": "Possiamo aiutarvi a organizzare gratuitamente una conferenza con un esperto del vostro settore!",
  "text1581": "Trova la tua corrispondenza.",
  "text1582": "Aggiungi reparto",
  "text1583": "Ordine",
  "text1584": "Carica il logo",
  "text1585": "Cooperazione scolastica",
  "text1586": "Progetti in cui la scuola è coinvolta",
  "text1587": "Data delle porte aperte",
  "text1588": "Data dell'esame di ammissione",
  "text1589": "Selezionare la data",
  "text1590": "Selezionare il tipo di iscrizione",
  "text1591": "Se desiderate ordinare da noi in un altro paese, scriveteci a",
  "text1592": "e noi elaboreremo il vostro ordine individualmente.",
  "text1593": "Aggiungere un progetto",
  "text1594": "Aggiungere la cooperazione",
  "text1595": "Descrizione dell'azienda",
  "text1596": "Il vostro settore di attività",
  "text1597": "Reti sociali",
  "text1598": "In quale circolo vuole lavorare",
  "text1599": "Qual è il suo campo?",
  "text1600": "Che tipo di lavoro sta cercando?",
  "text1601": "Stipendio previsto in € (al mese)",
  "text1602": "Inizio immediato",
  "text1603": "Tempi di lavoro",
  "text1604": "Titolo della posizione",
  "text1605": "Persiste ancora",
  "text1606": "Aggiungi altro",
  "text1607": "Titolo Qualifica",
  "text1608": "Organizzazione educativa",
  "text1609": "Educazione permanente",
  "text1610": "sito web dell'organizzazione",
  "text1611": "Cancellare",
  "text1612": "Competenze linguistiche",
  "text1613": "Lingua madre",
  "text1614": "Altre lingue",
  "text1615": "Competenze digitali",
  "text1616": "Quali competenze digitali avete?",
  "text1617": "Quale categoria di licenza possiede?",
  "text1618": "Tipo di lavoro",
  "text1619": "Descrizione del lavoro",
  "text1620": "Posizione adatta per",
  "text1621": "Soglia salariale più bassa in €",
  "text1622": "Limite massimo di stipendio in €",
  "text1623": "Industria",
  "text1624": "Benefici per i dipendenti",
  "text1625": "Tempo di lavoro",
  "text1626": "Età minima richiesta",
  "text1627": "Istruzione completata",
  "text1628": "Formazione richiesta nel settore",
  "text1629": "Competenze linguistiche",
  "text1630": "È richiesta un'esperienza precedente",
  "text1631": "Qualifiche necessarie",
  "text1632": "Prerequisiti di personalità",
  "text1633": "Informazioni per i richiedenti",
  "text1634": "Diploma",
  "text1635": "Scegliere il tipo di lavoro",
  "text1636": "Quale scuola stai studiando?",
  "text1637": "Scegliere un orario di lavoro comodo",
  "text1638": "Aggiungere un'abilità",
  "text1639": "Selezionare i dipartimenti",
  "text1640": "Scegliere il tipo di lavoro",
  "text1641": "Opere creative",
  "text1642": "Conferenze e seminari",
  "text1643": "Hobby e interessi",
  "text1644": "Onorificenze e riconoscimenti",
  "text1645": "Reti e appartenenze",
  "text1646": "Progetti",
  "text1647": "Pubblicazioni",
  "text1648": "Riferimenti",
  "text1649": "Attività di volontariato",
  "text1650": "Selezionare un tipo di abilità",
  "text1651": "Livello di competenza",
  "text1652": "Nome dell'opera creativa",
  "text1653": "Descrizione dell'opera creativa",
  "text1654": "Caricare il file",
  "text1655": "Nome della conferenza",
  "text1656": "Link al seminario/conferenza",
  "text1657": "Descrizione del seminario/conferenza",
  "text1658": "Nome dell'hobby/interesse",
  "text1659": "Descrizione degli hobby/interessi",
  "text1660": "Nome del premio/premio",
  "text1661": "Descrizione della distinzione/premio",
  "text1662": "Istituzione trasferente",
  "text1663": "Data di consegna",
  "text1664": "Nome dell'associazione",
  "text1665": "Descrizione dell'adesione",
  "text1666": "Nome del progetto",
  "text1667": "Descrizione del progetto",
  "text1668": "Titolo della pubblicazione",
  "text1669": "Data di pubblicazione",
  "text1670": "Descrizione della pubblicazione",
  "text1671": "Nome del riferimento",
  "text1672": "Caricare il foglio di riferimento",
  "text1673": "Posizione (referendum)",
  "text1674": "Email (referendum)",
  "text1675": "Numero di telefono (referendum)",
  "text1676": "Posizione",
  "text1677": "Nome dell'attività di volontariato",
  "text1678": "Descrizione dell'attività di volontariato",
  "text1679": "Link al file/video",
  "text1680": "Altro",
  "text1681": "Non hai competenze aggiunte",
  "text1682": "Il vostro profilo è stato aggiornato con successo",
  "text1683": "Caricare l'immagine del profilo",
  "text1684": "Aggiungere un annuncio",
  "text1685": "Creare un annuncio",
  "text1686": "Tipo di salario",
  "text1687": "Posizione",
  "text1688": "I miei messaggi",
  "text1689": "Token errato, riprovare",
  "text1690": "Ricerca per nome dell'offerta, settore, località",
  "text1691": "Oggi è",
  "text1692": "Contatti",
  "text1693": "Intermezzo",
  "text1694": "Come selezionare una sessione attiva",
  "text1695": "Il documento scaricabile e la password di accesso saranno disponibili solo dopo la conferma del pagamento.",
  "text1696": "Reimpostare la password",
  "text1697": "Mostra i dettagli dell'implementazione",
  "text1698": "Implementazione",
  "text1699": "Luogo",
  "text1700": "Tutte le visualizzazioni di realizzazione",
  "text1701": "Torna a tutte le realizzazioni",
  "text1702": "Dettaglio del prodotto",
  "text1703": "Nessun utente",
  "text1704": "Cerca utenti",
  "text1705": "A",
  "text1706": "Modulo di contatto dal web",
  "text1707": "Registrazione degli studenti",
  "text1708": "Vai al negozio",
  "text1709": "Se desideri essere informato sulle ultime novità, date di completamento e opzioni, iscriviti alla nostra newsletter e ricevi le ultime informazioni direttamente nella tua casella di posta.",
  "text1710": "Lun - Sab: 8:00 - 19:00",
  "text1711": "Ti risponderemo entro 24 ore. durante l'orario di lavoro.",
  "text1712": "Negozio di campioni",
  "text1713": "Un incontro personale deve essere organizzato in anticipo.",
  "text1714": "Compila il modulo e risponderemo alla tua domanda il prima possibile.",
  "text1715": "Mostra altro",
  "text1716": "Ordinamento",
  "text1717": "Pratica per gli studenti",
  "text1718": "Cooperazione con le scuole",
  "text1719": "Età",
  "text1720": "Elimina chat",
  "text1721": "Nessun messaggio",
  "text1722": "Stiamo preparando questo prodotto per te",
  "text1723": "Indirizzo aziendale",
  "text1724": "Persona da contattare",
  "text1725": "indirizzo www",
  "text1726": "Titolo prima del nome",
  "text1727": "Caratteristiche dell'azienda",
  "text1728": "Seleziona un'area",
  "text1729": "Termina l'offerta",
  "text1730": "Conoscenza delle lingue richiesta",
  "text1731": "Istruzione richiesta",
  "text1732": "Esperienza lavorativa richiesta",
  "text1733": "Tipo di offerta di lavoro",
  "text1734": "Il mio account",
  "text1735": "La mia biografia",
  "text1736": "Le mie offerte di lavoro",
  "text1737": "I miei corsi",
  "text1738": "La mia azienda",
  "text1739": "Biografie",
  "text1740": "Curriculum e certificati",
  "text1741": "Foto e video",
  "text1742": "Competenze e conoscenze",
  "text1743": "Categorie di industrie",
  "text1744": "Carica il tuo curriculum per il download da parte del datore di lavoro.",
  "text1745": "Certificato",
  "text1746": "Carica i certificati che hai a disposizione.",
  "text1747": "Lettera di motivazione",
  "text1748": "Carica lettera di motivazione.",
  "text1749": "Una foto non è obbligatoria, ma un curriculum con una foto sembra più personale e attira di più il reclutatore.",
  "text1750": "Carica il tuo curriculum video che ti avvicinerà di un passo alla posizione lavorativa desiderata.",
  "text1751": "Sapevate che un selezionatore impiega in media 7 secondi per scansionare un CV per la prima volta? Quindi, menzionate solo le esperienze rilevanti e descrivetele in punti o brevi paragrafi.",
  "text1752": "Fai sapere ai datori di lavoro qual è la tua istruzione.",
  "text1753": "Inserite le competenze e le conoscenze di cui disponete e il loro livello.",
  "text1754": "Aggiungi al tuo curriculum altre sezioni che sono importanti per te.",
  "text1755": "Titolo dopo il nome",
  "text1756": "Scegli dall'elenco le categorie di settore per le quali desideri candidarti",
  "text1757": "I nostri social network",
  "text1758": "Le nostre referenze",
  "text1759": "Ulteriori riferimenti",
  "text1760": "Il nostro team",
  "text1761": "Offerta attuale",
  "text1762": "Chiave non valida",
  "text1763": "Abbiamo capito",
  "text1764": "Prodotti chimici industriali ecologici",
  "text1765": "Come si realizzano i prodotti?",
  "text1766": "Possibilità di lavorare da casa?",
  "text1767": "Giorno di inizio",
  "text1768": "Descrizione dell'offerta di lavoro",
  "text1769": "Dettagli di contatto per rispondere all'offerta",
  "text1770": "Aggiungi l'esperienza lavorativa richiesta e il livello di esperienza richiesto al richiedente.",
  "text1771": "Aggiungi l'istruzione richiesta al richiedente.",
  "text1772": "Aggiungi le competenze linguistiche richieste per questa posizione lavorativa",
  "text1773": "Aggiungi all'offerta altre parti richieste dall'offerente.",
  "text1774": "Nome dell'esperienza lavorativa",
  "text1775": "Livello di esperienza lavorativa",
  "text1776": "Aggiungi nuovo",
  "text1777": "Istruzione secondaria",
  "text1778": "Istruzione universitaria di I livello",
  "text1779": "Istruzione superiore II. grado",
  "text1780": "Istruzione superiore III. grado",
  "text1781": "Livello",
  "text1782": "Scegli le categorie di patenti di guida richieste dal richiedente.",
  "text1783": "Il tuo curriculum è stato aggiornato con successo",
  "text1784": "Completa il CV",
  "text1785": "Nuova risposta nella consultazione",
  "text1786": "Hai una nuova risposta nello studio di consulenza",
  "text1787": "La domanda è stata aggiunta con successo",
  "text1788": "Aggiunto",
  "text1789": "Reazioni all'annuncio",
  "text1790": "Anni",
  "text1791": "Scarica CV",
  "text1792": "Imballaggio",
  "text1793": "Trova il tuo negozio locale",
  "text1794": "Numero di catalogo",
  "text1795": "Consegna 7 - 10 giorni",
  "text1796": "Registrati",
  "text1797": "Non hai offerte di lavoro",
  "text1798": "Curriculum cercati",
  "text1799": "Non importa",
  "text1800": "Cerca produttore, nome, serie, codice prodotto...",
  "text1801": "Scegli la qualità e la bellezza: acquista con noi!",
  "text1802": "Siamo un importatore diretto di questi produttori",
  "text1803": "Prezzo normale per",
  "text1804": "Il nostro prezzo per",
  "text1805": "Prezzo per 1 confezione",
  "text1806": "Inserisci la superficie per calcolare la quantità di colli",
  "text1807": "Inserisci il contenuto del desktop",
  "text1808": "imballaggio",
  "text1809": "Scegli una competenza soft",
  "text1810": "Seleziona un livello",
  "text1811": "Guarda il video",
  "text1812": "Nessuna nuova notifica",
  "text1813": "Vendi con noi",
  "text1814": "Collaboriamo con questi corrieri",
  "text1815": "Modifica annuncio",
  "text1816": "Posizioni lavorative consigliate",
  "text1817": "Posizione aperta",
  "text1818": "Contattaci",
  "text1819": "Posizioni simili",
  "text1820": "Ci riserviamo il diritto di non rispondere ai candidati che non soddisfano i requisiti indicati.",
  "text1821": "Informazioni sull'azienda",
  "text1822": "Portafoglio di aziende",
  "text1823": "Rifiuta tutto",
  "text1824": "Sito web",
  "text1825": "Quanti articoli hai?",
  "text1826": "Quanti ordini ricevi al mese?",
  "text1827": "corrispondenza",
  "text1828": "Accettato",
  "text1829": "Sì, desidero ricevere occasionalmente notizie e suggerimenti sui servizi e-commerce.",
  "text1830": "Rifiutato",
  "text1831": "Attesa",
  "text1832": "Ha risposto",
  "text1833": "Competenze trasversali",
  "text1834": "Scegli tra oltre 60 marchi nel nostro portafoglio e trova esattamente quello che stai cercando! Tutto è completamente personalizzabile, dalla tappezzeria ai colori. Contattaci e insieme creeremo un design personalizzato secondo i tuoi desideri.",
  "text1835": "Visualizza i prodotti",
  "text1836": "Dove andrà?",
  "text1837": "bambino",
  "text1838": "bambini",
  "text1839": "bambini",
  "text1840": "adulto",
  "text1841": "adulti",
  "text1842": "adulti",
  "text1843": "Da 1 a 3 notti",
  "text1844": "Da 4 a 6 notti",
  "text1845": "Da 7 a 15 notti",
  "text1846": "16+ notti",
  "text1847": "Seleziona il numero di notti",
  "text1848": "Altre opzioni",
  "text1849": "Nuova domanda",
  "text1850": "Luogo, posizione, hotel",
  "text1851": "Data dal - al",
  "text1852": "Numero di passeggeri",
  "text1853": "Durata del soggiorno",
  "text1854": "Cibo",
  "text1855": "Chiudi",
  "text1856": "Mostra più opzioni",
  "text1857": "Prezzo massimo per persona",
  "text1858": "Altro",
  "text1859": "Tipo di qualifica",
  "text1860": "Nessun tour soddisfa i criteri specificati.",
  "text1861": "Scopri di più",
  "text1862": "Altri articoli della scorsa settimana",
  "text1863": "Venditore",
  "text1864": "Listino prezzi delle biografie",
  "text1865": "Nuova registrazione all'ingrosso",
  "text1866": "Per niente",
  "text1867": "Non molto",
  "text1868": "Neutrale",
  "text1869": "Ancora un po'",
  "text1870": "Molto",
  "text1871": "Lo trovi interessante?",
  "text1872": "Hai completato con successo il test",
  "text1873": "Fatto",
  "text1874": "Sei il più adatto per",
  "text1875": "Mostra posizioni libere",
  "text1876": "Non sono un contribuente IVA",
  "text1877": "Mostra tutte le notifiche",
  "text1878": "Notifiche",
  "text1879": "Non letto",
  "text1880": "Segna tutto come letto",
  "text1881": "Nessuna notifica",
  "text1882": "Numero di record da visualizzare",
  "text1883": "Avete",
  "text1884": "nuovo messaggio",
  "text1885": "nuovi messaggi",
  "text1886": "nuovi messaggi",
  "text1887": "Rispondi alla domanda di annuncio",
  "text1888": "Reazione alla pubblicità",
  "text1889": "Completa il tuo profilo",
  "text1890": "Nuova offerta di lavoro",
  "text1891": "L'offerta scadrà a breve",
  "text1892": "L'azienda ha mostrato interesse",
  "text1893": "Nuovo richiedente",
  "text1894": "Aggiorna il tuo profilo",
  "text1895": "Notifica di sistema",
  "text1896": "Hai un nuovo candidato per un'offerta di lavoro",
  "text1897": "ha aggiunto una nuova offerta di lavoro",
  "text1898": "ha mostrato interesse per te",
  "text1899": "sconto",
  "text1900": "Ultimi blog",
  "text1901": "Prodotti consigliati",
  "text1902": "Novità e sconti",
  "text1903": "Dettaglio della categoria",
  "text1904": "Compila tutte le domande per continuare",
  "text1905": "Invia prova",
  "text1906": "Promozione speciale",
  "text1907": "Voglio vendere tramite Loft.cz",
  "text1908": "Inserisci la tua email e non perdere offerte uniche",
  "text1909": "Servizio",
  "text1910": "Infoline",
  "text1911": "Aree di lavoro idonee",
  "text1912": "Ambiente lavorativo idoneo",
  "text1913": "Unisciti a noi",
  "text1914": "Stipendio previsto",
  "text1915": "Aziende preferite",
  "text1916": "Vai a tutte le scuole",
  "text1917": "Abbonamento",
  "text1918": "Visto l'ultima volta",
  "text1919": "I miei eventi",
  "text1920": "Articolo successivo",
  "text1921": "Articolo precedente",
  "text1922": "Procedi con l'acquisto di un abbonamento.",
  "text1923": "Paese di consegna",
  "text1924": "Hai bisogno di contattarci? Scrivici a",
  "text1925": "PI",
  "text1926": "PD",
  "text1927": "Abbonamento attivo",
  "text1928": "Se annulli l'abbonamento, l'abbonamento rimarrà attivo fino alla fine del periodo di abbonamento.",
  "text1929": "Cronologia degli abbonamenti",
  "text1930": "Scarica fattura",
  "text1931": "Abbonamento attivato",
  "text1932": "Abilità",
  "text1933": "Hai già acquistato un abbonamento?",
  "text1934": "Accedi al tuo account.",
  "text1935": "L'abbonamento include l'accesso a tutte le lezioni di ballo, allenamenti e altre informazioni, sconto del 10% su tutti gli eventi Danceana OZ per gli utenti registrati.",
  "text1936": "Crea le tue informazioni di accesso.",
  "text1937": "Inizio",
  "text1938": "Fine",
  "text1939": "Partner",
  "text1940": "Acquista un abbonamento",
  "text1941": "Tutti gli eventi",
  "text1942": "Meno",
  "text1943": "Tutti gli album",
  "text1944": "Visualizza galleria",
  "text1945": "Cosa ottieni?",
  "text1946": "Voglio diventare partner",
  "text1947": "Tutti",
  "text1948": "Docenti",
  "text1949": "Altri corsi che potrebbero interessarti",
  "text1950": "Condizioni commerciali",
  "text1951": "Non ci sono corsi disponibili in questa categoria.",
  "text1952": "Salva la modifica dei dati",
  "text1953": "Verifica il tuo indirizzo email",
  "text1954": "Verifica",
  "text1955": "Su di me",
  "text1956": "Finora",
  "text1957": "Valori",
  "text1958": "Per completare la registrazione è necessario confermare l'indirizzo email",
  "text1959": "Invia nuovamente l'e-mail di conferma",
  "text1960": "L'e-mail di conferma è stata inviata nuovamente",
  "text1961": "Si è verificato un errore durante l'invio dell'e-mail di conferma",
  "text1962": "L'indirizzo email è stato verificato con successo",
  "text1963": "Cerca scuole",
  "text1964": "Nessuna scuola",
  "text1965": "Seleziona una posizione",
  "text1966": "Iscriviti alla newsletter e ricevi sempre le informazioni più aggiornate dalla nostra offerta",
  "text1967": "I clienti hanno detto di noi",
  "text1968": "Nessuna proprietà corrisponde al filtro selezionato",
  "text1969": "Saresti il più adatto per le posizioni",
  "text1970": "Posizioni lavorative idonee",
  "text1971": "Benefici occupazionali",
  "text1972": "Qualifiche",
  "text1973": "Impossibile verificare l'indirizzo email",
  "text1974": "Esegui test",
  "text1975": "Vuoi davvero eliminare l'annuncio?",
  "text1976": "giorno",
  "text1977": "giorni",
  "text1978": "giorni",
  "text1979": "Nascondi elenco fornitori",
  "text1980": "Mostra elenco fornitori",
  "text1981": "Verifica la disponibilità con il venditore",
  "text1982": "Seleziona rivenditore",
  "text1983": "Seleziona un rivenditore",
  "text1984": "Nascondi l'elenco dei rivenditori",
  "text1985": "Mostra l'elenco dei venditori",
  "text1986": "Grazie, abbiamo registrato la tua richiesta, ti contatteremo entro poche ore",
  "text1987": "Scuole preferite",
  "text1988": "Se non hai ancora un account con noi",
  "text1989": "Questa scuola non ha ancora un profilo verificato",
  "text1990": "Salva curriculum PDF",
  "text1991": "Contattare l'interessato",
  "text1992": "Patente di guida",
  "text1993": "Visualizza i prodotti",
  "text1994": "Il valore deve provenire da un intervallo",
  "text1995": "Inserisci",
  "text1996": "Livello base",
  "text1997": "Seleziona la durata del tuo abbonamento",
  "text1998": "Prezzo per abbonamento di 1 mese",
  "text1999": "Seleziona il numero di curriculum",
  "text2000": "Tutti gli articoli",
  "text2001": "Iscriviti alla newsletter e sarai il primo a ricevere le informazioni più interessanti su sconti, novità ed eventi.",
  "text2002": "Iscrivendosi alla newsletter, accetti",
  "text2003": "Non hai trovato la risposta\nalla domanda?",
  "text2004": "Chiamaci e chiedi",
  "text2005": "Il nostro negozio con noleggio",
  "text2006": "Ufficio in affitto",
  "text2007": "Hai bisogno di consigli o hai domande su un prodotto? Contattaci e ti risponderemo.",
  "text2008": "Scrivici",
  "text2009": "Formazione/esperienza richiesta nel settore",
  "text2010": "Invia interesse per un'offerta di lavoro",
  "text2011": "L'interesse per l'offerta di lavoro è stato inviato",
  "text2012": "Visualizza aziende",
  "text2013": "Hai bisogno di un consiglio? Mettiti in contatto con noi",
  "text2014": "Mostra tutto",
  "text2015": "Non accetto l'invio del questionario di soddisfazione all'interno del programma Heureka Verificato dai clienti.",
  "text2016": "Aggiungi social network",
  "text2017": "Prezzo comprensivo di IVA al 23%.",
  "text2018": "Condizioni di noleggio QUI",
  "text2019": "Iscriviti",
  "text2020": "Hai già il tuo account?",
  "text2021": "Scegli una moto",
  "text2022": "Cerca per nome della motocicletta...",
  "text2023": "Nessun prodotto trovato per",
  "text2024": "Non ci sono prodotti disponibili in questa categoria",
  "text2025": "Cancella tutto",
  "text2026": "Può contenere solo numeri",
  "text2027": "Tipo di scuola",
  "text2028": "Torna alla selezione della moto",
  "text2029": "Grazie, interessato al test\nla corsa è stata inviata.",
  "text2030": "Ti contatteremo al più presto possibile e fisseremo la data del tuo test drive",
  "text2031": "Torna alla pagina principale",
  "text2032": "Specializzazione",
  "text2033": "Istruzione completata più alta",
  "text2034": "Indirizzo del luogo di lavoro",
  "text2035": "Ho il mio schema",
  "text2036": "Inviaci il tuo disegno/modello tramite questo modulo e ti forniremo un prezzo\n              produzione.",
  "text2037": "Date dei corsi",
  "text2038": "Aggiungi competenze trasversali",
  "text2039": "L'interesse è stato inviato con successo",
  "text2040": "L'interesse per l'offerta di lavoro è già stato realizzato.",
  "text2041": "Sei sicuro di voler manifestare interesse per questa offerta di lavoro?",
  "text2042": "Conferma interesse",
  "text2043": "Conferma acquisto",
  "text2044": "Sei sicuro di voler acquistare un abbonamento?",
  "text2045": "Punto",
  "text2046": "mesi",
  "text2047": "Attiva le notifiche",
  "text2048": "Nuova offerta da parte del datore di lavoro",
  "text2049": "Nuova risposta per offrire interesse",
  "text2050": "Notifica di scadenza degli annunci popolari",
  "text2051": "Nuovo interesse dell'azienda",
  "text2052": "scuole",
  "text2053": "Visualizzato",
  "text2054": "Sindacati",
  "text2055": "Luogo di lavoro ricercato",
  "text2056": "Stipendio previsto",
  "text2057": "Distanza dal lavoro",
  "text2058": "Orario di lavoro",
  "text2059": "Data di creazione del profilo",
  "text2060": "Risoluzioni consigliate",
  "text2061": "Il prodotto sarà scaricabile dopo il pagamento dell'ordine",
  "text2062": "Non hai un profilo completamente compilato",
  "text2063": "Sono richiesti nome, cognome e almeno 1 soft skill",
  "text2064": "Almeno 1 soft skill",
  "text2065": "La creazione di un profilo servirà anche come curriculum. Completa i singoli passaggi e rispondi alle seguenti domande.",
  "text2066": "Annulla l'accettazione del richiedente",
  "text2067": "Vuoi confermare l'interesse del richiedente",
  "text2068": "Accetta il richiedente",
  "text2069": "L'interesse del richiedente viene confermato",
  "text2070": "Conferma",
  "text2071": "Accetta gli interessi",
  "text2072": "Rifiuta interesse",
  "text2073": "Il candidato riceverà un messaggio che lo hai accettato",
  "text2074": "Pratica per gli studenti",
  "text2075": "Nessuna offerta",
  "text2076": "Visualizza",
  "text2077": "offerta",
  "text2078": "offerte",
  "text2079": "Accetta tutto",
  "text2080": "Conferma tutte le offerte",
  "text2081": "Questa azione confermerà l'interesse per il lavoro di tutti i candidati la cui domanda ha lo stato \"In sospeso\"",
  "text2082": "I candidati riceveranno un messaggio che li hai accettati",
  "text2083": "Conferma di tutte le offerte...",
  "text2084": "Concetto",
  "text2085": "Attivo",
  "text2086": "Archiviato",
  "text2087": "Salva bozza",
  "text2088": "Aggiungi una soft skill",
  "text2089": "L'account verrà eliminato per",
  "text2090": "Sei sicuro di voler eliminare l'account?",
  "text2091": "Visualizza il mio curriculum nel database dei curriculum",
  "text2092": "sblocca curriculum",
  "text2093": "Non sei un Partner Jobiis",
  "text2094": "Se vuoi acquistare gli sblocchi curriculum ad un prezzo scontato, devi prima attivare l'abbonamento \"Jobiis Partner\"",
  "text2095": "Il modulo non è compilato",
  "text2096": "Mostra reazioni",
  "text2097": "Rimuovi pubblicità",
  "text2098": "Archivio",
  "text2099": "Attiva",
  "text2100": "Archiviato",
  "text2101": "Attivo",
  "text2102": "Modulo compilato in modo errato",
  "text2103": "Il modulo non è compilato correttamente. Controlla il modulo e invialo di nuovo.",
  "text2104": "Non hai questa biografia sbloccata",
  "text2105": "Sblocca curriculum",
  "text2106": "Per accedere alle informazioni su questo curriculum, il curriculum deve essere sbloccato.",
  "text2107": "Sblocca",
  "text2108": "Sblocchi gratuiti rimanenti",
  "text2109": "Sblocca gli acquisti rimanenti",
  "text2110": "Il CV è stato sbloccato",
  "text2111": "Visualizza curriculum",
  "text2112": "Non pagato",
  "text2113": "Paga",
  "text2114": "Rifinitura",
  "text2115": "Nessun prodotto nel carrello",
  "text2116": "Non hai abbastanza credito",
  "text2117": "Benefici aziendali",
  "text2118": "Offerta adatta agli stranieri",
  "text2119": "Offerta adatta a un laureato",
  "text2120": "Corsi di formazione",
  "text2121": "Crea una connessione con il tuo futuro lavoro",
  "text2122": "Sono un datore di lavoro",
  "text2123": "Sono un candidato",
  "text2124": "Paga l'offerta",
  "text2125": "Sblocca l'offerta gratuitamente",
  "text2126": "Offerte gratuite",
  "text2127": "menu di sblocco",
  "text2128": "Articolo",
  "text2129": "Socio",
  "text2130": "Utilizza l'offerta libera",
  "text2131": "rimane",
  "text2132": "Utilizza copertura gratuita",
  "text2133": "Il mio CV",
  "text2134": "Superato",
  "text2135": "Totale per il pagamento",
  "text2136": "Riepilogo dell'ordine",
  "text2137": "Continua al riepilogo",
  "text2138": "Prodotti da acquistare",
  "text2139": "Indirizzo di consegna",
  "text2140": "Torna alle informazioni di spedizione e fatturazione",
  "text2141": "per l'elaborazione degli ordini e scopi di marketing.",
  "text2142": "Accetto di inviare informazioni su novità, sconti e promozioni di prezzo.",
  "text2143": "massimo 600 caratteri",
  "text2144": "Aggiungi i dati dell'azienda in base al numero ID",
  "text2145": "Aggiungi dati",
  "text2146": "Non hai inserito i tuoi dati",
  "text2147": "Il tuo profilo non dispone di dati di fatturazione completi.",
  "text2148": "Valido fino al",
  "text2149": "massimo 600 caratteri",
  "text2150": "Obbligatorio",
  "text2151": "Vuoi salvare le modifiche apportate?",
  "text2152": "Non salvare",
  "text2153": "Superato",
  "text2154": "Nessuna reazione all'offerta",
  "text2155": "Acquista curriculum",
  "text2156": "Cerca per città",
  "text2157": "mesi",
  "text2158": "Pratica professionale per studenti",
  "text2159": "Titolo di qualifica/istruzione",
  "text2160": "Istruzione ottenuta",
  "text2161": "Organizzazione che fornisce istruzione/qualificazione",
  "text2162": "L'e-mail inserita esiste già",
  "text2163": "Dimensione dell'impresa",
  "text2164": "Seleziona la dimensione dell'azienda",
  "text2165": "Visualizza i vantaggi",
  "text2166": "Base",
  "text2167": "Il contenuto non è un XML valido",
  "text2168": "Il contenuto non è un JSON valido",
  "text2169": "Acquisto a rate",
  "text2170": "Mese",
  "text2171": "Non hai aggiunto istruzione/qualifica",
  "text2172": "Segnala un errore",
  "text2173": "Sblocchi brevi",
  "text2174": "Sblocca offerte",
  "text2175": "Rifinitura",
  "text2176": "Descrizione dell'errore",
  "text2177": "È stato segnalato un errore",
  "text2178": "Segnala un altro errore",
  "text2179": "Errore durante l'invio",
  "text2180": "Un'offerta salvata come bozza deve avere un nome",
  "text2181": "Verifica della disponibilità della merce",
  "text2182": "Indirizzo del venditore",
  "text2183": "Ciao, nell'eshop",
  "text2184": "abbiamo registrato la domanda del cliente per i seguenti beni:",
  "text2185": "Si prega di informarci se nel negozio è presente la merce richiesta in modo che possiamo informare il cliente.",
  "text2186": "Saluti, Dipartimento Vendite",
  "text2187": "Il tuo profilo non è ancora compilato",
  "text2188": "Affinché le aziende possano vedere il tuo profilo è necessario inserire i seguenti dati",
  "text2189": "Compila il profilo",
  "text2190": "Se desideri che le aziende vedano il tuo profilo nel database dei curriculum, devi inserire le seguenti informazioni:",
  "text2191": "Termina profilo",
  "text2192": "Ammin",
  "text2193": "Aggiorna",
  "text2194": "Profilo di interessi",
  "text2195": "Scegli un tutor",
  "text2196": "Altre classi del docente",
  "text2197": "Avanzamento del campo",
  "text2198": "Team docente",
  "text2199": "Corsi individuali",
  "text2200": "Accessi",
  "text2201": "Tutte le sale",
  "text2202": "Programma completo",
  "text2203": "Galleria eventi",
  "text2204": "Media",
  "text2205": "Non hai trovato la risposta alla tua domanda? Contattaci.",
  "text2206": "Istruttore",
  "text2207": "Riguardo al docente",
  "text2208": "Che tipi di danza insegno?",
  "text2209": "Livelli di esperienza di danza",
  "text2210": "Galleria del docente",
  "text2211": "Ballerina",
  "text2212": "Educatore",
  "text2213": "Classificazione (scegli tra le opzioni) *",
  "text2214": "Inserisci il nome del gruppo di ballo / ZUŠ e dove opera",
  "text2215": "Seleziona una scuola",
  "text2216": "In caso di problemi contattateci",
  "text2217": "Questa email verrà utilizzata come nome di accesso.",
  "text2218": "Riceverai un'e-mail di verifica dopo la registrazione.",
  "text2219": "termini di abbonamento",
  "text2220": "Termini di abbonamento",
  "text2221": "L'offerta non è stata completamente soddisfatta. Se desideri pubblicare l'offerta, modifica l'offerta in modo che tutti i campi obbligatori siano compilati.",
  "text2222": "Se desideri salvare l'offerta come bozza, devi inserire il nome dell'offerta.",
  "text2223": "Pagamento dell'offerta",
  "text2224": "L'offerta verrà pubblicata solo dopo il pagamento",
  "text2225": "Puoi pagare l'offerta sul profilo nella sezione",
  "text2226": "Offerta di lavoro",
  "text2227": "Accetto i pagamenti ricorrenti",
  "text2228": "Listino prezzi",
  "text2229": "La creazione di un profilo scolastico fungerà da biglietto da visita della tua scuola.",
  "text2230": "Congratulazioni! La tua richiesta di annuncio è stata approvata. Fare clic per aprire una chat con l'azienda.",
  "text2231": "Purtroppo la tua richiesta di inserzione è stata respinta.",
  "text2232": "Il corso è stato aggiunto con successo al carrello",
  "text2233": "Articoli nel carrello",
  "text2234": "Persona fisica",
  "text2235": "Persona giuridica (società)",
  "text2236": "Inclusione",
  "text2237": "Scegli tra le opzioni",
  "text2238": "Inserisci l'e-mail",
  "text2239": "Inserisci un numero di telefono",
  "text2240": "Inserisci un nome",
  "text2241": "Inserisci il cognome",
  "text2242": "Menu Modifica",
  "text2243": "Devi effettuare l'accesso prima di acquistare un abbonamento",
  "text2244": "Non avete ancora un account?",
  "text2245": "Crealo qui",
  "text2246": "Galleria",
  "text2247": "Interessato",
  "text2248": "con professionista",
  "text2249": "videobiografia",
  "text2250": "Ricetta",
  "text2251": "Crea un curriculum professionale",
  "text2252": "Numero della carta",
  "text2253": "Validità della carta",
  "text2254": "CVV",
  "text2255": "MM / AA",
  "text2256": "Docente",
  "text2257": "Accedi ai contenuti del corso tramite",
  "text2258": "abbonamento.",
  "text2259": "Se hai acquistato un abbonamento,",
  "text2260": "accedere.",
  "text2261": "Non hai corsi preferiti",
  "text2262": "Rimuovi la carta",
  "text2263": "Servizio biciclette",
  "text2264": "Paga e pubblica",
  "text2265": "Paga più tardi",
  "text2266": "Link per reagire all'offerta",
  "text2267": "Lascia il campo vuoto se desideri gestire le risposte all'offerta nel nostro sistema",
  "text2268": "Invia direttamente gli interessi",
  "text2269": "Pagato",
  "text2270": "Annulla iscrizione",
  "text2271": "Se non desideri ricevere email, clicca sul collegamento",
  "text2272": "Il nostro indirizzo",
  "text2273": "Visita a trovarci",
  "text2274": "Nome del titolare della carta",
  "text2275": "Formato della chiave privata non corretto",
  "text2276": "Si consiglia di ordinare",
  "text2277": "Aggiungi un file DXF al messaggio, in caso di più file comprimili in .rar o .zip",
  "text2278": "Chiedi il prezzo",
  "text2279": "Inserisci la quantità",
  "text2280": "La tua richiesta di prezzo è stata inviata. Ti contatteremo tramite il tuo indirizzo email.",
  "text2281": "Non mi interessa",
  "text2282": "Hanno comprato da noi",
  "text2283": "Oltre 2.789 clienti soddisfatti",
  "text2284": "Categorie selezionate",
  "text2285": "Negozio di 300 mq",
  "text2286": "Lun-ven: 8:30 - 17:00",
  "text2287": "Club bonus",
  "text2288": "Sei sicuro di voler uscire?",
  "text2289": "Sì, esci",
  "text2290": "Salva modifiche",
  "text2291": "crealo qui.",
  "text2292": "Se non hai ancora il tuo account,",
  "text2293": "No, annulla",
  "text2294": "Cliente soddisfatto",
  "text2295": "Persona",
  "text2296": "Azienda",
  "text2297": "Disponibile",
  "text2298": "al tuo indirizzo",
  "text2299": "Esplora",
  "text2300": "Prodotti più venduti",
  "text2301": "Carica altro",
  "text2302": "Ordina",
  "text2303": "Spedizione immediata",
  "text2304": "Confronta",
  "text2305": "Parametri tecnici",
  "text2306": "Aggiungi valutazione",
  "text2307": "Si è verificato un errore durante l'aggiornamento del tuo profilo.",
  "text2308": "Disposizioni generali",
  "text2309": "Menu principale",
  "text2310": "Informazioni sul tuo ordine",
  "text2311": "L'ordine è stato pagato",
  "text2312": "L'ordine non è stato ancora pagato",
  "text2313": "Continua verso il basso",
  "text2314": "Selezione SUPERIORE",
  "text2315": "Esplora le scelte TOP per ogni giardino",
  "text2316": "Amato dai proprietari di casa\nin tutta la Slovacchia",
  "text2317": "Le strutture e gli accessori in legno più apprezzati per il tuo giardino",
  "text2318": "Esplora le nostre categorie più vendute di gazebo, casette, pensiline e accessori in legno. Qualità e consegna veloce in tutta la Slovacchia.",
  "text2319": "Tutte le categorie",
  "text2320": "Cosa distingue i nostri prodotti?",
  "text2321": "Dettagli tecnici",
  "text2322": "Le nostre ultime referenze",
  "text2323": "Qualificazione",
  "text2324": "Perché scegliere gazebo e casette in legno?",
  "text2325": "Vuoi anche tu la casetta da giardino o il gazebo dei tuoi sogni?",
  "text2326": "Scopri l'offerta",
  "text2327": "Vantaggi",
  "text2328": "Cosa ottieni con i nostri prodotti?",
  "text2329": "Sono interessato ad una consulenza",
  "text2330": "Realizzazioni",
  "text2331": "Storie di clienti soddisfatti",
  "text2332": "Più realizzazioni",
  "text2333": "Articoli interessanti da leggere",
  "text2334": "Non hai trovato la risposta alla domanda? Non esitate a contattarci.",
  "text2335": "Riproduci il video",
  "text2336": "Sei pronto a trasformare il tuo giardino?",
  "text2337": "Hai bisogno di un consiglio? Non esitate a contattarci sia tramite il modulo di contatto che direttamente tramite i recapiti riportati di seguito.",
  "text2338": "Compila il modulo.",
  "text2339": "Cosa ti interessa?",
  "text2340": "Il tuo messaggio",
  "text2341": "Inviando il modulo, accetti",
  "text2342": "trattando i dati personali.",
  "text2343": "Invia messaggio",
  "text2344": "Iscriviti alla newsletter e ricevi le informazioni più aggiornate sulla nostra offerta.",
  "text2345": "Non ricordi la password?",
  "text2346": "Si prega di inserire il numero dell'ordine e l'e-mail.",
  "text2347": "L'ordine per la combinazione specificata di numero ordine ed e-mail non esiste.",
  "text2348": "Hai effettuato l'accesso. Puoi trovare tutti i tuoi ordini nel tuo profilo.",
  "text2349": "La password deve contenere almeno da 6 a 64 caratteri, una lettera maiuscola e un numero.",
  "text2350": "Dati personali/aziendali",
  "text2351": "Numero di inventario",
  "text2352": "La tua registrazione è avvenuta con successo. Ti abbiamo inviato un link di conferma per l'attivazione dell'account nella tua casella di posta elettronica.",
  "text2353": "Scegli una categoria in base alle tue preferenze e trova il prodotto che stai cercando.",
  "text2354": "Mostra più categorie",
  "text2355": "Ordina per",
  "text2356": "Informazioni sulla categoria",
  "text2357": "Calcolatrice",
  "text2358": "Contattaci e saremo felici di aiutarti.",
  "text2359": "Questo prodotto non ha ancora recensioni. Sii il primo e condividi la tua esperienza!",
  "text2360": "recensioni",
  "text2361": "Cronologia degli ordini",
  "text2362": "Sto acquistando per un'azienda",
  "text2363": "Conferma la modifica della password",
  "text2364": "Si è verificato un errore.",
  "text2365": "Luogo di riferimento",
  "text2366": "Informazioni sul progetto",
  "text2367": "Galleria progetti",
  "text2368": "Esperienza del cliente",
  "text2369": "Realizzazioni simili",
  "text2370": "Continua all'articolo",
  "text2371": "Contenuto dell'articolo",
  "text2372": "Lun - ven",
  "text2373": "Sab - dom",
  "text2374": "Chiuso",
  "text2375": "Vai al funzionamento",
  "text2376": "Non abbiamo trovato contenuti che soddisfino i requisiti di ricerca",
  "text2377": "Grazie per il tuo interesse",
  "text2378": "Ti ricontatteremo il prima possibile.",
  "text2379": "Pagina iniziale",
  "text2380": "Ispirazioni",
  "text2381": "Ispirazioni per il tuo giardino",
  "text2382": "Guarda il processo di realizzazione di una casetta da giardino e di un gazebo",
  "text2383": "Noi contro la concorrenza",
  "text2384": "Cosa ci rende migliori rispetto alla concorrenza?",
  "text2385": "Concorrenza",
  "text2386": "Gazebo da giardino e casette in legno per il tuo giardino",
  "text2387": "Qualità e prezzi convenienti con consegna in Slovacchia",
  "text2388": "Crea lo spazio perfetto per rilassarti, riporre o proteggere la tua auto con i nostri gazebo, casette, pergolati e casette in legno. Ordina oggi!",
  "text2389": "Prezzo per pezzo",
  "text2390": "Pagamento e spedizione",
  "text2391": "È consentita una sola categoria attiva per integrazione API.",
  "text2392": "Se hai un account con noi, accedi e inseriremo i dati in base ai dati del tuo account.",
  "text2393": "Scopri ciò che i nostri clienti non possono elogiare. Questi prodotti di alta qualità combinano stile, funzionalità e convenienza.",
  "text2394": "Visualizza le nostre strutture in legno più popolari, realizzate in abete rosso o pino di qualità per resistenza e fascino. Ideale per qualsiasi spazio esterno.",
  "text2395": "Applicazione",
  "text2396": "Link utili",
  "text2397": "Diventa membro",
  "text2398": "Zona membri",
  "text2399": "Nome cognome / Ragione sociale",
  "text2400": "Luogo di lavoro (ad es. laboratorio biochimico)",
  "text2401": "Istituzione (ad es. NsP Bratislava)",
  "text2402": "per finalità di marketing e contatti",
  "text2403": "Trattamento dei dati personali",
  "text2404": "Scopri di più",
  "text2405": "Benvenuti nell'area membri",
  "text2406": "Documenti",
  "text2407": "Statuti",
  "text2408": "Codice etico",
  "text2409": "Presidio",
  "text2410": "Verbali e documenti",
  "text2411": "Elenco dei rappresentanti degli iscritti all'associazione",
  "text2412": "Statistiche del mercato IVD",
  "text2413": "Crediti",
  "text2414": "Accetto di inviare un questionario sulla soddisfazione come parte del programma Heureka Verified by Customers, che aiuta a migliorare i nostri servizi.",
  "text2415": "Incontra il tuo tutor",
  "text2416": "Cerca per nome dell'azienda o numero ID",
  "text2417": "Nessuna azienda trovata",
  "text2418": "Gateway di pagamento sconosciuto",
  "text2419": "Non hai abbonamenti attivi.",
  "text2420": "Compralo qui.",
  "text2421": "Tipo pagatore",
  "text2422": "Eq. prezzo",
  "text2423": "Metro",
  "text2424": "Corsi acquistati",
  "text2425": "Non hai acquistato alcun corso.",
  "text2426": "Panoramica dei corsi.",
  "text2427": "Fai un passo indietro",
  "text2428": "Puoi controllare lo stato del tuo ordine in qualsiasi momento cliccando il pulsante qui sotto",
  "text2429": "Abbiamo ricevuto la tua prenotazione per la prescrizione elettronica. Controlla la tua casella di posta elettronica.",
  "text2430": "Non riempito",
  "text2431": "Grazie per aver inviato la prenotazione!",
  "text2432": "La tua prenotazione è stata inviata con successo.",
  "text2433": "Dati inviati",
  "text2434": "Carica una foto della ricetta",
  "text2435": "Foto selezionate",
  "text2436": "Scatta una foto",
  "text2437": "Immagine della prescrizione elettronica",
  "text2438": "Come offerente",
  "text2439": "Ho già un account, ne voglio uno",
  "text2440": "Come datore di lavoro",
  "text2441": "Numero di identificazione (IČO)",
  "text2442": "Indirizzo e sede dell'azienda",
  "text2443": "Modifica CV",
  "text2444": "Le modifiche al profilo sono state salvate con successo",
  "text2445": "Chiedi al nostro esperto",
  "text2446": "Posizione preferita",
  "text2447": "Lavoro nei fine settimana",
  "text2448": "Lavoro di notte",
  "text2449": "Informazioni aggiuntive",
  "text2450": "Preferenze di lavoro",
  "text2451": "Nessun CV corrisponde ai filtri selezionati",
  "text2452": "Per aggiungere una nuova offerta di lavoro è necessario compilare tutti i campi obbligatori.",
  "text2453": "Informazioni di base sulla posizione",
  "text2454": "Requisiti del richiedente",
  "text2455": "Tipo di temporizzazione",
  "text2456": "Seleziona il tipo di patente di guida richiesta",
  "text2457": "Aggiungi un'altra lingua",
  "text2458": "Giorno di inizio stimato",
  "text2459": "Inserisci le informazioni sul luogo di lavoro.",
  "text2460": "Condizioni salariali",
  "text2461": "Indicare i termini di pagamento per l'offerente",
  "text2462": "Rimuovi menu",
  "text2463": "Offerte attuali",
  "text2464": "Questa azienda non ha offerte attive",
  "text2465": "Descrivi la tua attività",
  "text2466": "Offriamo stage per studenti",
  "text2467": "Collaboriamo con le scuole",
  "text2468": "Contenuto del blog",
  "text2469": "Articoli simili",
  "text2470": "Leggi articoli utili.",
  "text2471": "Registrati",
  "text2472": "Aggiungi al carrello",
  "text2473": "Ricerca avanzata",
  "text2474": "Cerca in",
  "text2475": "Attendere l'e-mail e l'SMS",
  "text2476": "Cancella filtro",
  "text2477": "Corrispondenza parziale con il nome del prodotto",
  "text2478": "Breve descrizione del prodotto",
  "text2479": "Codice prodotto EAN",
  "text2480": "Codice prodotto esterno",
  "text2481": "Codice prodotto",
  "text2482": "Inizia a digitare un indirizzo",
  "text2483": "Candidati",
  "text2484": "Candidati più anziani",
  "text2485": "I candidati più giovani",
  "text2486": "Ultime reazioni",
  "text2487": "Reazioni più antiche",
  "text2488": "Accettato",
  "text2489": "Non accettato",
  "text2490": "Data in arrivo",
  "text2491": "Nessun corso trovato",
  "text2492": "negozio",
  "text2493": "Processo di formazione",
  "text2494": "Impostazione del modello email mancante nello stato dell'ordine",
  "text2495": "Locker self-service Balíkovo",
  "text2496": "Punto vendita Balíkovo",
  "text2497": "Invia",
  "text2498": "Seleziona",
  "text2499": "Posizione selezionata",
  "text2500": "Contanti alla consegna",
  "text2501": "Importo totale dell'ordine",
  "text2502": "Compra",
  "text2503": "Utilizza copertura gratuita",
  "text2504": "credito",
  "text2505": "crediti",
  "text2506": "crediti",
  "text2507": "Pagamento con crediti",
  "text2508": "La spedizione dell'ordine non è pronta",
  "text2509": "L'ordine è già stato spedito",
  "text2510": "Il corriere non offre la spedizione automatizzata",
  "text2511": "Non mostrare la prossima volta",
  "text2512": "Numero di persone",
  "text2513": "Un nuovo tentativo di pagamento non è consentito per il metodo di pagamento",
  "text2514": "Il gateway di pagamento attualmente non supporta i rimborsi API",
  "text2515": "Creazione promemoria",
  "text2516": "Modifica di un promemoria",
  "text2517": "Eliminazione promemoria",
  "text2518": "Creazione del prodotto",
  "text2519": "Modifica del prodotto",
  "text2520": "Eliminazione del prodotto",
  "text2521": "Creazione del prezzo",
  "text2522": "Adeguamento del prezzo",
  "text2523": "Eliminazione del prezzo",
  "text2524": "Creazione di un tipo di proprietà",
  "text2525": "Modifica tipo di proprietà",
  "text2526": "Eliminazione del tipo di proprietà",
  "text2527": "Creazione del tipo di elenco delle proprietà",
  "text2528": "Modifica del tipo di elenco delle proprietà",
  "text2529": "Eliminazione del tipo di elenco delle proprietà",
  "text2530": "Creazione di una stanza",
  "text2531": "Modifica della stanza",
  "text2532": "Eliminazione della stanza",
  "text2533": "Creazione di un'etichetta di proprietà",
  "text2534": "Modifica etichetta proprietà",
  "text2535": "Elimina tag proprietà",
  "text2536": "Creazione di informazioni aggiuntive sulla proprietà",
  "text2537": "Modifica delle informazioni aggiuntive sulla proprietà",
  "text2538": "Eliminazione di informazioni aggiuntive sulla proprietà",
  "text2539": "Creazione del valore delle informazioni aggiuntive sulla proprietà",
  "text2540": "Modifica del valore delle informazioni aggiuntive sulla proprietà",
  "text2541": "Eliminazione del valore delle informazioni aggiuntive sulla proprietà",
  "text2542": "Creare una città",
  "text2543": "Adeguamento della città",
  "text2544": "Cancella la città",
  "text2545": "Creazione del comune",
  "text2546": "Modifica del comune",
  "text2547": "Eliminazione del villaggio",
  "text2548": "Creazione di un campo di testo di proprietà",
  "text2549": "Modifica campo testo proprietà",
  "text2550": "Cancellazione del campo di testo della proprietà",
  "text2551": "Creazione di una categoria di proprietà",
  "text2552": "Modifica della categoria dell'immobile",
  "text2553": "Eliminazione categoria proprietà",
  "text2554": "Creazione di una regola di proprietà",
  "text2555": "Modifica della normativa immobiliare",
  "text2556": "Eliminazione della regola di proprietà",
  "text2557": "Creazione di una risposta alla regola di proprietà",
  "text2558": "Modifica della risposta alla regola di proprietà",
  "text2559": "Eliminazione della risposta alla regola di proprietà in corso",
  "text2560": "Creazione di una prenotazione di proprietà",
  "text2561": "Modifica della prenotazione della proprietà",
  "text2562": "Eliminazione di una prenotazione di proprietà",
  "text2563": "Creazione di una destinazione di proprietà",
  "text2564": "Adeguamento della destinazione dell'immobile",
  "text2565": "Eliminazione destinazione proprietà",
  "text2566": "Creazione di una posizione di proprietà",
  "text2567": "Adeguamento della posizione immobiliare",
  "text2568": "Eliminazione della posizione di una proprietà",
  "text2569": "Costituzione di un'agenzia immobiliare",
  "text2570": "Modifica agenzia immobiliare",
  "text2571": "Cancellazione agenzia immobiliare",
  "text2572": "Creazione di un agente immobiliare",
  "text2573": "Modifica agente immobiliare",
  "text2574": "Eliminazione di un agente immobiliare",
  "text2575": "Creazione di un promotore immobiliare",
  "text2576": "Modifica del promotore immobiliare",
  "text2577": "Eliminazione del promotore immobiliare",
  "text2578": "Creazione di beni immobili",
  "text2579": "Modifica di beni immobili",
  "text2580": "Eliminazione di beni immobili",
  "text2581": "Creazione del prezzo immobiliare",
  "text2582": "Adeguamento del prezzo immobiliare",
  "text2583": "Eliminazione del prezzo dell'immobile",
  "text2584": "Creazione di una regola di proprietà personalizzata",
  "text2585": "Modifica del regolamento proprio della proprietà",
  "text2586": "Eliminazione di una regola di proprietà personalizzata",
  "text2587": "Creazione di un giorno di proprietà prenotabile",
  "text2588": "Modifica del giorno prenotabile dell'immobile",
  "text2589": "Cancellazione del giorno prenotabile dell'immobile",
  "text2590": "Creazione del tipo di corso",
  "text2591": "Modifica tipo di corso",
  "text2592": "Eliminazione del tipo di corso",
  "text2593": "Creazione della categoria del corso",
  "text2594": "Modifica categoria del corso",
  "text2595": "Eliminazione della categoria del corso",
  "text2596": "Creazione campo testo corso",
  "text2597": "Modifica campo testo corso",
  "text2598": "Cancellazione del campo di testo del corso",
  "text2599": "Creazione di un corso",
  "text2600": "Regolazione della rotta",
  "text2601": "Cancellazione del corso",
  "text2602": "Creazione della categoria ambulatorio",
  "text2603": "Adeguamento della categoria dello studio",
  "text2604": "Eliminazione della categoria ufficio di consultazione",
  "text2605": "Creazione del prezzo del corso",
  "text2606": "Adeguamento del prezzo del corso",
  "text2607": "Eliminazione del prezzo del corso",
  "text2608": "Creazione di un capitolo del corso",
  "text2609": "Modifica di un capitolo del corso",
  "text2610": "Eliminazione di un capitolo del corso",
  "text2611": "Creazione di un istruttore del corso",
  "text2612": "Modifica dell'istruttore del corso",
  "text2613": "Eliminazione dell'istruttore del corso",
  "text2614": "Creazione di un livello di corso",
  "text2615": "Regolazione del livello del percorso",
  "text2616": "Livello del corso chiaro",
  "text2617": "Creazione di un'aula corsi",
  "text2618": "Modifica dell'aula del corso",
  "text2619": "Eliminazione di un'aula del corso",
  "text2620": "Creazione dell'evento del corso",
  "text2621": "Modifica evento del corso",
  "text2622": "Cancellazione degli eventi del percorso",
  "text2623": "Creazione del programma del corso",
  "text2624": "Modifica del programma del corso",
  "text2625": "Eliminazione del programma del corso",
  "text2626": "Creazione del tipo di occupazione",
  "text2627": "Modifica del tipo di orario di lavoro",
  "text2628": "Eliminazione del tipo di orario di lavoro",
  "text2629": "Creazione dell'etichetta del portale del lavoro",
  "text2630": "Modifica etichetta portale lavoro",
  "text2631": "Eliminazione etichetta portale lavoro",
  "text2632": "Creazione di un campo di testo per il portale del lavoro",
  "text2633": "Modifica del campo di testo del portale lavoro",
  "text2634": "Eliminazione del campo di testo del portale lavoro",
  "text2635": "Creazione della categoria del portale di lavoro",
  "text2636": "Modifica la categoria del portale di lavoro",
  "text2637": "Eliminazione della categoria del portale di lavoro",
  "text2638": "Creazione del tipo di pagamento del portale del lavoro",
  "text2639": "Modifica del tipo di pagamento del portale del lavoro",
  "text2640": "Eliminazione del tipo di pagamento del portale per il lavoro",
  "text2641": "Creazione di dimensioni aziendali nel portale del lavoro",
  "text2642": "Adeguamento dimensione azienda portale lavoro",
  "text2643": "Eliminazione delle dimensioni dell'azienda del portale di lavoro",
  "text2644": "Creazione di un portale per il lavoro aziendale",
  "text2645": "Modifica del portale del lavoro aziendale",
  "text2646": "Eliminazione dell'azienda del portale di lavoro",
  "text2647": "Creazione dello stato del portale di lavoro",
  "text2648": "Modifica dello stato del portale del lavoro",
  "text2649": "Cancellazione dello stato del portale di lavoro",
  "text2650": "Creazione del valore dell'attributo del portale per il lavoro",
  "text2651": "Modifica del valore dell'attributo del portale lavoro",
  "text2652": "Cancellazione del valore dell'attributo del portale per il lavoro",
  "text2653": "Creazione dell'attributo del portale del lavoro",
  "text2654": "Modifica attributo del portale lavoro",
  "text2655": "Eliminazione dell'attributo del portale per il lavoro",
  "text2656": "Creazione dell'orario di lavoro nel portale lavoro",
  "text2657": "Adeguamento dell'orario di lavoro del portale del lavoro",
  "text2658": "Cancellazione dell'orario di lavoro del portale di lavoro",
  "text2659": "Creazione portale lavoro cantiere",
  "text2660": "Modifica del luogo di svolgimento del portale del lavoro",
  "text2661": "Eliminazione del luogo di prestazione lavorativa dal portale del lavoro",
  "text2662": "Creazione di un portale del lavoro per fasce di età",
  "text2663": "Adeguamento della fascia di età del portale del lavoro",
  "text2664": "Cancellazione della fascia di età del portale del lavoro",
  "text2665": "Stabilimento dell'esperienza pregressa richiesta nel portale di lavoro",
  "text2666": "Adeguamento dell'esperienza pregressa richiesta nel portale di lavoro",
  "text2667": "Rimozione dell'esperienza precedente richiesta nel portale del lavoro",
  "text2668": "Creazione dell'idoneità per una posizione nel portale del lavoro",
  "text2669": "Adeguamento di idoneità per la posizione nel portale del lavoro",
  "text2670": "Eliminazione dell'idoneità per la posizione nel portale del lavoro",
  "text2671": "Creazione di un portale per il lavoro con formazione completata",
  "text2672": "Modifica del portale del lavoro con istruzione completata",
  "text2673": "Eliminazione del portale di lavoro per l'istruzione completata",
  "text2674": "Creazione di un portale di lavoro per patenti di guida",
  "text2675": "Modifica del portale lavoro patenti di guida",
  "text2676": "Eliminazione della patente di guida dal portale del lavoro",
  "text2677": "Crea portale lavoro tipo scuola",
  "text2678": "Modifica tipologia scuola del portale lavoro",
  "text2679": "Eliminazione del tipo di scuola del portale di lavoro",
  "text2680": "Creazione della sezione scuola del portale lavoro",
  "text2681": "Modifica della sezione scuola del portale lavoro",
  "text2682": "Eliminazione della sezione scuola del portale lavoro",
  "text2683": "Creazione di un portale del lavoro scolastico",
  "text2684": "Modifica del portale del lavoro della scuola",
  "text2685": "Eliminazione del portale lavoro scuola",
  "text2686": "Realizzazione del progetto Portale Scuola Lavoro",
  "text2687": "Modifica progetto portale lavoro scuola",
  "text2688": "Eliminazione del progetto scolastico del portale lavoro",
  "text2689": "Istituzione del portale del lavoro per la cooperazione scolastica",
  "text2690": "Adeguamento del portale lavoro cooperazione scolastica",
  "text2691": "Eliminazione della collaborazione della scuola dal portale del lavoro",
  "text2692": "Creazione di un'offerta di lavoro sul portale del lavoro",
  "text2693": "Modifica dell'offerta di lavoro del portale del lavoro",
  "text2694": "Eliminazione dell'offerta di lavoro dal portale di lavoro",
  "text2695": "Creazione della competenza per l'elenco dei lavori nel portale di lavoro",
  "text2696": "Modifica della capacità di elenco dei lavori del portale di lavoro",
  "text2697": "Eliminazione della competenza relativa all'elenco dei lavori del portale di lavoro",
  "text2698": "Creazione di un'offerta di lavoro sul portale del lavoro",
  "text2699": "Adeguamento salariale dell'offerta di lavoro sul portale del lavoro",
  "text2700": "Eliminazione dello stipendio dell'offerta di lavoro del portale del lavoro",
  "text2701": "Crea un curriculum sul portale del lavoro",
  "text2702": "Modifica del curriculum del portale lavori",
  "text2703": "Eliminazione CV dal portale di lavoro",
  "text2704": "Creazione di competenze di curriculum nel portale di lavoro",
  "text2705": "Portale lavoro riprendi l'adeguamento delle competenze",
  "text2706": "Eliminazione della competenza curriculum del portale lavoro",
  "text2707": "Creazione del portale di lavoro per riprendere l'esperienza lavorativa",
  "text2708": "Modifica del portale del lavoro per riprendere l'esperienza lavorativa",
  "text2709": "Eliminazione dell'esperienza lavorativa dal CV del portale lavoro",
  "text2710": "Creazione di un portale per il lavoro per riprendere l'istruzione",
  "text2711": "Modifica del portale del lavoro riprende l'istruzione",
  "text2712": "Eliminazione del portale di lavoro per riprendere l'istruzione",
  "text2713": "Creazione del curriculum salariale nel portale del lavoro",
  "text2714": "Il portale del lavoro riprende l'adeguamento salariale",
  "text2715": "Eliminazione del portale di lavoro per riprendere lo stipendio",
  "text2716": "Creazione dello stato di agenzia di viaggi",
  "text2717": "Adeguamento dello status di agenzia di viaggi",
  "text2718": "Cancellazione dello status dell'agenzia di viaggi",
  "text2719": "Creazione di un'etichetta per un'agenzia di viaggi",
  "text2720": "Adeguamento etichetta agenzia di viaggi",
  "text2721": "Eliminazione dell'etichetta dell'agenzia di viaggi",
  "text2722": "Creazione campo testo agenzia di viaggi",
  "text2723": "Modifica del campo di testo dell'agenzia di viaggi",
  "text2724": "Eliminazione del campo testo agenzia di viaggi",
  "text2725": "Creazione del valore dell'attributo dell'agenzia di viaggi",
  "text2726": "Modifica del valore dell'attributo agenzia di viaggi",
  "text2727": "Eliminazione del valore dell'attributo dell'agenzia di viaggi",
  "text2728": "Creazione dell'attributo agenzia di viaggi",
  "text2729": "Modifica dell'attributo dell'agenzia di viaggi",
  "text2730": "Eliminazione dell'attributo agenzia di viaggi",
  "text2731": "Creazione della categoria agenzia di viaggio",
  "text2732": "Modifica categoria agenzia di viaggio",
  "text2733": "Eliminazione della categoria agenzia di viaggio",
  "text2734": "Creazione di un tour in agenzia di viaggi",
  "text2735": "Modifica del tour dell'agenzia di viaggi",
  "text2736": "Eliminazione di un tour di un'agenzia di viaggi",
  "text2737": "Creazione della data del tour dell'agenzia di viaggi",
  "text2738": "Modifica della data del tour dell'agenzia di viaggi",
  "text2739": "Cancellazione della data del tour dell'agenzia di viaggi",
  "text2740": "Creazione di una prenotazione per un tour in agenzia di viaggi",
  "text2741": "Adeguamento della prenotazione del tour in agenzia di viaggi",
  "text2742": "Eliminazione della prenotazione di un tour in agenzia di viaggi",
  "text2743": "Creazione del partecipante al tour dell'agenzia di viaggi",
  "text2744": "Modifica partecipante al tour dell'agenzia di viaggi",
  "text2745": "Eliminazione di un partecipante al tour dell'agenzia di viaggi",
  "text2746": "Creazione del tipo di cliente",
  "text2747": "Modifica del tipo di cliente",
  "text2748": "Eliminazione tipo cliente",
  "text2749": "Creazione cliente",
  "text2750": "Modifica del cliente",
  "text2751": "Eliminazione di un cliente",
  "text2752": "Creazione del cliente nel gruppo clienti",
  "text2753": "Modifica di un cliente in un gruppo di clienti",
  "text2754": "Eliminazione di un cliente da un gruppo di clienti",
  "text2755": "Creazione del gruppo clienti",
  "text2756": "Modifica del gruppo clienti",
  "text2757": "Eliminazione gruppo clienti",
  "text2758": "Creazione del ruolo utente",
  "text2759": "Modifica del ruolo utente",
  "text2760": "Eliminazione del ruolo utente",
  "text2761": "Creazione utente",
  "text2762": "Modifica utente",
  "text2763": "Eliminazione utente",
  "text2764": "Creazione di un coupon prodotto",
  "text2765": "Modifica del coupon del prodotto",
  "text2766": "Eliminazione coupon prodotto",
  "text2767": "Creazione coupon",
  "text2768": "Modifica coupon",
  "text2769": "Eliminazione coupon",
  "text2770": "Creazione del buono sconto",
  "text2771": "Rettifica sconto coupon",
  "text2772": "Eliminazione buono sconto",
  "text2773": "Creazione di un prodotto regalo",
  "text2774": "Modifica di un prodotto regalo",
  "text2775": "Eliminazione di un prodotto regalo",
  "text2776": "Creazione di accessori del prodotto",
  "text2777": "Modifica degli accessori del prodotto",
  "text2778": "Eliminazione degli accessori del prodotto",
  "text2779": "Creazione del pacchetto prodotti",
  "text2780": "Modifica del pacchetto prodotto",
  "text2781": "Eliminazione del pacchetto prodotti",
  "text2782": "Creazione di una domanda sul prodotto",
  "text2783": "Modifica della domanda sul prodotto",
  "text2784": "Eliminazione domanda prodotto",
  "text2785": "Creazione di un prodotto virtuale su un prodotto",
  "text2786": "Modifica prodotto virtuale in prodotto",
  "text2787": "Eliminazione del prodotto virtuale nel prodotto",
  "text2788": "Creazione del servizio per il prodotto",
  "text2789": "Modifica del servizio in prodotto",
  "text2790": "Eliminazione del servizio del prodotto",
  "text2791": "Creazione di una recensione del prodotto",
  "text2792": "Modifica recensione prodotto",
  "text2793": "Eliminazione recensione prodotto in corso",
  "text2794": "Creazione di una variante di prodotto",
  "text2795": "Modifica variante prodotto",
  "text2796": "Eliminazione variante prodotto",
  "text2797": "Creazione del prezzo della variante del prodotto",
  "text2798": "Adeguamento del prezzo della variante di prodotto",
  "text2799": "Eliminazione del prezzo della variante prodotto",
  "text2800": "Creazione della categoria margine",
  "text2801": "Regola il margine della categoria",
  "text2802": "Cancellazione del margine della categoria",
  "text2803": "Creazione di uno sconto di categoria",
  "text2804": "Modifica dello sconto di categoria",
  "text2805": "Eliminazione sconto categoria",
  "text2806": "Creazione categoria",
  "text2807": "Modifica categoria",
  "text2808": "Cancellazione categoria",
  "text2809": "Creazione del valore dell'attributo",
  "text2810": "Modifica del valore dell'attributo",
  "text2811": "Eliminazione del valore dell'attributo",
  "text2812": "Creazione dell'attributo",
  "text2813": "Modifica di un attributo",
  "text2814": "Eliminazione attributo",
  "text2815": "Creazione del margine del fornitore",
  "text2816": "Rettifica margine fornitore",
  "text2817": "Eliminazione del margine del fornitore",
  "text2818": "Creazione dello sconto fornitore",
  "text2819": "Rettifica sconto fornitore",
  "text2820": "Eliminazione sconto fornitore",
  "text2821": "Creazione fornitore",
  "text2822": "Modifica fornitore",
  "text2823": "Eliminazione fornitore",
  "text2824": "Creazione produttore",
  "text2825": "Modifica del produttore",
  "text2826": "Elimina produttore",
  "text2827": "Creazione di un campo di testo",
  "text2828": "Modifica del campo di testo",
  "text2829": "Cancellazione di un campo di testo",
  "text2830": "Creazione dello stato del prodotto",
  "text2831": "Modifica dello stato del prodotto",
  "text2832": "Cancellazione dello stato del prodotto",
  "text2833": "Creazione etichetta prodotto",
  "text2834": "Modifica etichetta prodotto",
  "text2835": "Eliminazione etichetta prodotto",
  "text2836": "Creazione di un prodotto regalo",
  "text2837": "Modifica di un prodotto regalo",
  "text2838": "Eliminazione di un prodotto regalo",
  "text2839": "Creazione di un regalo",
  "text2840": "Modifica di un regalo",
  "text2841": "Eliminazione di un regalo",
  "text2842": "Creazione del prodotto per l'azione",
  "text2843": "Modifica del prodotto per l'azione",
  "text2844": "Eliminazione del prodotto per la promozione",
  "text2845": "Creare azione",
  "text2846": "Modifica azione",
  "text2847": "Eliminazione dell'azione",
  "text2848": "Creazione del prezzo delle azioni",
  "text2849": "Adeguamento del prezzo delle azioni",
  "text2850": "Eliminazione del prezzo delle azioni",
  "text2851": "Creazione di un'opzione di servizio",
  "text2852": "Opzione di servizio di modifica",
  "text2853": "Eliminazione di un'opzione di servizio",
  "text2854": "Creazione del prezzo dell'opzione di servizio",
  "text2855": "Adeguamento del prezzo dell'opzione di servizio",
  "text2856": "Eliminazione del prezzo dell'opzione di servizio",
  "text2857": "Creazione del metodo di pagamento",
  "text2858": "Modifica del metodo di pagamento",
  "text2859": "Eliminazione del metodo di pagamento",
  "text2860": "Creazione del prezzo del metodo di pagamento",
  "text2861": "Modifica del prezzo del metodo di pagamento",
  "text2862": "Eliminazione del prezzo del metodo di pagamento",
  "text2863": "Creazione dello sconto sul metodo di pagamento",
  "text2864": "Modifica dello sconto sul metodo di pagamento",
  "text2865": "Eliminazione dello sconto sul metodo di pagamento",
  "text2866": "Creazione di un metodo di trasporto",
  "text2867": "Rettifica del metodo di trasporto",
  "text2868": "Eliminazione del metodo di trasporto",
  "text2869": "Creazione del prezzo del metodo di spedizione",
  "text2870": "Modifica del prezzo del metodo di spedizione",
  "text2871": "Eliminazione del prezzo del metodo di spedizione",
  "text2872": "Creazione di un punto di erogazione",
  "text2873": "Modifica punto di erogazione",
  "text2874": "Eliminazione di un punto di erogazione",
  "text2875": "Creazione di un multiprogetto",
  "text2876": "Modifica multiprogetto",
  "text2877": "Cancellazione multiprogetto",
  "text2878": "Creazione di una regione",
  "text2879": "Modifica regione",
  "text2880": "Elimina regione",
  "text2881": "Creazione della lingua",
  "text2882": "Modifica della lingua",
  "text2883": "Cancellazione lingua",
  "text2884": "Creazione di moneta",
  "text2885": "Adeguamento valutario",
  "text2886": "Cancellazione valuta",
  "text2887": "Creazione della terra",
  "text2888": "Modifica del paesaggio",
  "text2889": "Cancella paese",
  "text2890": "Creazione di un menu",
  "text2891": "Modifica del menu",
  "text2892": "Cancellazione del menu",
  "text2893": "Creazione di una voce di menu",
  "text2894": "Modifica voce di menu",
  "text2895": "Elimina voce di menu",
  "text2896": "Creazione di un modello di email",
  "text2897": "Modifica del modello di posta elettronica",
  "text2898": "Eliminazione di un modello di email",
  "text2899": "Creazione dell'IVA",
  "text2900": "Adeguamento IVA",
  "text2901": "Eliminazione IVA",
  "text2902": "Creazione del tipo commercio all'ingrosso",
  "text2903": "Modifica del tipo all'ingrosso",
  "text2904": "Eliminazione tipo vendita all'ingrosso",
  "text2905": "Creazione di commercio all'ingrosso",
  "text2906": "Rettifica commercio all'ingrosso",
  "text2907": "Eliminazione commercio all'ingrosso",
  "text2908": "Creazione dell'indirizzo di vendita all'ingrosso",
  "text2909": "Modifica indirizzo di vendita all'ingrosso",
  "text2910": "Eliminazione indirizzo di vendita all'ingrosso",
  "text2911": "Crea un dominio all'ingrosso",
  "text2912": "Modifica del dominio all'ingrosso",
  "text2913": "Eliminazione del dominio all'ingrosso",
  "text2914": "Creazione di un reclamo",
  "text2915": "Rettifica del reclamo",
  "text2916": "Eliminazione del reclamo",
  "text2917": "Creazione del motivo di un reclamo",
  "text2918": "Modifica del motivo del reclamo",
  "text2919": "Cancellazione del motivo del reclamo",
  "text2920": "Creazione dello stato del reclamo",
  "text2921": "Adeguamento dello stato del reclamo",
  "text2922": "Eliminazione dello stato del reclamo",
  "text2923": "Creazione della pagina",
  "text2924": "Modifica della pagina",
  "text2925": "Eliminazione pagina",
  "text2926": "Creazione banner",
  "text2927": "Modifica banner",
  "text2928": "Eliminazione banner",
  "text2929": "Creazione di genere",
  "text2930": "Adeguamento del genere",
  "text2931": "Cancellazione del genere",
  "text2932": "Creazione di un prodotto blog",
  "text2933": "Modifica del prodotto in blog",
  "text2934": "Eliminazione del prodotto per il blog",
  "text2935": "Crea un blog",
  "text2936": "Modifica del blog",
  "text2937": "Eliminazione del blog",
  "text2938": "Creazione della categoria blog",
  "text2939": "Modifica categoria blog",
  "text2940": "Eliminazione categoria blog",
  "text2941": "Creazione di un post su un social network",
  "text2942": "Modifica di un post su un social network",
  "text2943": "Eliminazione di un post su un social network",
  "text2944": "Creazione di una rete sociale",
  "text2945": "Modifica di un social network",
  "text2946": "Eliminazione del social network",
  "text2947": "Creazione di newsletter",
  "text2948": "Modifica della newsletter",
  "text2949": "Eliminazione della newsletter",
  "text2950": "Creazione di posta di massa",
  "text2951": "Modifica della posta in massa",
  "text2952": "Eliminazione della posta in blocco",
  "text2953": "Creazione di etichette per newsletter",
  "text2954": "Modifica dell'etichetta della newsletter",
  "text2955": "Eliminazione etichetta newsletter in corso",
  "text2956": "Creazione di una newsletter via email",
  "text2957": "Modifica dell'e-mail della newsletter",
  "text2958": "Eliminazione dell'e-mail della newsletter",
  "text2959": "Creazione di punti fedeltà",
  "text2960": "Modifica dei punti fedeltà",
  "text2961": "Eliminazione punti fedeltà",
  "text2962": "Creazione di una risposta alla consultazione",
  "text2963": "Adeguamento della risposta dell'ufficio di consulenza",
  "text2964": "Eliminazione della risposta dell'ufficio di consulenza",
  "text2965": "Istituzione di una sala di consultazione",
  "text2966": "Modifica dello studio",
  "text2967": "Eliminazione dello studio in corso",
  "text2968": "Creazione della categoria di riferimento",
  "text2969": "Modifica della categoria di riferimento",
  "text2970": "Eliminazione della categoria di riferimento",
  "text2971": "Creazione del riferimento",
  "text2972": "Riferimento modifica",
  "text2973": "Eliminazione riferimento",
  "text2974": "Creazione del servizio",
  "text2975": "Modifica del servizio",
  "text2976": "Eliminazione servizio",
  "text2977": "Creazione del prezzo del servizio",
  "text2978": "Adeguamento del prezzo del servizio",
  "text2979": "Eliminazione del prezzo del servizio",
  "text2980": "Creare una carriera",
  "text2981": "Modifica carriera",
  "text2982": "Cancellazione carriera",
  "text2983": "Creazione dell'informativa obbligatoria",
  "text2984": "Regolamento sull'obbligo di comunicazione",
  "text2985": "Eliminazione dell'informativa obbligatoria",
  "text2986": "Creazione di gallerie",
  "text2987": "Galleria di modifica",
  "text2988": "Eliminazione galleria",
  "text2989": "Creazione di un membro del team",
  "text2990": "Modifica di un membro del team",
  "text2991": "Eliminazione di un membro del team",
  "text2992": "Creazione del cliente per l'abbonamento",
  "text2993": "Modifica cliente in abbonamento",
  "text2994": "Eliminazione di un cliente in abbonamento",
  "text2995": "Creazione della categoria di abbonamento",
  "text2996": "Modifica categoria di abbonamento",
  "text2997": "Eliminazione della categoria di abbonamento",
  "text2998": "Creazione del tipo di abbonamento",
  "text2999": "Modifica tipo di abbonamento",
  "text3000": "Eliminazione del tipo di abbonamento",
  "text3001": "Creazione del prezzo del tipo di abbonamento",
  "text3002": "Adeguamento del prezzo del tipo di abbonamento",
  "text3003": "Eliminazione del prezzo del tipo di abbonamento",
  "text3004": "Creazione dell'abbonamento",
  "text3005": "Modifica abbonamento",
  "text3006": "Eliminazione abbonamento",
  "text3007": "Modifica dell'API di configurazione",
  "text3008": "Creazione dello stato dell'ordine",
  "text3009": "Modifica dello stato dell'ordine",
  "text3010": "Eliminazione dello stato dell'ordine",
  "text3011": "Creazione dell'impostazione dello stato dell'ordine",
  "text3012": "Modifica l'impostazione dello stato dell'ordine",
  "text3013": "Cancellazione dell'impostazione dello stato dell'ordine",
  "text3014": "Creazione di un ordine",
  "text3015": "Modifica ordine",
  "text3016": "Eliminazione ordine",
  "text3017": "Creazione della spedizione dell'ordine",
  "text3018": "Rettifica spedizione ordine",
  "text3019": "Eliminazione della spedizione dell'ordine",
  "text3020": "Creazione icona",
  "text3021": "Icona Modifica",
  "text3022": "Icona di eliminazione",
  "text3023": "Creazione di un rifugio",
  "text3024": "Adeguamento del rifugio",
  "text3025": "Sgombero del rifugio",
  "text3026": "Creazione del tipo di recensione",
  "text3027": "Modifica del tipo di recensione",
  "text3028": "Rimozione del tipo di recensione",
  "text3029": "Creazione recensione",
  "text3030": "Modifica recensione",
  "text3031": "Rimozione recensione",
  "text3032": "Creazione di configurazioni",
  "text3033": "Modifica configurazioni",
  "text3034": "Eliminazione delle configurazioni",
  "text3035": "Creazione seo",
  "text3036": "Modifica seo",
  "text3037": "Eliminazione seo",
  "text3038": "Creazione del reindirizzamento",
  "text3039": "Modifica reindirizzamento",
  "text3040": "Cancellazione reindirizzamento",
  "text3041": "Creazione di un servizio di calcolatrice",
  "text3042": "Modifica del servizio calcolatrice",
  "text3043": "Eliminazione del servizio calcolatrice",
  "text3044": "Creazione del prezzo del servizio calcolatrice",
  "text3045": "Rettifica prezzo servizio calcolatrice",
  "text3046": "Eliminazione del prezzo del servizio di calcolatrice",
  "text3047": "Creazione di informazioni aggiuntive sulla calcolatrice",
  "text3048": "Modifica delle informazioni aggiuntive della calcolatrice",
  "text3049": "Cancellazione di informazioni aggiuntive sulla calcolatrice",
  "text3050": "Creazione di valore grazie alle informazioni aggiuntive della calcolatrice",
  "text3051": "Modifica del valore delle informazioni aggiuntive della calcolatrice",
  "text3052": "Cancellazione del valore delle informazioni aggiuntive della calcolatrice",
  "text3053": "Creazione del prezzo del valore delle informazioni aggiuntive del calcolatore",
  "text3054": "Modifica del prezzo del valore delle informazioni aggiuntive del calcolatore",
  "text3055": "Cancellazione del valore del prezzo delle informazioni aggiuntive del calcolatore",
  "text3056": "Creazione di un prodotto calcolatrice",
  "text3057": "Modifica del prodotto Calcolatrice",
  "text3058": "Eliminazione del prodotto calcolatrice",
  "text3059": "Creazione di un calcolatore del prezzo del prodotto",
  "text3060": "Calcola l'adeguamento del prezzo del prodotto",
  "text3061": "Calcola il prezzo del prodotto calcolatore di compensazione",
  "text3062": "Creazione di un ordine per la calcolatrice",
  "text3063": "Modifica dell'ordine del calcolatore",
  "text3064": "Eliminazione dell'ordine della calcolatrice",
  "text3065": "Creazione del valore dell'ordine della calcolatrice",
  "text3066": "Regolazione del valore dell'ordine del calcolatore",
  "text3067": "Cancellazione del valore dell'ordine della calcolatrice",
  "text3068": "Creazione di un servizio di ordinazione calcolatrici",
  "text3069": "Modifica del servizio di ordinazione calcolatrici",
  "text3070": "Eliminazione del servizio di ordinazione calcolatrici",
  "text3071": "Modifica configurazione agenzia di viaggio",
  "text3072": "Modifica della configurazione della newsletter",
  "text3073": "Modifica della configurazione della posta in blocco",
  "text3074": "Modifica configurazione programma fedeltà",
  "text3075": "Modifica della configurazione del carrello abbandonato",
  "text3076": "Modifica della configurazione SEO",
  "text3077": "Creazione dello status di prescrizione elettronica",
  "text3078": "Modifica dello status della prescrizione elettronica",
  "text3079": "Cancellazione dello stato della prescrizione elettronica",
  "text3080": "Creazione di prescrizione elettronica",
  "text3081": "Modifica della prescrizione elettronica",
  "text3082": "Eliminazione di una prescrizione elettronica",
  "text3083": "Creazione dello stato di prenotazione dei farmaci",
  "text3084": "Modifica dello stato di prenotazione dei farmaci",
  "text3085": "Eliminazione dello stato di prenotazione dei farmaci",
  "text3086": "Creazione del prodotto di prenotazione del farmaco",
  "text3087": "Modifica del prodotto di prenotazione del farmaco",
  "text3088": "Eliminazione del prodotto di prenotazione del farmaco",
  "text3089": "Creazione di una prenotazione di farmaci",
  "text3090": "Modifica della prenotazione dei farmaci",
  "text3091": "Cancellazione della prenotazione dei farmaci",
  "text3092": "Creazione del servizio di prenotazione",
  "text3093": "Modifica del servizio di prenotazione",
  "text3094": "Eliminazione del servizio di prenotazione",
  "text3095": "Creazione del prezzo del servizio di prenotazione",
  "text3096": "Adeguamento del prezzo del servizio di prenotazione",
  "text3097": "Eliminazione del prezzo del servizio di prenotazione",
  "text3098": "Creazione di un programma di prenotazione automatica",
  "text3099": "Modifica del programma di prenotazione automatica",
  "text3100": "Eliminazione del programma di prenotazione automatica",
  "text3101": "Creazione dell'orario di prenotazione",
  "text3102": "Regolazione dell'orario di prenotazione",
  "text3103": "Eliminazione dell'orario di prenotazione",
  "text3104": "Creazione persona prenotazione",
  "text3105": "Modifica persona prenotata",
  "text3106": "Eliminazione di una persona prenotata",
  "text3107": "Creazione della prenotazione",
  "text3108": "Modifica prenotazione",
  "text3109": "Eliminazione prenotazione",
  "text3110": "Configurazione delle impostazioni generali",
  "text3111": "L'accesso è riuscito",
  "text3112": "Il tuo account è stato collegato con successo.",
  "text3113": "Ora puoi chiudere in sicurezza questa finestra: il risultato è stato inviato all'applicazione.",
  "text3114": "Chiudi la finestra",
  "text3115": "Chiudi questa finestra manualmente.",
  "text3116": "Seguici su Instagram",
  "text3117": "Il collegamento è stato copiato con successo negli appunti",
  "text3118": "L'abbonamento sta per scadere",
  "text3119": "Le modifiche al profilo sono state salvate con successo",
  "text3120": "Il profilo è stato creato con successo",
  "text3121": "Ci stiamo preparando",
  "text3122": "Non hai un abbonamento attivo",
  "text3123": "Acquista un abbonamento di 1 anno e ottieni accesso illimitato a tutti i corsi online e uno sconto del 10% sugli eventi!",
  "text3124": "Acquista un abbonamento",
  "text3125": "I miei prodotti",
  "text3126": "Presidenza dell'associazione SEDMA",
  "text3127": "Hai già acquistato un abbonamento.",
  "text3128": "Vai ai corsi",
  "text3129": "Puoi trovare i documenti dell'ordine nel tuo profilo",
  "text3130": "Questo prodotto non è disponibile nel nostro e-shop",
  "text3131": "Ricerca informazioni sul prodotto...",
  "text3132": "Questo prodotto non è disponibile nel nostro e-shop",
  "text3133": "Creazione della categoria regalo",
  "text3134": "Modifica categoria regalo",
  "text3135": "Eliminazione categoria regalo",
  "text3136": "Il regalo è già stato assegnato",
  "text3137": "Il regalo non è consentito per questo prodotto",
  "text3138": "Acquista corsi nei nostri eventi.",
  "text3139": "L'e-mail di conferma è stata inviata con successo",
  "text3140": "Il collegamento per la reimpostazione della password non è valido",
  "text3141": "Cerca nei campi",
  "text3142": "Ricerca esatta",
  "text3143": "L'ordine è stato annullato",
  "text3144": "L'ordine di pagamento è stato annullato e non è stato eseguito.",
  "text3145": "Sei stato disconnesso",
  "text3146": "Qualcuno ha effettuato l'accesso al tuo account da un altro dispositivo.",
  "text3147": "Modifica della configurazione dello studio",
  "text3148": "Creazione dell'inventario",
  "text3149": "Modifica archiviazione",
  "text3150": "Eliminazione spazio di archiviazione",
  "text3151": "Creazione di un articolo di inventario",
  "text3152": "Modifica articolo di inventario",
  "text3153": "Eliminazione articolo di inventario",
  "text3154": "Il file è già stato elaborato in passato",
  "text3155": "Creazione dell'acquisto del giorno",
  "text3156": "Modifica acquisto del giorno",
  "text3157": "Elimina l'acquisto del giorno",
  "text3158": "Creazione dell'articolo di acquisto del giorno",
  "text3159": "Modifica dell'articolo acquistato del giorno",
  "text3160": "Eliminazione dell'articolo acquistato del giorno",
  "text3161": "Mostra tutto",
  "text3162": "Creazione di uno sconto sull'acquisto dell'articolo giornaliero",
  "text3163": "Rettifica dell'acquisto dello sconto articolo giornaliero",
  "text3164": "Eliminazione dello sconto dell'articolo acquistato in giornata",
  "text3165": "Creazione di un gruppo di prodotti",
  "text3166": "Modifica del gruppo di prodotti",
  "text3167": "Eliminazione di un gruppo di prodotti",
  "text3168": "Creazione di uno sconto per un gruppo di prodotti",
  "text3169": "Modifica lo sconto del gruppo di prodotti",
  "text3170": "Eliminazione di uno sconto per un gruppo di prodotti",
  "text3171": "Il regalo è stato aggiunto all'ordine",
  "text3172": "Il regalo è già stato aggiunto all'ordine",
  "text3173": "Creazione della categoria di trasporto",
  "text3174": "Modifica della categoria di trasporto",
  "text3175": "Eliminazione categoria di trasporto",
  "text3176": "Creazione della categoria del prezzo di spedizione",
  "text3177": "Modifica del prezzo di spedizione della categoria",
  "text3178": "Eliminazione della categoria del prezzo di spedizione",
  "text3179": "Nome / Ragione sociale",
  "text3180": "Parametri del prodotto",
  "text3181": "Inserisci il tuo indirizzo email e ti invieremo un collegamento per reimpostare la password.",
  "text3182": "Creazione di un account",
  "text3183": "Ancora password",
  "text3184": "Numero di riferimento",
  "text3185": "Torna al login",
  "text3186": "Prodotti scontati",
  "text3187": "Vendita completa",
  "text3188": "Acquisto del giorno",
  "text3189": "minuti",
  "text3190": "ora",
  "text3191": "ore",
  "text3192": "ore",
  "text3193": "secondo",
  "text3194": "secondi",
  "text3195": "secondi",
  "text3196": "L'azione scade il",
  "text3197": "minuti",
  "text3198": "Acquista questo prodotto",
  "text3199": "Iscriviti per ricevere notizie e sconti.",
  "text3200": "Hai iniziato con successo l'iscrizione alla newsletter",
  "text3201": "Hai effettuato l'accesso. Puoi trovare tutti i tuoi ordini nel tuo profilo.",
  "text3202": "Scarica il listino prezzi",
  "text3203": "Inviaci un fax",
  "text3204": "Correzione",
  "text3205": "Collegamento bancario (EUR)",
  "text3206": "I nostri distributori",
  "text3207": "clienti soddisfatti",
  "text3208": "Il tuo account è stato creato con successo!",
  "text3209": "Carica altri articoli",
  "text3210": "Hai bisogno di un consiglio? Non esitate a contattarci tramite il modulo di contatto o direttamente tramite telefono ed e-mail.",
  "text3211": "Contattaci, saremo lieti di consigliarti",
  "text3212": "Informazioni su fatturazione e consegna",
  "text3213": "Creazione del prezzo di spedizione del prodotto",
  "text3214": "Modifica del prezzo di spedizione del prodotto",
  "text3215": "Eliminazione del prezzo di spedizione del prodotto",
  "text3216": "Il coupon inserito non esiste",
  "text3217": "Ho un buono sconto",
  "text3218": "Grazie per il numero dell'ordine",
  "text3219": "Ti abbiamo inviato la conferma dell'ordine all'indirizzo e-mail che hai inserito.",
  "text3220": "Nessun prodotto trovato",
  "text3221": "Articoli interessanti",
  "text3222": "Rimosso",
  "text3223": "Annulla iscrizione",
  "text3224": "Vuoi davvero cancellarti dalla newsletter?",
  "text3225": "L'iscrizione alla newsletter è stata annullata",
  "text3226": "Annulla l'iscrizione alla newsletter",
  "text3227": "Con ogni ordine",
  "text3228": "Incluso",
  "text3229": "Ordine da",
  "text3230": "Con ogni ordine",
  "text3231": "Cosa dicono i nostri clienti soddisfatti?",
  "text3232": "Scaduto",
  "text3233": "Per accedere all'area membri devi essere",
  "text3234": "ha effettuato l'accesso",
  "text3235": "Se non sei registrato, clicca sul link",
  "text3236": "Registrazione.",
  "text3237": "Hai dimenticato la password?",
  "text3238": "Sfoglia categoria",
  "text3239": "Prodotti promozionali",
  "text3240": "Offerta attuale di tour",
  "text3241": "Menu",
  "text3242": "Il prodotto è stato aggiunto al carrello",
  "text3243": "Creazione fornitore variante",
  "text3244": "Modifica del fornitore della variante",
  "text3245": "Eliminazione fornitore variante",
  "text3246": "Creazione della variante prezzo fornitore",
  "text3247": "Rettifica prezzo fornitore variante",
  "text3248": "Eliminazione prezzo fornitore variante",
  "text3249": "Il coupon non è valido",
  "text3250": "Le informazioni sulle opzioni di reso e sui reclami sui prodotti sono disponibili sul sito web",
  "text3251": "Resi e reclami",
  "text3252": "Tempo di operatività della linea cliente",
  "text3253": "Lun-ven: 8:30 - 17:00",
  "text3254": "Più di",
  "text3255": "Mostra tutti i servizi",
  "text3256": "Nascondi",
  "text3257": "Regali per il prodotto",
  "text3258": "Regalo con l'acquisto",
  "text3259": "Calcola i rimborsi",
  "text3260": "recensioni verificate",
  "text3261": "Motivo del contatto",
  "text3262": "Autenticazione non valida. Per favore riprova",
  "text3263": "Il numero di telefono è obbligatorio",
  "text3264": "Iscrivendoti accetti",
  "text3265": "Azione",
  "text3266": "Consegna veloce",
  "text3267": "Consegna gratuita veloce e sicura per ordini superiori a €100.",
  "text3268": "Opzioni di consegna",
  "text3269": "30 giorni per il reso",
  "text3270": "Non sei soddisfatto del prodotto? Hai 30 giorni per restituire l'articolo e ottenere un rimborso.",
  "text3271": "Opzioni di pagamento",
  "text3272": "Cliente",
  "text3273": "Tasso di clientela",
  "text3274": "Mancano ore",
  "text3275": "Stato dell'abbonamento",
  "text3276": "L'abbonamento è attivato",
  "text3277": "L'abbonamento non è attivato",
  "text3278": "Scade",
  "text3279": "E-mail di fatturazione",
  "text3280": "Dirigente responsabile (dirigente)",
  "text3281": "Vai all'indirizzo",
  "text3282": "Collegamento bancario",
  "text3283": "Reclamo n.:",
  "text3284": "Data del reclamo",
  "text3285": "Data di acquisto",
  "text3286": "Firma del cliente",
  "text3287": "Firma del venditore",
  "text3288": "giorno",
  "text3289": "Descrizione dettagliata del difetto e dello stato della merce",
  "text3290": "Accessori in dotazione",
  "text3291": "Oggetto del reclamo",
  "text3292": "Prova d'acquisto",
  "text3293": "Confezione originale",
  "text3294": "Elaborazione del reclamo n.:",
  "text3295": "Data di fine",
  "text3296": "Maggiori specifiche della riparazione eseguita",
  "text3297": "Creazione di un registro degli incidenti",
  "text3298": "Modifica della registrazione degli incidenti",
  "text3299": "Cancellazione della registrazione dell'incidente",
  "text3300": "Tempo di operatività della linea cliente",
  "text3301": "Recensioni Google",
  "text3302": "Iscriviti per ricevere notizie",
  "text3303": "Informati in tempo sui nostri sconti e promozioni.",
  "text3304": "Cerca un tour",
  "text3305": "Cerca un tour",
  "text3306": "Mostra tutti i tour",
  "text3307": "Sono interessato ad un tour su misura",
  "text3308": "Cosa possiamo offrirti",
  "text3309": "Destinazione",
  "text3310": "Quanti di voi vorrebbero viaggiare",
  "text3311": "Quale termine ti si addice meglio",
  "text3312": "Termine preferito",
  "text3313": "La tua richiesta per un tour su misura è stata inviata con successo",
  "text3314": "Al momento non supportiamo la funzionalità",
  "text3315": "File non trovati",
  "text3316": "Catalogo prodotti",
  "text3317": "Valutato",
  "text3318": "più di 1000 clienti",
  "text3319": "Vai all'e-shop",
  "text3320": "Scarica l'e-book gratuitamente",
  "text3321": "Modifica della configurazione dei regali",
  "text3322": "Scrivici una email",
  "text3323": "I nostri articoli interessanti",
  "text3324": "Non sei ancora registrato?",
  "text3325": "Ecco cosa ti stai perdendo:",
  "text3326": "Iscriviti",
  "text3327": "Documenti GRATUITI",
  "text3328": "Documenti pagati",
  "text3329": "Non hai trovato la risposta alla domanda? Mettiti in contatto con noi direttamente tramite contatto.",
  "text3330": "Registrazione malattie professionali, eventi pericolosi, infortuni sul lavoro",
  "text3331": "Leggi e regolamenti in materia di salute e sicurezza",
  "text3332": "Primo soccorso in caso di pericolo di vita",
  "text3333": "Piano traumatologico",
  "text3334": "Registri, ispezioni e rapporti",
  "text3335": "Direttive e Leggi",
  "text3336": "Termini di attrezzatura tecnica",
  "text3337": "Protocollo sulla formazione dei dipendenti",
  "text3338": "Esempi di documenti",
  "text3339": "Ispezione e Procedure",
  "text3340": "Certificato",
  "text3341": "Modifica della configurazione di marketing",
  "text3342": "Creazione della categoria di prenotazione",
  "text3343": "Modifica categoria di prenotazione",
  "text3344": "Eliminazione della categoria di prenotazione",
  "text3345": "Hai un account? Accedi e inseriremo i dati per te.",
  "text3346": "Hai effettuato l'accesso con successo",
  "text3347": "Ottieni i seguenti vantaggi come parte della tua iscrizione",
  "text3348": "Utilizza coupon",
  "text3349": "Protezione completa",
  "text3350": "ciò che conta di più per te",
  "text3351": "Compila il modulo e ti ricontatteremo.",
  "text3352": "Il tuo messaggio/interesse",
  "text3353": "Inviando un messaggio accetti",
  "text3354": "per scopi di contatto.",
  "text3355": "Continua a leggere",
  "text3356": "Reclamo",
  "text3357": "Recesso dal contratto",
  "text3358": "Recesso dal contratto e reclamo della merce",
  "text3359": "mostra tutto",
  "text3360": "lettura min",
  "text3361": "Non hai trovato la risposta alla tua domanda? Contattaci telefonicamente o tramite email e saremo felici di risponderti.",
  "text3362": "Ulteriori informazioni su Sonicube",
  "text3363": "Diventa partner",
  "text3364": "Modifica della configurazione dei promemoria",
  "text3365": "Modifica la configurazione della pianificazione dei promemoria",
  "text3366": "Creazione promemoria",
  "text3367": "Modifica promemoria",
  "text3368": "Eliminazione promemoria",
  "text3369": "Iscrivendoti alla newsletter, accetti",
  "text3370": "per scopi di marketing e newsletter.",
  "text3371": "Compila il modulo e ti ricontatteremo\nentro 24 ore.",
  "text3372": "Numero di giorni di scadenza",
  "text3373": "Data assegnata per il recupero",
  "text3374": "Un regalo per il prodotto",
  "text3375": "Hai bisogno di informazioni sui prodotti o sul tuo ordine?",
  "text3376": "La nota è già stata inviata al cliente",
  "text3377": "Cerca",
  "text3378": "Altre foto",
  "text3379": "Operazione fallita",
  "text3380": "Modalità di consegna",
  "text3381": "Descrizione del difetto",
  "text3382": "Il tuo account è stato creato con successo!",
  "text3383": "Ti abbiamo inviato all'indirizzo e-mail che hai inserito",
  "text3384": "Reimposta filtro",
  "text3385": "L'ordine è stato inviato con successo",
  "text3386": "Abbiamo registrato con successo il tuo ordine. Riceverai una conferma all'indirizzo email inserito durante l'ordine.",
  "text3387": "Iscriviti e ricevi consigli su come supportare la rigenerazione e la salute.",
  "text3388": "Reclami",
  "text3389": "per scopi di marketing.",
  "text3390": "Cliente aziendale",
  "text3391": "Leggi l'articolo",
  "text3392": "Ho una domanda",
  "text3393": "prodotto EAN",
  "text3394": "Creazione di tipi di gruppi di prodotti",
  "text3395": "Modifica del tipo di gruppi di prodotti",
  "text3396": "Eliminazione del tipo di gruppi di prodotti",
  "text3397": "Aggiungi una recensione",
  "text3398": "Obbligo fiscale",
  "text3399": "Valutazione del prodotto",
  "text3400": "Valuta questo prodotto",
  "text3401": "La registrazione è avvenuta con successo",
  "text3402": "Ti abbiamo inviato un'e-mail di verifica all'indirizzo e-mail che hai inserito.",
  "text3403": "Descrizione del testo",
  "text3404": "allo scopo di elaborare le valutazioni dei prodotti.",
  "text3405": "Il tuo codice",
  "text3406": "Per il pagamento",
  "text3407": "Torna alla spedizione e al pagamento",
  "text3408": "Ordine con obbligo di pagamento",
  "text3409": "Fantastico! L'ordine è in arrivo",
  "text3410": "Grazie per averci scelto.",
  "text3411": "Troverai la conferma dell'ordine nella tua email e ti terremo informato sul suo stato",
  "text3412": "Hai un account con noi?",
  "text3413": "Accedi e inseriremo i dati per te.",
  "text3414": "Ordine",
  "text3415": "Password corrente",
  "text3416": "Ti abbiamo inviato una conferma di modifica della password all'indirizzo e-mail inserito.",
  "text3417": "Cerca il prodotto",
  "text3418": "Certificati",
  "text3419": "I miei progetti",
  "text3420": "Nessuna integrazione SMS è attiva",
  "text3421": "Errore durante la convalida dei limiti SMS",
  "text3422": "Impossibile verificare lo stato del credito SMS. Controlla la configurazione",
  "text3423": "Credito SMS insufficiente",
  "text3424": "Riepilogo dei promemoria inviati",
  "text3425": "i seguenti promemoria sono stati inviati ai clienti",
  "text3426": "Estrazione del documento avviata. Riceverai una notifica al termine",
  "text3427": "Programma una consulenza",
  "text3428": "Possiamo aiutarti anche in questo",
  "text3429": "Per gli studenti",
  "text3430": "offerta",
  "text3431": "Ci troverai",
  "text3432": "L'offerta è stata aggiunta ai preferiti",
  "text3433": "Modifica della configurazione del documento",
  "text3434": "Numero di offerte",
  "text3435": "Altre offerte",
  "text3436": "L'offerta è stata modificata",
  "text3437": "L'offerta è stata creata",
  "text3438": "Aiuto con l'ordinazione",
  "text3439": "Vedi tutto",
  "text3440": "posizioni aperte",
  "text3441": "Posizioni",
  "text3442": "L'ordine è già stato pagato",
  "text3443": "Una fattura è anche una bolla di consegna.",
  "text3444": "Prodotti",
  "text3445": "Generato dall'intelligenza artificiale",
  "text3446": "mensile",
  "text3447": "Visualizza CV completo",
  "text3448": "Perché taggare un'immagine AI?",
  "text3449": "Spuntando confermi che l'immagine è stata creata dall'intelligenza artificiale.\n        In questo modo ci aiuti a rispettare la legge sull’AI e ad aumentare la trasparenza per i candidati.",
  "text3450": "La responsabilità della corretta etichettatura dei contenuti generati dall'intelligenza artificiale spetta all'inserzionista.",
  "text3451": "I contenuti AI non contrassegnati possono essere successivamente modificati o rimossi da un moderatore.",
  "text3452": "Non hai trovato la risposta alla domanda?",
  "text3453": "Contattaci e ti risponderemo il prima possibile.",
  "text3454": "Anno di nascita",
  "text3455": "La data di nascita serve esclusivamente a verificare l'età legale dell'utente e ad assicurare il rispetto dei requisiti di legge. Questi dati non vengono utilizzati per altri scopi",
  "text3456": "Seleziona file",
  "text3457": "Il numero massimo di file è",
  "text3458": "La dimensione massima del file è 2 MB",
  "text3459": "Errore durante il caricamento del file",
  "text3460": "Modalità di pagamento",
  "text3461": "Forme di consegna",
  "text3462": "Non perdere nessuna novità e le vendite attuali!",
  "text3463": "Iscriviti alla nostra newsletter per ricevere novità",
  "text3464": "La tua email",
  "text3465": "Numero di valutazioni",
  "text3466": "Questo prodotto non ha recensioni.",
  "text3467": "Dettagli di consegna",
  "text3468": "Compila un'e-mail per inviare un collegamento per la reimpostazione della password.",
  "text3469": "I nostri articoli",
  "text3470": "Vendita",
  "text3471": "Non hai accesso ai CV",
  "text3472": "Questa sezione è disponibile per gli account aziendali con accesso CV prepagato.",
  "text3473": "Visualizza listino prezzi",
  "text3474": "L'accesso ai curriculum è disponibile solo per gli account aziendali.",
  "text3475": "Intera categoria",
  "text3476": "Nascondi telefono",
  "text3477": "Elenco delle posizioni",
  "text3478": "La sequenza selezionata non è applicabile al tipo di documento",
  "text3479": "Apri cestino",
  "text3480": "Sconti sulla quantità",
  "text3481": "Acquista l'accesso ai curriculum",
  "text3482": "Accesso ai CV",
  "text3483": "Per le aziende",
  "text3484": "Pubblicazione di un'offerta di lavoro",
  "text3485": "In cima all'offerta",
  "text3486": "Offerta a tempo limitato",
  "text3487": "Il coupon scade il",
  "text3488": "Iscriviti alla newsletter e ottieni uno sconto!",
  "text3489": "Notizie, tendenze attuali ed eventi direttamente nella tua email. L'abbonamento prevede un buono sconto. Esci in qualsiasi momento gratuitamente.",
  "text3490": "No grazie, non voglio sconti",
  "text3491": "Ottieni coupon",
  "text3492": "Al momento dell'ordine sopra",
  "text3493": "Per tutti gli ordini",
  "text3494": "Il coupon è stato inviato alla tua email",
  "text3495": "Ottieni il coupon",
  "text3496": "Ricevi informazioni su nuovi prodotti e sconti tra i primi.",
  "text3497": "Consegna",
  "text3498": "Scopri il concetto",
  "text3499": "Diventa un partner",
  "text3500": "Scopri le possibilità di cooperazione",
  "text3501": "punti",
  "text3502": "Numero di punti guadagnati per l'acquisto di 1 €",
  "text3503": "Valore di un punto",
  "text3504": "Sconto massimo in percentuale per ordine",
  "text3505": "Se desideri utilizzare il programma fedeltà, effettua il login",
  "text3506": "Riscatta tutti i punti",
  "text3507": "I punti fedeltà sono stati applicati",
  "text3508": "Applica",
  "text3509": "E-mail di accesso",
  "text3510": "Nessun allegato",
  "text3511": "valutazione",
  "text3512": "valutazioni",
  "text3513": "valutazioni",
  "text3514": "Scegli valutazione",
  "text3515": "Ulteriori informazioni qui",
  "text3516": "Mostra tutti i parametri",
  "text3517": "Sblocchi rimanenti",
  "text3518": "Tutti i dati saranno disponibili dopo aver sbloccato il curriculum.",
  "text3519": "Profilo bloccato",
  "text3520": "Profilo del candidato",
  "text3521": "Seleziona da 1 a 3 categorie/posizioni",
  "text3522": "Visualizza tutti i blog",
  "text3523": "Preventivo non vincolante",
  "text3524": "Stendardo principale",
  "text3525": "Diapositiva precedente",
  "text3526": "Un'altra diapositiva",
  "text3527": "Apri popup",
  "text3528": "Mostra riferimento sulla mappa",
  "text3529": "Pagina precedente",
  "text3530": "Pagina successiva",
  "text3531": "Vai alla pagina",
  "text3532": "Vai alla diapositiva",
  "text3533": "Anteprime precedenti",
  "text3534": "Visualizza più immagini",
  "text3535": "Altre anteprime",
  "text3536": "Richiedi una consulenza partner",
  "text3537": "Questa etichetta può essere utilizzata dai nostri partner",
  "text3538": "Creazione di domande frequenti",
  "text3539": "Modifica domande frequenti",
  "text3540": "Elimina le domande frequenti",
  "text3541": "Creazione di Schema.org",
  "text3542": "Modifica di Schema.org",
  "text3543": "Eliminazione di Schema.org",
  "text3544": "Compila il modulo e fissa una prima consulenza con il partner.",
  "text3545": "Creazione di un watchdog",
  "text3546": "Modifica del cane da guardia",
  "text3547": "Eliminazione del watchdog",
  "text3548": "Pacchetto HASQO",
  "text3549": "Ulteriori informazioni",
  "text3550": "Pacchetto",
  "text3551": "Il pacchetto contiene",
  "text3552": "Adatto per",
  "text3553": "Consultare",
  "text3554": "Nome dell'operazione",
  "text3555": "Città operativa",
  "text3556": "Tipo di operazione",
  "text3557": "Dimensione (m²)",
  "text3558": "Ora programmata",
  "text3559": "Tel. numero",
  "text3560": "I tuoi dati",
  "text3561": "La biografia è bloccata",
  "text3562": "CV è disponibile solo dopo l'acquisto. Dopo lo sblocco, verrà visualizzato il profilo completo del richiedente.",
  "text3563": "Cane da guardia",
  "text3564": "Il cane da guardia è stato creato con successo",
  "text3565": "Ti faremo sapere quando questo prodotto sarà di nuovo disponibile",
  "text3566": "Impossibile creare il watchdog",
  "text3567": "Inserisci la tua email per essere avvisato quando il prodotto sarà di nuovo disponibile",
  "text3568": "Cani da guardia",
  "text3569": "Il watchdog è stato rimosso",
  "text3570": "Impossibile rimuovere il watchdog",
  "text3571": "Non hai watchdog impostati",
  "text3572": "Condimenti gratuiti",
  "text3573": "Calcolatrice Quattro",
  "text3574": "Seleziona una presa GLS",
  "text3575": "Descrizione del progetto",
  "text3576": "A quale implementazione sei interessato?",
  "text3577": "Selezionare",
  "text3578": "Luogo di implementazione",
  "text3579": "Compila l'indirizzo",
  "text3580": "Data indicativa di attuazione",
  "text3581": "Nome / Azienda",
  "text3582": "Si prega di inserire il nome/nome dell'azienda",
  "text3583": "Inserisci la tua email",
  "text3584": "Compila il telefono",
  "text3585": "La tua nota",
  "text3586": "Nota",
  "text3587": "Inviando accetti",
  "text3588": "Conosci i nostri servizi",
  "text3589": "Mostra altre realizzazioni",
  "text3590": "Hai altre domande?",
  "text3591": "Hai un'altra domanda o non hai trovato la risposta?",
  "text3592": "Orario di lavoro",
  "text3593": "Su ordinazione",
  "text3594": "Materiali di qualità",
  "text3595": "Dettaglio dell'esecuzione",
  "text3596": "Il processo di realizzazione",
  "text3597": "per iscriversi alle notizie",
  "text3598": "Ricevi le informazioni più recenti da KAUFMANN.",
  "text3599": "La tua email",
  "text3600": "Iscrivendoti alla newsletter, accetti",
  "text3601": "Mostra sulla mappa",
  "text3602": "o",
  "text3603": "I nostri lavoratori sono a vostra disposizione in",
  "text3604": "giorni lavorativi dalle 8:00 alle 16:00",
  "text3605": "Magazzino",
  "text3606": "Carica più realizzazioni",
  "text3607": "Non abbiamo trovato alcun risultato in questa categoria",
  "text3608": "Creazione del prodotto più venduto",
  "text3609": "Modifica del prodotto più venduto",
  "text3610": "Eliminazione del prodotto più venduto",
  "text3611": "Rapporto",
  "text3612": "Motivo della segnalazione",
  "text3613": "Laurea",
  "text3614": "notti",
  "text3615": "Data del tour",
  "text3616": "Durata del tour",
  "text3617": "Prezzo da",
  "text3618": "Su richiesta",
  "text3619": "Mostra dettagli del tour",
  "text3620": "Posti vacanti",
  "text3621": "Sto aggiornando le date",
  "text3622": "Tutti i tour sono nascosti",
  "text3623": "Non ci sono tour disponibili per il periodo selezionato",
  "text3624": "Riduci",
  "text3625": "Schermo intero",
  "text3626": "Impossibile caricare le date",
  "text3627": "sottocategorie",
  "text3628": "Rimuovi la selezione",
  "text3629": "Report sulle offerte",
  "text3630": "Registrazione della società",
  "text3631": "Riportare la biografia",
  "text3632": "Impossibile inviare il rapporto",
  "text3633": "Il rapporto è stato inviato",
  "text3634": "biografie",
  "text3635": "biografie",
  "text3636": "Ordine in elaborazione",
  "text3637": "Casa",
  "text3638": "Crea il pagamento dell'ordine",
  "text3639": "Rettifica pagamento ordine",
  "text3640": "Eliminazione del pagamento dell'ordine",
  "text3641": "Diventa il nostro partner unico.",
  "text3642": "Iscriviti per ricevere notizie e informazioni su\naggiunte nuove funzionalità.",
  "text3643": "Nuove proprietà",
  "text3644": "Immobili a un prezzo premium",
  "text3645": "Riferimenti di clienti soddisfatti",
  "text3646": "Guarda cosa pensano di noi i nostri clienti.",
  "text3647": "Leggi articoli sulle attrazioni di Cipro",
  "text3648": "Tutte le foto",
  "text3649": "Condividi",
  "text3650": "Data di completamento",
  "text3651": "Descrizione dell'immobile",
  "text3652": "Visita della località",
  "text3653": "Genera PDF",
  "text3654": "Prenotazione del tour",
  "text3655": "Scelta di un termine per la consultazione online",
  "text3656": "Proprietà a Cipro Nord",
  "text3657": "Numero di stanze",
  "text3658": "Ufficio immobiliare",
  "text3659": "Immobiliare",
  "text3660": "Rivendita / Intercia pagata",
  "text3661": "Fissa un appuntamento per una consulenza",
  "text3662": "La chiamata Zoom dura massimo 1 ora e risponderemo a tutte le tue domande + riceverai\n              presentazione gratuita di tutti i progetti disponibili che abbiamo a Cipro.",
  "text3663": "Offerte",
  "text3664": "Hai altre domande? Saremo lieti di presentarvi nella pratica il concetto HASQO.",
  "text3665": "Richiedi una consulenza",
  "text3666": "Zona cliente",
  "text3667": "Spedizione",
  "text3668": "Consegna riuscita",
  "text3669": "Linea cliente",
  "text3670": "Voglio ricevere un preventivo",
  "text3671": "Iscrivendoti alla newsletter, accetti",
  "text3672": "Scegli dalle notizie",
  "text3673": "Acquista per categoria",
  "text3674": "Selezione di prodotti TOP",
  "text3675": "Iscriviti alla newsletter e ricevi sempre informazioni aggiornate su promozioni e novità.",
  "text3676": "Il tuo indirizzo email...",
  "text3677": "Garanzia di acquisto sicuro",
  "text3678": "Metodi di trasporto",
  "text3679": "Le nostre realizzazioni",
  "text3680": "Collezioni",
  "text3681": "Visualizza tutte le collezioni",
  "text3682": "Si fidano di noi",
  "text3683": "Verificato e ottenuto da Google",
  "text3684": "Tutte le recensioni",
  "text3685": "Verificato",
  "text3686": "Tutti i filtri",
  "text3687": "Nessun prodotto trovato",
  "text3688": "Profondità",
  "text3689": "Richiedi un preventivo per la tua spedizione",
  "text3690": "Web creato",
  "text3691": "dalle 9:00 alle 17:00",
  "text3692": "Informazioni sul servizio",
  "text3693": "Cosa comprende il servizio?",
  "text3694": "Per quali spedizioni è adatto il servizio?",
  "text3695": "Come va?",
  "text3696": "Visualizza un altro servizio",
  "text3697": "Cosa dicono i nostri clienti soddisfatti",
  "text3698": "E-mail di registrazione",
  "text3699": "Compila il modulo e ricevi un'offerta",
  "text3700": "Cerca la spedizione",
  "text3701": "Scrivici un messaggio",
  "text3702": "Ricevi un'offerta",
  "text3703": "Esci",
  "text3704": "Sistema di fedeltà",
  "text3705": "L'indirizzo di consegna è lo stesso dell'indirizzo di fatturazione",
  "text3706": "Nome della persona da contattare",
  "text3707": "Cognome della persona da contattare",
  "text3708": "L'indirizzo email non può essere modificato, contatta il nostro supporto.",
  "text3709": "Consigli, tendenze e articoli pratici",
  "text3710": "Altri articoli che potrebbero interessarti",
  "text3711": "Operatore",
  "text3712": "Hai bisogno di un consiglio?\nContattaci e saremo felici di aiutarti.",
  "text3713": "Contatta il nostro supporto clienti oppure scrivici tramite il modulo di contatto e il nostro staff ti consiglierà.",
  "text3714": "La tua richiesta",
  "text3715": "Invia richiesta di modifica password",
  "text3716": "Articoli su ordinazione",
  "text3717": "Importo dell'ordine",
  "text3718": "è stato registrato. Aspettiamo il pagamento e, una volta accreditato sul nostro conto, procederemo con l'implementazione. Per favore controlla la tua email",
  "text3719": "Visualizza le posizioni disponibili",
  "text3720": "L'ultima offerta",
  "text3721": "Entra a far parte del nostro team",
  "text3722": "Compila il form e inviaci il tuo CV. Se il tuo profilo ci interessa e soddisfa le tue esigenze, ti contatteremo.",
  "text3723": "Inviaci il tuo CV",
  "text3724": "Luogo di carico",
  "text3725": "Destinazione di destinazione",
  "text3726": "Tipo di merce",
  "text3727": "Peso (circa)",
  "text3728": "Volume (m3)",
  "text3729": "Mostra percorso",
  "text3730": "Ordine completo",
  "text3731": "Variante",
  "text3732": "Inserisci il codice sconto",
  "text3733": "Utilizza punti",
  "text3734": "Numero di punti (inserire il numero intero)",
  "text3735": "Avvertenza: non è possibile modificare ulteriormente il cliente sulla fattura.",
  "text3736": "Voglio acquistare per un'azienda",
  "text3737": "L'indirizzo di consegna è diverso dall'indirizzo di fatturazione",
  "text3738": "Informazioni su fatturazione e consegna",
  "text3739": "Il tuo ordine è stato spedito",
  "text3740": "Abbiamo registrato il tuo ordine con il numero",
  "text3741": "consegneremo la conferma dell'ordine all'indirizzo e-mail inserito in fase di creazione dell'ordine.",
  "text3742": "Torna alla pagina principale",
  "text3743": "Prodotti cercati",
  "text3744": "elementi",
  "text3745": "Mostra tutte le ricerche",
  "text3746": "Confronto di prodotti",
  "text3747": "Nessun prodotto da confrontare. Aggiungi prodotti facendo clic sull'icona di confronto.",
  "text3748": "Peso",
  "text3749": "Varianti colore",
  "text3750": "Il tuo account è stato creato con successo",
  "text3751": "Registrazione qui",
  "text3752": "1 corso = 5 corsi di formazione",
  "text3753": "Iscrivendoti alla newsletter accetti",
  "text3754": "Leggi i nostri articoli pratici o lasciati ispirare dalle tendenze dei mobili in teak.",
  "text3755": "Visualizza l'offerta",
  "text3756": "Prodotti promozionali",
  "text3757": "Crea il tipo di carico",
  "text3758": "Modifica del tipo di carico",
  "text3759": "Elimina il tipo di carico",
  "text3760": "Creazione del carico",
  "text3761": "Regolazione del carico",
  "text3762": "Eliminazione del carico",
  "text3763": "Creazione del pagamento della prenotazione",
  "text3764": "Modifica del pagamento della prenotazione",
  "text3765": "Eliminazione del pagamento della prenotazione",
  "text3766": "Informazioni sull'alloggio",
  "text3767": "I tuoi dati sono al sicuro",
  "text3768": "Partecipa più di",
  "text3769": "clienti soddisfatti",
  "text3770": "Verificato e ottenuto da Google",
  "text3771": "Orari di apertura dello showroom",
  "text3772": "Acquistando questo prodotto, riceverai",
  "text3773": "punti",
  "text3774": "Hai sul tuo account",
  "text3775": "Descrivi il prodotto",
  "text3776": "(+) Positivo",
  "text3777": "(-) Negativo",
  "text3778": "Aggiungi positivo",
  "text3779": "Aggiungi negativo",
  "text3780": "L'elemento padre non può essere questo elemento o il suo elemento figlio.",
  "text3781": "La partita IVA non è valida",
  "text3782": "La partita IVA inserita non è valida",
  "text3783": "Hai {{param}} punti",
  "text3784": "Sistema di prenotazione",
  "text3785": "Puoi applicare max.",
  "text3786": "Punti riscattati",
  "text3787": "Affitto monolocale",
  "text3788": "Numero di punti",
  "text3789": "La vendita è terminata",
  "text3790": "Stiamo attualmente preparando questo prodotto",
  "text3791": "Voglio un preventivo",
  "text3792": "Offerta di prezzo entro 24 ore",
  "text3793": "Hai bisogno di un preventivo per il tuo progetto? Rispondiamo entro 24 ore",
  "text3794": "Saldatura professionale e lavorazione dei metalli a livello professionale",
  "text3795": "Il nostro team è pronto per avviare immediatamente il progetto. Contattaci oggi.",
  "text3796": "o chiamaci",
  "text3797": "Compila il modulo di richiesta e ti ricontatteremo al più presto per discutere nel dettaglio il tuo progetto.",
  "text3798": "Le nostre ultime realizzazioni",
  "text3799": "Operiamo in tutta Europa",
  "text3800": "Cosa possiamo offrire ai nostri partner?",
  "text3801": "Visualizza posizioni lavorative",
  "text3802": "A quale servizio sei interessato?",
  "text3803": "Seleziona un servizio dall'elenco",
  "text3804": "Data di consegna richiesta",
  "text3805": "Documentazione del progetto",
  "text3806": "Allega file",
  "text3807": "Inviando il messaggio acconsenti al trattamento dei dati personali per finalità di contatto.",
  "text3808": "Al momento non offriamo alcuna posizione aperta",
  "text3809": "Nessun riferimento trovato in questa categoria.",
  "text3810": "Elimina file",
  "text3811": "Sulla base del modulo di preventivo compilato, ti contatterò al più presto possibile con una proposta di preventivo. Grazie per la pazienza.",
  "text3812": "Sono interessato ad un'offerta di lavoro",
  "text3813": "Servizi utilizzati",
  "text3814": "Passo",
  "text3815": "Realizziamo progetti all'interno dell'UE - principalmente in Germania, Austria, Repubblica Ceca e Slovacchia, ma anche in altri paesi a seconda delle esigenze del cliente.",
  "text3816": "Richiedi un preventivo per il tuo progetto oggi stesso!",
  "text3817": "Inizio dei lavori",
  "text3818": "Tipo di occupazione",
  "text3819": "Stipendio (lordo)",
  "text3820": "Informazioni sull'implementazione",
  "text3821": "Ulteriori realizzazioni",
  "text3822": "Torna a tutti gli articoli",
  "text3823": "Altri articoli",
  "text3824": "Contenuto",
  "text3825": "Continua",
  "text3826": "o",
  "text3827": "Accesso non riuscito",
  "text3828": "Per la registrazione tramite account social è richiesto il consenso al trattamento dei dati personali.",
  "text3829": "L'accesso è riuscito",
  "text3830": "L'e-mail dall'account social non è verificata.",
  "text3831": "Non è possibile accedere all'account utente.",
  "text3832": "L'accesso tramite account social è scaduto.",
  "text3833": "Accesso tramite account social non riuscito.",
  "text3834": "Cerca medicinali, vitamine, cosmetici...",
  "text3835": "Link copiato negli appunti",
  "text3836": "Numero del pacco/Numero di tracciabilità...",
  "text3837": "Annulla qui",
  "text3838": "Potresti anche essere interessato.",
  "text3839": "Ulteriori informazioni sulla categoria",
  "text3840": "Account registrato",
  "text3841": "Reso della merce - recesso dal contratto",
  "text3842": "Riparazione della merce",
  "text3843": "",
  "text3844": "Filtra prodotti",
  "text3845": "Riepilogo invio",
  "text3846": "Accettazione",
  "text3847": "Cessazione",
  "text3848": "Nuovo reclamo n.:",
  "text3849": "Shopping sicuro",
  "text3850": "Ripristina",
  "text3851": "Leggi la descrizione completa",
  "text3852": "Contenuto della confezione",
  "text3853": "Per la registrazione ora ottieni:",
  "text3854": "Offerte gratuite",
  "text3855": "Offerte top gratuitamente",
  "text3856": "Corsi gratuiti",
  "text3857": "I migliori corsi gratis",
  "text3858": "Accesso gratuito ai CV",
  "text3859": "per il tuo abbonamento",
  "text3860": "è stato creato un codice di accesso alla flotta:",
  "text3861": "Puoi condividere questo codice con gli utenti per aderire al tuo abbonamento.",
  "text3862": "Numero massimo di membri:",
  "text3863": "Codice abbonamento flotta",
  "text3864": "Per inviare un'altra segnalazione di arresto anomalo è necessario un abbonamento attivo.",
  "text3865": "Conferma annullamento",
  "text3866": "recesso dal contratto n.:",
  "text3867": "cambio merce n.:",
  "text3868": "reclamo n.:",
  "text3869": "scambio di merci",
  "text3870": "recesso dal contratto",
  "text3871": "reclamo",
  "text3872": "1750+ parti originali in stock",
  "text3873": "Che parte stai cercando?",
  "text3874": "Trova il negozio più vicino",
  "text3875": "Apri catalogo",
  "text3876": "Mostra tutto",
  "text3877": "Pezzi di ricambio",
  "text3878": "Recensioni dei clienti",
  "text3879": "È necessario effettuare l'accesso per aggiungere una recensione del prodotto",
  "text3880": "Codice sconto",
  "text3881": "Inserisci il codice",
  "text3882": "Riepilogo dell'ordine",
  "text3883": "Procedi a Spedizione e pagamento",
  "text3884": "Continua ai dettagli di consegna",
  "text3885": "Continua al riepilogo dell'ordine",
  "text3886": "Nota ordine",
  "text3887": "Ordine confermato!",
  "text3888": "Grazie per il tuo acquisto",
  "text3889": "Abbiamo inviato la conferma a",
  "text3890": "Qual è il prossimo passo?",
  "text3891": "Ordine elaborato",
  "text3892": "Il tuo pagamento è andato a buon fine.",
  "text3893": "Preparazione del pacchetto",
  "text3894": "Il magazzino sta preparando il tuo ordine",
  "text3895": "Consegna al vettore",
  "text3896": "Il corriere prenderà in consegna il pacco per la consegna.",
  "text3897": "Consegna",
  "text3898": "Verrai ricontattato",
  "text3899": "Orari di apertura",
  "text3900": "Spedizioni e magazzino",
  "text3901": "Portatori",
  "text3902": "Prodotti della collezione",
  "text3903": "Non ci sono prodotti in questa collezione",
  "text3904": "Mostra altri articoli",
  "text3905": "Calcolatore dei prezzi",
  "text3906": "Sono interessato alla revisione",
  "text3907": "Sono interessato a un'offerta",
  "text3908": "Ordina una consulenza gratuita",
  "text3909": "Invia una richiesta di offerta",
  "text3910": "Visualizza dettagli",
  "text3911": "Mostra altre 5 domande",
  "text3912": "Inizia oggi",
  "text3913": "Richiedi un preventivo non vincolante per un impianto di trattamento delle acque reflue",
  "text3914": "Preferisci chiamare?",
  "text3915": "Lun-ven, dalle 8:00 alle 17:00",
  "text3916": "Sono vicino ad un ruscello",
  "text3917": "Quante persone utilizzeranno l'impianto di trattamento?",
  "text3918": "Ho un terreno in pendenza",
  "text3919": "Confronto dei costi",
  "text3920": "Perché un impianto di trattamento delle acque reflue radicali vale più di una fossa settica e di un impianto di trattamento di attivazione",
  "text3921": "Costi operativi annuali",
  "text3922": "Costo totale in 10 anni",
  "text3923": "Funzionamento senza preoccupazioni",
  "text3924": "Dall'ordine al lancio",
  "text3925": "Come è l'installazione dell'impianto di trattamento delle acque reflue",
  "text3926": "Pretrattamento meccanico in fossa settica",
  "text3927": "Pulizia biologica con batteri",
  "text3928": "Filtrazione delle radici da parte delle piante",
  "text3929": "Processo naturale in 4 passaggi",
  "text3930": "Come funziona un impianto di depurazione delle acque reflue radicali",
  "text3931": "Guida dettagliata",
  "text3932": "Depuratori delle acque reflue per case familiari in Slovacchia",
  "text3933": "Perché scegliere ECOPLANET SLOVAKIA",
  "text3934": "Guida completa",
  "text3935": "Depuratore acque reflue ECOKOCKA",
  "text3936": "su richiesta",
  "text3937": "costo individuale",
  "text3938": "Risposte alle tue domande",
  "text3939": "Domande frequenti sugli impianti di trattamento delle acque reflue",
  "text3940": "La tua sicurezza",
  "text3941": "Perché affidarsi a ECOPLANET SLOVAKIA",
  "text3942": "Informazioni pratiche",
  "text3943": "Cosa dovresti sapere prima di acquistare un impianto di trattamento delle acque reflue",
  "text3944": "Esperienze reali",
  "text3945": "Cosa dicono i nostri clienti",
  "text3946": "Recensione Google",
  "text3947": "Scorri con le frecce per ulteriori recensioni",
  "text3948": "Tutta la Slovacchia",
  "text3949": "Installiamo depuratori delle acque reflue in tutta la Slovacchia",
  "text3950": "famiglie",
  "text3951": "in tutta la Slovacchia",
  "text3952": "comuni e pensioni",
  "text3953": "Domande più frequenti",
  "text3954": "Nome della pagina",
  "text3955": "Persone di contatto",
  "text3956": "Indirizzo di contatto",
  "text3957": "Date e prezzi",
  "text3958": "Descrizione del tour",
  "text3959": "Video",
  "text3960": "Gira",
  "text3961": "Numero di giorni/notti",
  "text3962": "Riservato",
  "text3963": "Stato sconosciuto",
  "text3964": "Il prezzo include",
  "text3965": "Il prezzo non include",
  "text3966": "Tutti i tour",
  "text3967": "Prenota un appuntamento",
  "text3968": "Prenotazione della riunione",
  "text3969": "Iscriviti alla newsletter",
  "text3970": "Sii il primo a sapere di cacca, date e sconti.",
  "text3971": "Con l'invio acconsenti al trattamento dei dati personali.",
  "text3972": "Panoramica dei termini",
  "text3973": "Visualizza il programma",
  "text3974": "Tour simili",
  "text3975": "Fatto",
  "text3976": "Tutte le date hanno già avuto luogo",
  "text3977": "Leggi gli articoli su Madeira!",
  "text3978": "Prenotazione non vincolante",
  "text3979": "Prenotazione del tour non vincolante",
  "text3980": "Prenotazione non vincolante",
  "text3981": "Inserisci il tuo numero di telefono. numero",
  "text3982": "Aggiungi un altro partecipante",
  "text3983": "Elimina partecipante",
  "text3984": "Tipo di incontro",
  "text3985": "Città degli incontri",
  "text3986": "Data e ora",
  "text3987": "Avanti",
  "text3988": "Invio in corso...",
  "text3989": "Conferma la prenotazione",
  "text3990": "Seleziona un luogo di incontro",
  "text3991": "Luogo d'incontro",
  "text3992": "Iscriviti alla newsletter e ricevi sempre le informazioni più aggiornate sulla nostra offerta.",
  "text3993": "Dove puoi trovarci?",
  "text3994": "Cosa rende speciale la nostra agenzia di viaggi SCOPRI IL MONDO?",
  "text3995": "Ufficio (operazione)",
  "text3996": "palazzina INFORMATIKA al 2° piano",
  "text3997": "Grazie per la prenotazione!...",
  "text3998": "Tour più vicini",
  "text3999": "Compila i dettagli di contatto e il budget approssimativo.",
  "text4000": "Chiedo come",
  "text4001": "6.000 e oltre",
  "text4002": "Cosa dobbiamo preparare per te?",
  "text4003": "La richiesta è stata inviata",
  "text4004": "Grazie. Dopo l'elaborazione, ti invieremo un preventivo via e-mail.",
  "text4005": "Numero della richiesta",
  "text4006": "Invia un'altra richiesta",
  "text4007": "Il budget massimo deve essere superiore al minimo.",
  "text4008": "Controlla i campi contrassegnati.",
  "text4009": "Hai inviato troppe richieste. Per favore riprova tra poco.",
  "text4010": "",
  "text4011": "",
  "text4012": "",
  "text4013": "",
  "text4014": "",
  "text4015": "",
  "text4016": "",
  "text4017": "",
  "text4018": "",
  "text4019": "",
  "text4020": "",
  "text4021": "",
  "text4022": "",
  "text4023": "",
  "text4024": "",
  "text4025": "",
  "text4026": "",
  "text4027": "",
  "text4028": "",
  "text4029": "",
  "text4030": "",
  "text4031": "",
  "text4032": "",
  "text4033": "",
  "text4034": "",
  "text4035": "",
  "text4036": "",
  "text4037": "",
  "text4038": "",
  "text4039": "",
  "text4040": "",
  "text4041": "",
  "text4042": "",
  "text4043": "",
  "text4044": "",
  "text4045": "",
  "text4046": "",
  "text4047": "",
  "text4048": "",
  "text4049": "",
  "text4050": "",
  "text4051": "",
  "text4052": "Questi sono i dati della vostra azienda?",
  "text4053": "",
  "text4054": "Rimuovi coupon",
  "text4055": "Inattivo",
  "text4056": "Assicurato",
  "text4057": "Non assicurato",
  "text4058": "Aggiungi veicolo",
  "text4059": "Modifica veicolo",
  "text4060": "Eliminare il veicolo?",
  "text4061": "Il mio garage",
  "text4062": "Data della revisione e del controllo emissioni",
  "text4063": "Esportazione non riuscita. Riprova.",
  "text4064": "Metti in pausa il video",
  "text4065": "Materiale",
  "text4066": "Nuova configurazione",
  "text4067": "Passaggi di configurazione",
  "text4068": "Carica un file",
  "text4069": "Prenota un appuntamento",
  "text4070": "Impossibile copiare il link",
  "text4071": "Dati aggiornati correttamente",
  "text4072": "Aggiungi al confronto",
  "text4073": "Rimuovi dal confronto",
  "text4074": "Torna all’elenco",
  "text4075": "Regione",
  "text4076": "Cataloghi",
  "text4077": "La mia flotta",
  "text4078": "Riepilogo dei danni",
  "text4079": "Targa",
  "text4080": "Data e ora di partenza",
  "text4081": "Data e ora di arrivo",
  "text4082": "Numero del biglietto",
  "text4083": "Numero di passaporto",
  "text4084": "Torna ai parametri",
  "text4085": "Riepilogo e contatti",
  "text4086": "La configurazione è stata inviata",
  "text4087": "Retribuzione minima",
  "text4088": "Retribuzione massima",
  "text4089": "Riepilogo della configurazione",
  "text4090": "Aggiornato:",
  "text4091": "E-mail di contatto *",
  "text4092": "Caricamento delle configurazioni...",
  "text4093": "Applica codice",
  "text4094": "Nota (facoltativa)...",
  "text4095": "Configurazioni in corso",
  "text4096": "Non ci sono ancora prodotti",
  "text4097": "Impossibile caricare la configurazione",
  "text4098": "Impossibile inviare la configurazione",
  "text4099": "Impossibile aprire la configurazione",
  "text4100": "Impossibile salvare la configurazione",
  "text4101": "Carica dal registro",
  "text4102": "Prezzo stimato",
  "text4103": "Inviato",
  "text4104": "Preventivi inviati",
  "text4105": "Invieremo il preventivo via e-mail",
  "text4106": "ai fini dell'emissione di un preventivo ai sensi del GDPR.",
  "text4107": "Aggiungi una domanda sul prodotto",
  "text4108": "",
  "text4109": "",
  "text4110": "",
  "text4111": "",
  "text4112": "",
  "text4113": "",
  "text4114": "",
  "text4115": "",
  "text4116": "",
  "text4117": "",
  "text4118": "",
  "text4119": "",
  "text4120": "",
  "text4121": "",
  "text4122": "",
  "text4123": "",
  "text4124": "",
  "text4125": "",
  "text4126": "",
  "text4127": "",
  "text4128": "",
  "text4129": "",
  "text4130": "",
  "text4131": "",
  "text4132": "",
  "text4133": "",
  "text4134": "",
  "text4135": "",
  "text4136": "",
  "text4137": "",
  "text4138": "",
  "text4139": "",
  "text4140": "",
  "text4141": "",
  "text4142": "",
  "text4143": "",
  "text4144": "",
  "text4145": "",
  "text4146": "",
  "text4147": "",
  "text4148": "",
  "text4149": "",
  "text4150": ""
}) satisfies TranslationDictionary;
